export const pt = {
  common: {
    loading: 'Carregando...',
    save: 'Salvar',
    cancel: 'Cancelar',
    edit: 'Editar',
    delete: 'Excluir',
    confirmDeleteProject: 'Confirma exclusão do projeto?',
    back: 'Voltar',
    retry: 'Tentar novamente',
    you: 'você',
    close: 'Fechar',
    refresh: 'Recarregar',
    dateFormatPlaceholder: 'dd/mm/aaaa',
  },
  deleteDialog: {
    cancel: 'Cancelar',
    archive: 'Arquivar',
    hardDelete: 'Excluir permanentemente',
    loading: 'Verificando vínculos…',
    irreversible: 'Esta ação não pode ser desfeita.',
    subtreeNote: 'Também serão removidos: {phases} etapa(s) e {activities} atividade(s) sem uso.',
    blockedIntro: 'Este item só pode ser arquivado porque está vinculado a outros registros:',
    /** Project entities (and any surface without archive) — do not mention Arquivar. */
    blockedIntroNoArchive: 'Não é possível remover este item porque está vinculado a outros registros:',
    blockers: {
      projectService: '{count} projeto(s)',
      projectItemService: '{count} ambiente(s)',
      projectItemProject: '{count} projeto(s) usando este ambiente',
      projectItemTemplate: '{count} modelo(s) usando este ambiente',
      template: '{count} modelo(s)',
      projectPhase: '{count} etapa(s) de projeto',
      projectItemPhase: '{count} etapa(s) de ambiente',
      timeEntry: '{count} lançamento(s) de horas',
      currentPhase: 'É a etapa atual do serviço no projeto',
      lastService: 'É o único serviço do projeto',
    },
  },
  auth: {
    login: {
      title: 'Entrar',
      subtitle: 'Bem-vindo de volta. Informe suas credenciais para continuar.',
      email: 'E-mail',
      password: 'Senha',
      submit: 'Entrar',
      submitting: 'Entrando...',
      brandName: 'ArqManager',
      brandTitle: 'Gerencie seus projetos de arquitetura com confiança.',
      brandSubtitle: 'Acompanhe projetos, etapas e equipes em um só painel.',
      brandFooter: '© 2026 ArqManager',
    },
    setup: {
      title: 'Definir senha',
      subtitle: 'Crie uma senha para ativar sua conta',
      password: 'Nova senha',
      confirm: 'Confirmar senha',
      submit: 'Salvar senha',
      submitting: 'Salvando...',
      success: 'Senha definida. Você já pode entrar.',
      invalidToken: 'Este link é inválido ou expirou. Peça a um administrador para gerar um novo.',
      usedToken: 'Este link já foi utilizado.',
    },
    invite: {
      linkTitle: 'Link de definição de senha',
      linkHelp: 'Copie e envie este link para o usuário definir a senha.',
      copy: 'Copiar link',
      copied: 'Link copiado',
      copyError: 'Não foi possível copiar. Copie o link manualmente.',
    },
    errors: {
      invalidCredentials: 'E-mail ou senha inválidos.',
      generic: 'Não foi possível entrar. Tente novamente.',
    },
    logout: 'Sair',
    oauth: {
      title: 'Conectar {client}',
      subtitle: '{client} quer acessar o ArqManager em seu nome.',
      signedInAs: 'Você está conectado como {user}.',
      access: 'O aplicativo poderá ler e alterar dados com as mesmas permissões que você tem.',
      redirectsTo: 'Depois de autorizar, você volta para {host}.',
      selfAssertedName: 'O nome acima foi informado pelo próprio aplicativo. Só autorize se reconhecer o endereço.',
      localWarning: 'Este aplicativo roda no seu computador. Autorize apenas se você acabou de iniciar esta conexão.',
      approve: 'Autorizar',
      approving: 'Autorizando...',
      deny: 'Cancelar',
      errorTitle: 'Não foi possível conectar',
      errors: {
        invalidClient: 'Aplicativo desconhecido. Remova a conexão no aplicativo e adicione-a novamente.',
        invalidRedirect: 'O endereço de retorno deste aplicativo não é permitido.',
        noPermission: 'Você não tem permissão para conectar aplicativos. Fale com um administrador.',
        sessionExpired: 'Sua sessão expirou. Recarregue a página e entre novamente.',
        generic: 'Não foi possível concluir a autorização. Tente novamente.',
      },
    },
    noAccess: {
      title: 'Sem acesso',
      message: 'Você não tem permissão para acessar esta página. Fale com um administrador.',
    },
  },
  horas: {
    bannerTitle: 'Horas de Atividades',
    bannerSubtitle: 'Registre e revise seu tempo',
    statThisMonth: 'Este mês',
    statEntries: 'Registros',
    prevMonth: 'Mês anterior',
    nextMonth: 'Próximo mês',
    logTitle: 'Registrar horas',
    editTitle: 'Editar registro',
    addEntry: 'Adicionar registro',
    updateEntry: 'Atualizar registro',
    cancel: 'Cancelar',
    modeLabel: 'Tipo de lançamento',
    modeProject: 'Projeto',
    modeAdmin: 'Administrativo',
    fields: {
      project: 'Projeto',
      service: 'Serviço',
      phase: 'Etapa',
      subphase: 'Subetapa',
      date: 'Data',
      hours: 'Horas',
      minutes: 'Minutos',
      description: 'Descrição',
      activity: 'Atividade',
      descriptionOptional: 'Descrição (opcional)',
      adminCategory: 'Categoria',
      adminActivity: 'Atividade',
    },
    descriptionPlaceholder: 'No que você trabalhou?',
    projectPlaceholder: 'Selecionar projeto…',
    projectSearchPlaceholder: 'Buscar projeto…',
    projectEmpty: 'Nenhum projeto encontrado',
    servicePlaceholder: 'Selecionar serviço…',
    serviceSearchPlaceholder: 'Buscar serviço…',
    serviceEmpty: 'Nenhum serviço encontrado',
    activityPlaceholder: 'Selecionar atividade…',
    activitySearchPlaceholder: 'Buscar…',
    activityEmpty: 'Nenhuma atividade encontrada',
    subphaseNone: '— Etapa principal —',
    minutesRange: 'Minutos devem estar entre 0 e 59',
    noProjects: 'Nenhum projeto com etapas disponível.',
    entriesCount: '{count} registros',
    totalHours: '{hours} no total',
    week: 'Semana {n}',
    empty: 'Nenhum registro neste mês ainda. Registre suas primeiras horas.',
    toastAdded: 'Registro adicionado',
    toastUpdated: 'Registro atualizado',
    toastError: 'Não foi possível salvar o registro.',
    toastLateBlocked: 'Lançamento fora do prazo. Você não tem permissão para registrar horas nessa data.',
    lateBlockedTitle: 'Lançamento bloqueado',
    lateBlockedDismiss: 'Entendi',
    loadError: 'Não foi possível carregar os registros.',
    loggedAt: 'Registrado em {at}',
    lateBadge: 'Registrado com atraso',
    deleteConfirm: 'Excluir?',
    logHours: 'Lançar horas',
    logAsUser: 'Registrar para',
    loggedBy: 'por {name}',
    confirmPhase: {
      title: 'Confirmar etapa',
      message: 'A etapa atual do serviço {service} em {project} é {current}. Tem certeza de que deseja lançar estas horas em {selected}?',
      confirm: 'Sim, lançar',
      cancel: 'Cancelar',
    },
    moveEntries: {
      title: 'Mover lançamentos',
      description: 'Mover todos os lançamentos de "{name}" ({count} · {hours}) para outra atividade.',
      descriptionWithService: 'Mover todos os lançamentos de "{service} · {name}" ({count} · {hours}) para outra atividade.',
      descriptionUnassigned: 'Mover todos os lançamentos sem atividade da etapa "{name}" ({count} · {hours}) para uma atividade.',
      descriptionUnassignedWithService: 'Mover todos os lançamentos sem atividade da etapa "{service} · {name}" ({count} · {hours}) para uma atividade.',
      entriesLabel: 'Lançamentos sem atividade',
      noDescription: 'Sem descrição',
      destination: 'Atividade de destino',
      searchPlaceholder: 'Buscar atividade…',
      confirm: 'Mover',
      cancel: 'Cancelar',
      emptyDestinations: 'Nenhuma atividade de destino disponível.',
      loadError: 'Não foi possível carregar os destinos.',
      moveError: 'Não foi possível mover os lançamentos.',
      success: '{count} lançamentos movidos ({hours}).',
      noEntries: 'Esta atividade não tem lançamentos.',
      action: 'Mover lançamentos',
      provisionTitle: 'Estrutura que será criada nos projetos:',
      provisionAttach: '{project}: incluir serviço {service}',
      provisionBackfill: '{project}: completar etapas de {service}',
    },
  },
  ponto: {
    bannerTitle: 'Horas',
    bannerSubtitle: 'Registre sua jornada e acompanhe o saldo do mês',
    teamBannerTitle: 'Resumo da Equipe',
    teamBannerSubtitle: 'Horas trabalhadas e pendências de cada pessoa',
    prevMonth: 'Mês anterior',
    nextMonth: 'Próximo mês',
    statBalance: 'Saldo do mês',
    statWorked: 'Horas trabalhadas',
    statPending: 'Pendências',
    statForecast: 'Previsão de horas',
    statForecastHelp: 'Horas já registradas neste mês, somadas à carga esperada dos dias úteis restantes (feriados e fins de semana não contam), considerando sua jornada contratual.',
    statForecastValue: 'Previsão de valor',
    statForecastValueHelp: 'Previsão de horas do mês multiplicada pelo seu valor de hora contratado.',
    empty: 'Nenhum turno registrado neste mês ainda. Registre seu primeiro turno.',
    logTitle: 'Registrar turno',
    editTitle: 'Editar turno',
    addShift: 'Registrar turno',
    updateShift: 'Atualizar turno',
    cancel: 'Cancelar',
    logAsUser: 'Registrar para',
    fields: {
      date: 'Data',
      start: 'Entrada',
      end: 'Saída',
      mode: 'Modelo',
      note: 'Observação',
    },
    modeLabel: 'Modelo',
    modeNotInformed: 'Não informado',
    statusOpen: 'Em curso',
    pendingRegistration: 'Pendência de registro',
    pendingClosure: 'Pendência de fechamento',
    loadUndefined: 'Carga indefinida',
    loadUndefinedHint: 'Carga não definida para este dia (sem vínculo vigente).',
    dayType: {
      saturday: 'Sábado',
      sunday: 'Domingo',
      holiday: 'Feriado',
    },
    payrollSuppressed: 'O saldo aparece apenas para quem tem acesso à folha.',
    lateBadge: 'Registrado com atraso',
    loggedAt: 'Registrado em {at}',
    loggedBy: 'por {name}',
    deleteConfirm: 'Excluir turno?',
    deleteConfirmNoteWarning: 'A observação deste dia será perdida.',
    fourthShiftWarning: 'Este dia já tem mais de 3 turnos registrados.',
    filterOutOfLoad: 'Fora da carga',
    toastAdded: 'Turno registrado',
    toastUpdated: 'Turno atualizado',
    toastError: 'Não foi possível salvar o turno.',
    loadError: 'Não foi possível carregar os turnos.',
    excludedDaysCount_one: '{count} dia excluído do saldo por falta de vínculo vigente',
    excludedDaysCount_other: '{count} dias excluídos do saldo por falta de vínculo vigente',
    table: {
      colDay: 'Dia',
      colShift: '{n}º turno',
      colTotal: 'Total',
      colLoad: 'Carga',
      colBalance: 'Saldo',
      colMode: 'Modelo',
      colNote: 'Observação',
      noteDisabledHint: 'Registre um turno para adicionar uma observação',
      modeAbsenceOnlyHint: 'Sem turno registrado, só é possível selecionar um modelo de ausência.',
      modeAbsenceBlockedHint: 'Exclua os turnos deste dia para selecionar um modelo de ausência.',
      modeRequiredHint: 'Selecione um modelo para este dia.',
    },
    card: {
      today: 'Hoje · {date}',
      open: 'Registro aberto',
      closed: 'Registro fechado',
      workedOf: '{worked} de {expected}',
      remaining: 'faltam {remaining}',
      punchIn: 'Registrar entrada',
      punchOut: 'Registrar saída',
    },
    team: {
      colName: 'Pessoa',
      colWorked: 'Horas trabalhadas',
      colPendingRegistration: 'Pendências de registro',
      colPendingClosure: 'Pendências de fechamento',
      colLoad: 'Carga esperada',
      colBalance: 'Saldo do mês',
      payrollSuppressed: 'Carga e saldo aparecem apenas para quem tem acesso à folha.',
      empty: 'Nenhuma pessoa ativa encontrada.',
      loadError: 'Não foi possível carregar os dados da equipe.',
      viewDetails: 'Ver detalhes',
      detailsEmpty: 'Nenhum turno registrado neste mês.',
      detailsLoadError: 'Não foi possível carregar os turnos desta pessoa.',
    },
    export: {
      action: 'Exportar PDF',
      pdf: {
        docTitle: 'Registro de horas',
        pageTitle: 'REGISTRO DE HORAS',
        collaboratorLabel: 'NOME',
        jobRoleLabel: 'ATIVIDADE',
        periodLabel: 'PERÍODO',
        notInformed: '—',
        statWorked: 'TOTAL DE HORAS',
        statExpected: 'HORAS PREVISTAS',
        statBalance: 'SALDO DO MÊS',
        statWorkedDays: 'DIAS COM REGISTRO',
        colDay: 'DIA',
        colWeekday: 'SEM.',
        colEntry: 'ENTRADA',
        colExit: 'SAÍDA',
        colMode: 'MODELO',
        colTotal: 'TOTAL',
        colObservation: 'OBSERVAÇÃO',
        totalRowLabel: 'Total do mês',
        pendingStatus: 'pendente',
        pendingClosureNote_one: 'Registro com saída pendente no dia {days} não entra no total até ser concluído.',
        pendingClosureNote_other: 'Registros com saída pendente nos dias {days} não entram no total até serem concluídos.',
      },
    },
  },
  activities: {
    title: 'Atividades',
    subtitle: 'Todas as atividades dos projetos em andamento e seus responsáveis.',
    searchPlaceholder: 'Buscar atividade, projeto ou cliente',
    searchLabel: 'Buscar atividades',
    projectFilter: 'Projeto',
    projectAll: 'Todos os projetos',
    projectSearch: 'Buscar projeto',
    projectEmpty: 'Nenhum projeto encontrado',
    mineOnly: 'Atribuídas a mim',
    assigneeFilter: 'Responsável',
    assigneeAll: 'Todos os responsáveis',
    assigneeSearch: 'Buscar responsável',
    assigneeEmpty: 'Nenhum responsável encontrado',
    statusAll: 'Todas',
    statusFilter: 'Filtrar por situação',
    summaryShown_one: '{count} atividade',
    summaryShown_other: '{count} atividades',
    summaryPending_one: '{count} pendente',
    summaryPending_other: '{count} pendentes',
    summaryLogged: '{hours} lançadas',
    empty: 'Nenhuma atividade encontrada com os filtros atuais.',
    loadError: 'Não foi possível carregar as atividades',
    pageOf: 'Página {current} de {total}',
    perPage: 'Por página',
    prevPage: 'Página anterior',
    nextPage: 'Próxima página',
    statusChip: 'Situação da atividade',
    statusError: 'Não foi possível alterar a situação',
    statusForbidden: 'Você não pode alterar a situação desta atividade',
    hoursOf: '{logged} de {planned}',
    hoursNoBudget: '{logged} lançadas',
    select: 'Abrir atividade',
    back: 'Voltar para a lista',
    panel: {
      emptyTitle: 'Nenhuma atividade selecionada',
      emptyHint: 'Escolha uma atividade na lista para ver os detalhes.',
      situation: 'Situação',
      responsible: 'Responsável',
      progress: 'Progresso',
      progressOf: '{logged} de {planned}',
      progressNoBudget: '{logged} lançadas',
      logTitle: 'Lançar horas',
      logDate: 'Data',
      logHours: 'Horas',
      logMinutes: 'Minutos',
      logDescription: 'Observação',
      logSubmit: 'Lançar',
      logError: 'Não foi possível lançar as horas',
      logInvalid: 'Informe uma quantidade de horas maior que zero',
      entriesTitle: 'Lançamentos',
      entriesEmpty: 'Nenhum lançamento nesta atividade.',
      entriesError: 'Não foi possível carregar os lançamentos',
    },
  },
  teamHours: {
    bannerTitle: 'Horas da equipe',
    bannerSubtitle: 'Horas registradas por toda a equipe — filtre por membro, projeto ou atividade',
    filters: 'Filtros',
    allMembers: 'Todos os membros',
    allProjects: 'Todos os projetos',
    scopeAll: 'Todo o escopo',
    scopeSearchPlaceholder: 'Buscar serviço, etapa ou atividade…',
    scopeEmpty: 'Nada encontrado',
    scopeExpand: 'Expandir',
    scopeCollapse: 'Recolher',
    memberSearchPlaceholder: 'Buscar membro…',
    memberInactiveHint: '{role} · Inativo',
    projectSearchPlaceholder: 'Buscar projeto…',
    memberEmpty: 'Nenhum membro encontrado',
    projectEmpty: 'Nenhum projeto encontrado',
    allItems: 'Todos os ambientes',
    itemSearchPlaceholder: 'Buscar ambiente…',
    itemEmpty: 'Nenhum ambiente encontrado',
    nMoreSelected: '+{n}',
    clearFilters: 'Limpar filtros',
    periodWeek: 'Esta semana',
    periodMonth: 'Este mês',
    periodAll: 'Tudo',
    periodCustom: 'Personalizado',
    customTitle: 'Período personalizado',
    from: 'De',
    to: 'Até',
    apply: 'Aplicar',
    cancel: 'Cancelar',
    kpiTotal: 'Total registrado',
    kpiTotalSub: '{count} registros',
    kpiMembers: 'Membros lançando',
    kpiMembersValue: '{active} de {total}',
    kpiMembersAll: 'Todos lançaram horas',
    kpiMembersMissing: '{count} sem registros',
    kpiAvg: 'Média por membro',
    kpiAvgSub: 'entre membros com registros',
    kpiTopProject: 'Projeto com mais horas',
    kpiTopProjectSub: '{hours} registradas',
    kpiTopProjectEmpty: 'Sem horas no período',
    chartByMember: 'Horas por membro',
    chartByProject: 'Horas por projeto',
    clickToFilter: 'clique para filtrar',
    unassigned: 'Sem atividade',
    phasesCount: '{count} etapas',
    entries: 'Registros',
    entriesSummaryOne: '{count} registro · {hours}',
    entriesSummaryOther: '{count} registros · {hours}',
    colDate: 'Data',
    colMember: 'Membro',
    colProject: 'Projeto',
    colActivity: 'Etapa › Atividade',
    colDescription: 'Descrição',
    colHours: 'Horas',
    emptyEntries: 'Nenhum registro corresponde a estes filtros.',
    emptyEntriesTryAll: 'Nenhum registro para estes filtros no período selecionado. Experimente o período "Tudo".',
    loading: 'Carregando…',
    loadError: 'Não foi possível carregar os registros.',
    removeFilter: 'Remover filtro',
    perPage: 'Por página',
    pageOf: 'Página {current} de {total}',
    prevPage: 'Página anterior',
    nextPage: 'Próxima página',
    editEntry: 'Editar registro de {name} em {date}',
    editPanelTitle: 'Hora de {name}',
    editLoadError: 'Não foi possível abrir este registro.',
  },
  teamPayroll: {
    bannerTitle: 'Resumo financeiro da equipe',
    bannerSubtitle: 'Total a pagar por colaborador, recalculado a partir do registro de horas, da folha e dos lançamentos do mês',
    prevMonth: 'Mês anterior',
    nextMonth: 'Próximo mês',
    loadError: 'Não foi possível carregar o resumo financeiro.',
    retry: 'Tentar novamente',
    header: {
      title: 'Resumo do mês',
      scopeNote: 'Considera todos os colaboradores elegíveis do mês, independente dos filtros aplicados na tabela.',
      members: 'Colaboradores',
      workingDays: 'Dias úteis',
      previsto: 'Previsto',
      previstoCaption: 'Carga contratual do mês',
      proventos: 'Proventos',
      proventosCaption: 'Inclui valor base a pagar, VR e VT',
      descontos: 'Descontos',
      descontosCaption: 'Inclui VR e VT quando adiantados',
      adiantamentos: 'Adiantamentos',
      reembolsos: 'Reembolsos',
      total: 'Total a pagar',
      totalCaption: 'Descontos aplicados, adiantamentos somados',
    },
    filters: {
      searchPlaceholder: 'Buscar colaborador…',
      jobRole: 'Cargo',
      allJobRoles: 'Todos os cargos',
      clear: 'Limpar filtros',
    },
    bands: {
      title: 'Bandas',
      previsto: 'Previsto',
      proventos: 'Proventos',
      descontos: 'Descontos',
      adiantamentos: 'Adiantamentos',
      reembolsos: 'Reembolsos',
    },
    columns: {
      name: 'Nome',
      jobRole: 'Cargo',
      previsto: 'Previsto',
      proventos: 'Proventos',
      descontos: 'Descontos',
      adiantamentos: 'Adiantamentos',
      reembolsos: 'Reembolsos',
      total: 'Total a pagar',
      totalsLabel: 'Totais',
    },
    viewMode: {
      label: 'Visão',
      resumo: 'Resumo',
      detalhado: 'Detalhado',
    },
    detailed: {
      subcolumns: {
        horas: 'Horas',
        remuneracao: 'Remuneração',
        valorVt: 'Valor VT',
        valorVr: 'Valor VR',
        qtdVt: 'Qtd VT',
        totalVt: 'Total VT',
        qtdVr: 'Qtd VR',
        totalVr: 'Total VR',
        diversos: 'Diversos',
        total: 'Total',
        vt: 'VT',
        vr: 'VR',
      },
    },
    emptyMonth: 'Nenhum colaborador com vínculo vigente neste mês.',
    emptyFilters: 'Nenhum colaborador corresponde aos filtros aplicados.',
    flags: {
      daysWithoutWindow_one: '{count} dia sem vínculo vigente no mês',
      daysWithoutWindow_other: '{count} dias sem vínculo vigente no mês',
      daysWithoutWindowWithPunch_one: '{count} dia sem vínculo no mês, {punchCount} com registro',
      daysWithoutWindowWithPunch_other: '{count} dias sem vínculo no mês, {punchCount} com registro',
      openShiftDays_one: '{count} turno em aberto no mês',
      openShiftDays_other: '{count} turnos em aberto no mês',
      incompletePayroll: 'Vínculo com dado de remuneração incompleto.',
    },
    details: {
      expand: 'Expandir detalhamento de {name}',
      collapse: 'Recolher detalhamento de {name}',
      hoursTitle: 'Horas',
      expectedHours: 'Horas previstas',
      workedHours: 'Horas realizadas',
      difference: 'Diferença',
      expectedHoursNote: 'Horas previstas consideram o mês civil inteiro — pode divergir do saldo em Resumo da Equipe, que considera apenas os dias até hoje.',
      compositionTitle: 'Composição do total a pagar',
      valorBase: 'Valor base a pagar',
      vr: 'VR',
      vt: 'VT',
      proventosDiversos: 'Proventos diversos',
      reembolsos: 'Reembolsos',
      proventos: 'Proventos',
      descontos: 'Descontos',
      adiantamentos: 'Adiantamentos',
      total: 'Total a pagar',
    },
    export: {
      action: 'Exportar CSV',
      actionXlsx: 'Exportar Excel',
      filename: 'resumo-financeiro-equipe',
      error: 'Não foi possível exportar o resumo financeiro.',
      xlsx: {
        summarySheet: 'Resumo',
        totalRowLabel: 'Totais',
        summaryColumns: {
          name: 'Nome',
          jobRole: 'Cargo',
          expectedHours: 'Horas previstas',
          previsto: 'Previsto',
          workedHours: 'Horas trabalhadas',
          valorBase: 'Remuneração',
          vtDays: 'Qtd VT',
          vt: 'VT',
          vrDays: 'Qtd VR',
          vr: 'VR',
          proventosDiversos: 'Proventos diversos',
          proventos: 'Total proventos',
          vtQtyDeducted: 'Qtd VT não utilizado',
          vtTotalDeducted: 'VT não utilizado',
          vrQtyDeducted: 'Qtd VR não utilizado',
          vrTotalDeducted: 'VR não utilizado',
          descontosDiversos: 'Descontos diversos',
          descontos: 'Total descontos',
          adiantamentosVt: 'Adiantamento VT',
          adiantamentosVr: 'Adiantamento VR',
          adiantamentos: 'Total adiantamentos',
          reembolsos: 'Reembolsos',
          total: 'Total a pagar',
        },
      },
      columns: {
        name: 'Nome',
        jobRole: 'Cargo',
        expectedHours: 'Horas previstas',
        workedHours: 'Horas realizadas',
        previsto: 'Previsto',
        valorBase: 'Valor base a pagar',
        vr: 'VR',
        vt: 'VT',
        reembolsos: 'Reembolsos',
        proventos: 'Proventos',
        descontos: 'Descontos',
        adiantamentos: 'Adiantamentos',
        total: 'Total a pagar',
      },
    },
    summaries: {
      action: 'Gerar resumos',
      error: 'Não foi possível gerar os resumos financeiros.',
      docTitle: 'Resumo financeiro',
      pageTitle: 'RESUMO FINANCEIRO',
      generatedAt: 'Documento gerado em {at}',
      filename: 'resumos-financeiros',
      nameLabel: 'NOME',
      periodLabel: 'PERÍODO',
      remunerationTitle: 'RESUMO DA REMUNERAÇÃO',
      discountsTitle: 'Descontos',
      totalRemuneration: 'TOTAL REMUNERAÇÃO',
      reimbursementTitle: 'RESUMO REEMBOLSOS',
      totalReimbursement: 'TOTAL REEMBOLSO',
      totalToReceive: 'TOTAL A RECEBER',
      workedHoursLine: 'Horas Trabalhadas',
      vrLine: 'Vale Refeição {month}',
      vtLine: 'Vale Transporte {month}',
      vrAdvanceLine: 'Adiantamento Vale Refeição {month}',
      vtAdvanceLine: 'Adiantamento Vale Transporte {month}',
      vrUnusedLine: 'Vale Refeição não utilizado - {month}',
      vtUnusedLine: 'Vale Transporte não utilizado - {month}',
      reimbursementLine: 'Reembolso de Despesas ref. {month}',
      diversEarning: 'Provento diverso',
      diversDiscount: 'Desconto diverso',
      continuedLabel: '{name} · {period} (continuação)',
      disclaimer: 'Os valores foram recalculados na data de geração deste resumo e não estão congelados: uma nova geração pode trazer números diferentes se os dados de origem forem alterados.',
    },
    emptySelection: 'Nenhum colaborador selecionado.',
    rowActions: {
      menuLabel: 'Ações de {name}',
      downloadPdf: 'Baixar PDF individual',
      downloadError: 'Não foi possível baixar o PDF individual.',
    },
  },
  projectReport: {
    bannerTitle: 'Relatório de projetos',
    bannerSubtitle: 'Horas planejadas vs registradas em todos os projetos',
    donutComplete: 'CONCLUÍDO',
    statPlanned: 'Planejado',
    statLogged: 'Registrado',
    overBudgetOne: '{count} acima do orçamento',
    overBudgetOther: '{count} acima do orçamento',
    kpiPlanned: 'Total planejado',
    kpiPlannedSubOne: 'em {count} projeto',
    kpiPlannedSubOther: 'em {count} projetos',
    kpiLogged: 'Total registrado',
    kpiLoggedSub: '{pct}% do plano total',
    kpiRemaining: 'Saldo',
    kpiRemainingAll: 'Todas as horas registradas',
    kpiRemainingSub: '{pct}% ainda a registrar',
    kpiOverBudget: 'Acima do orçamento',
    kpiOverBudgetNone: 'Nenhum',
    kpiOverBudgetOk: 'Todos os projetos no prazo',
    comparisonTitle: 'Comparação de projetos',
    legendPlanned: 'Planejado',
    legendLogged: 'Registrado',
    legendOver: 'Acima do orçamento',
    sortLabel: 'Ordenar:',
    sortPct: '% usado',
    sortHours: 'Horas',
    sortName: 'Nome',
    phaseTitle: 'Detalhamento por etapa',
    colPhase: 'Etapa',
    colPlanned: 'Planejado',
    colLogged: 'Registrado',
    colProgress: 'Progresso',
    colPct: '%',
    summaryPhasesOne: '{count} etapa',
    summaryPhasesOther: '{count} etapas',
    summaryProjectsOne: '{count} projeto',
    summaryProjectsOther: '{count} projetos',
    summaryServicesOne: '{count} serviço',
    summaryServicesOther: '{count} serviços',
    summaryHint: 'clique em uma atividade para filtrar o relatório',
    expandAll: 'Expandir tudo',
    collapseAll: 'Recolher tudo',
    activitiesCountOne: '{count} atividade',
    activitiesCountOther: '{count} atividades',
    shareTitle: 'Parcela das horas registradas da etapa',
    unassigned: 'Sem atividade',
    removeFilter: 'Remover filtro',
  },
  settings: {
    bannerTitle: 'Configurações gerais',
    bannerSubtitle: 'Ajuste as configurações que afetam todo o sistema.',
    lateThreshold: {
      label: 'Limite de dias úteis para lançamento de horas',
      help: 'Define o prazo de lançamento: registros feitos mais de N dias úteis após a data trabalhada são marcados como "Registrado com atraso" na lista de horas. Fins de semana e feriados nacionais não entram na contagem — com o limite em 1, o trabalho de sexta-feira pode ser lançado até segunda-feira. Use 0 para exigir o lançamento no mesmo dia útil.',
      unit: 'dias úteis',
    },
    lateBlock: {
      label: 'Bloquear lançamentos fora do prazo',
      help: 'Quando ativo, apenas usuários com a permissão "Registrar fora do prazo" podem lançar ou mover horas para datas fora do limite acima. Os demais continuam podendo corrigir a descrição e as horas de registros antigos.',
    },
    vrMinimumHours: {
      label: 'Limite de horas para VR',
      help: 'No Resumo financeiro da equipe, um dia presencial só gera VR quando o turno registrado nele ultrapassa este número de horas.',
      unit: 'horas',
    },
    reportLogo: {
      label: 'Logo dos relatórios',
      help: 'Aparece no topo dos relatórios exportados em PDF, como o Registro de horas. Use uma imagem PNG ou JPG de até 1 MB — de preferência com fundo transparente.',
      empty: 'Nenhum logo enviado',
      previewAlt: 'Logo atual dos relatórios',
      upload: 'Enviar logo',
      replace: 'Trocar logo',
      remove: 'Remover',
      toastSaved: 'Logo atualizado',
      toastRemoved: 'Logo removido',
      toastError: 'Não foi possível atualizar o logo.',
    },
    save: 'Salvar',
    toastSaved: 'Configurações salvas',
    toastError: 'Não foi possível salvar as configurações.',
    loadError: 'Não foi possível carregar as configurações.',
  },
  topbar: { apps: 'Apps', chat: 'Chat', calendar: 'Agenda', email: 'E-mail' },
  nav: {
    sectionHome: 'INÍCIO', sectionApps: 'APLICATIVOS', sectionPages: 'CONFIGURAÇÕES',
    configuration: 'Configuração',
    access: 'Acessos',
    dashboard: 'Painel', agents: 'Agentes de IA', projects: 'Projetos',
    contacts: 'Contatos',
    today: 'Hoje',
    pipelines: 'Pipelines', datasets: 'Conjuntos de dados', logs: 'Logs',
    settings: 'Perfis', integrations: 'Integrações', role: 'Designer', users: 'Usuários',
    sectionMyWork: 'Meu trabalho',
    hours: 'Horas de Atividades',
    ponto: 'Registro de Horas',
    teamHours: 'Horas da equipe',
    teamPonto: 'Resumo da Equipe',
    sectionCommercial: 'Comercial',
    budgets: 'Orçamentos',
    contracts: 'Contratos',
    commercialDashboard: 'Painel',
    projectProfit: 'Lucro',
    budgetParameters: 'Parâmetros',
    technicalReserves: 'Relacionamento',
    cityHall: 'Processos na prefeitura',
    schedules: 'Prazos Arq',
    sectionHr: 'RH',
    sectionFinance: 'Financeiro',
    teamEarnings: 'Proventos e Descontos',
    reimbursements: 'Reembolsos',
    teamPayroll: 'Resumo financeiro',
    forecast: 'Previsão',
    closings: 'Fechamentos',
    financialEntries: 'Movimentação',
    expenseTypes: 'Tipos de despesa',
    kmRates: 'Valor do KM',
    projectReport: 'Relatório de projetos',
    tokens: 'Tokens de acesso',
    services: 'Serviços',
    tags: 'Etiquetas',
    jobRoles: 'Cargos',
    projectItems: 'Ambientes',
    adminActivities: 'Atividades administrativas',
    holidays: 'Feriados',
    workModels: 'Modelos de trabalho',
    templates: 'Modelos',
    projectStatus: 'Status de projeto',
    activityStatus: 'Situações de atividade',
    activities: 'Atividades',
    customFields: 'Campos personalizados',
    general: 'Geral',
    openMenu: 'Abrir menu',
    closeMenu: 'Fechar menu',
    menu: 'Menu',
  },
  contacts: {
    title: 'Contatos',
    subtitle: 'Pessoas e empresas',
    bannerSubtitle: 'Pessoas, empresas e grupos, com seus telefones, endereços, contas e relações',
    resultCount: '{shown} de {total} contatos',
    resultCountShown: '{shown} contatos',
    pageOf: 'Página {current} de {total}',
    perPage: 'Por página',
    prevPage: 'Página anterior',
    nextPage: 'Próxima página',
    new: 'Novo contato',
    search: 'Buscar por nome, documento ou e-mail',
    empty: 'Nenhum contato encontrado',
    loadError: 'Não foi possível carregar os contatos',
    saveError: 'Não foi possível salvar o contato',
    relationsLoadError: 'Não foi possível carregar as relações',
    /** One tag in the list's Relações column: "{role} de {name}", e.g. "Mãe de Helena Silva". */
    relationSummary: '{role} de {name}',
    categoriesLoadError: 'Não foi possível carregar as categorias',
    /** Distinct from `categoriesLoadError`: a form missing its custom fields looks complete, so
     *  the failure has to name which list did not arrive. */
    customFieldsLoadError: 'Não foi possível carregar os campos personalizados',
    type: { label: 'Tipo', person: 'Pessoa', company: 'Empresa', group: 'Grupo', all: 'Todos' },
    fields: {
      name: 'Nome',
      nameCompany: 'Razão social',
      nameGroup: 'Nome do grupo',
      nameGroupHint: 'Como vocês chamam o cliente na agenda. Ex.: Juliana (Alex)',
      tradeName: 'Nome fantasia',
      document: 'Documento',
      cpf: 'CPF',
      cnpj: 'CNPJ',
      rg: 'RG',
      /** No mask runs on this box, so the placeholder is what tells the user the punctuation and the
       *  São Paulo check letter are both welcome — the RG is stored exactly as typed. */
      rgPlaceholder: '12.345.678-X',
      email: 'E-mail',
      instagram: 'Instagram',
      /** The box takes anything the user pasted — `normalizeInstagram` strips the `@`, the URL and a
       *  share link's query tail — so the placeholder shows the shortest of those forms. */
      instagramPlaceholder: '@usuario',
      /** Names the link on the detail screen. The visible text is the handle, which says nothing
       *  about where it goes or that it leaves the app. */
      instagramOpen: 'Abrir {handle} no Instagram',
      birthDate: 'Data de nascimento',
      notes: 'Observações',
      categories: 'Categorias',
      subcategories: 'Subcategorias',
      city: 'Cidade',
      relations: 'Relações',
    },
    tabs: {
      phones: 'Telefones',
      addresses: 'Endereços',
      bankAccounts: 'Bancos',
      relations: 'Relações',
      members: 'Membros',
      projects: 'Projetos',
    },
    sections: {
      identity: 'Identidade',
      identityHint: 'Dados principais do contato',
      notes: 'Observações',
      /** The Observações card on the contact form. The heading is the field's name, so the hint
       *  has to say something the heading does not: what belongs in the box. */
      notesHint: 'Anotações livres sobre este contato',
    },
    create: {
      /** Ends a create whose contact is already on the server, so "Cancelar" would be a lie.
       *  Used by ContactFormPage, once the contact exists but some of its records did not save. */
      finish: 'Concluir',
    },
    /** The full-page contact form (`ContactFormPage`), which serves both /contatos/novo and
     *  /contatos/:id/editar. Distinct from `fields.*`, which are the identity inputs it embeds. */
    form: {
      createTitle: 'Novo contato',
      editTitle: 'Editar {name}',
      back: 'Contatos',
      submitCreate: 'Criar contato',
      submitEdit: 'Salvar',
      typeSection: 'Tipo de contato',
      typeHint: 'O tipo define quais campos de identificação se aplicam.',
      typeLocked: 'O tipo não muda depois da criação.',
      /** Why the identity fields are greyed out mid-flow: the contact is already on the server and
       *  a retry only re-sends the records that failed, so an edit here would go nowhere. Distinct
       *  from `typeLocked`, which is about a value that never changes again. */
      identityLocked: 'O contato já foi criado. Para alterar estes dados, edite o contato depois de concluir.',
      typeHintPerson: 'Pessoa física',
      typeHintCompany: 'Pessoa jurídica',
      typeHintGroup: 'Casal ou domicílio',
      errorSummary_one: 'Corrija {count} campo antes de salvar.',
      errorSummary_other: 'Corrija {count} campos antes de salvar.',
      /** The contact is already saved at this point — this reports only the rows that were not. */
      partialSave_one: 'O contato foi criado, mas {count} registro não pôde ser salvo. Corrija e salve novamente.',
      partialSave_other: 'O contato foi criado, mas {count} registros não puderam ser salvos. Corrija e salve novamente.',
      /** The second sentence of that same banner, never a banner of its own: a member is created
       *  before being attached, so a refused attach leaves a real contact in the agenda. Concluir
       *  and "remover" both walk away from it, and without this the user is never told it exists. */
      partialSaveMemberCreated_one: 'O contato desse membro já foi criado e está na agenda, mesmo sem o vínculo com o grupo.',
      partialSaveMemberCreated_other: 'Os contatos de {count} membros já foram criados e estão na agenda, mesmo sem o vínculo com o grupo.',
    },
    /**
     * Qualifies one sub-record list by whose records it is — used only where a second list of the
     * same kind is on the same page (a group's edit page, with a member's editor open).
     *
     * Applied to the section TITLE, where it is visible and meant to be: that heading is what a
     * sighted user reads to tell the two lists apart, and it is the reason the controls under it
     * need no visible qualifier of their own. Applied to every control's `aria-label`, where the
     * visible words are left alone — an accessible name still containing its visible label, so
     * "Label in Name" holds. See `ContactSubListTab.ownerName`.
     */
    subList: {
      ofOwner: '{label} de {name}',
    },
    /** `add` names both the control that OPENS the inline new-record form and the one that
     *  commits it — they are never on screen together (opening it hides the trigger), and it is
     *  the accurate name for both. A bare "Salvar" there would collide with the contact's own
     *  Salvar, which sits on the same page on /contatos/:id/editar; `addCancel` is the same
     *  reasoning for "Cancelar", which would otherwise read as "leave without saving the contact". */
    phone: {
      number: 'Telefone', add: 'Adicionar telefone', addCancel: 'Cancelar novo telefone',
      empty: 'Nenhum telefone cadastrado',
      sectionHint: 'Cada número tem uma categoria e uma descrição livre',
      whatsappOpen: 'Conversar com {number} no WhatsApp',
      callOpen: 'Ligar para {number}',
    },
    address: {
      zip: 'CEP', street: 'Logradouro', number: 'Número', community: 'Condomínio',
      complement: 'Complemento', district: 'Bairro', city: 'Cidade', state: 'UF',
      add: 'Adicionar endereço', addCancel: 'Cancelar novo endereço', empty: 'Nenhum endereço cadastrado',
      cepNotFound: 'CEP não encontrado',
      cepLookupFailed: 'Não foi possível consultar o CEP',
      sectionHint: 'Cada endereço tem uma categoria e uma descrição livre',
      copyOne: 'Copiar endereço', copyAll: 'Copiar todos os endereços', copied: 'Endereço copiado',
    },
    bank: {
      bank: 'Banco', branch: 'Agência', accountNumber: 'Conta', pixKey: 'Chave PIX',
      holderName: 'Titular', add: 'Adicionar conta', addCancel: 'Cancelar nova conta',
      empty: 'Nenhuma conta cadastrada',
      forbidden: 'Você não tem permissão para ver contas bancárias',
      sectionHint: 'Cada conta tem uma categoria e uma descrição livre',
    },
    relation: {
      add: 'Adicionar relação', empty: 'Nenhuma relação cadastrada',
      target: 'Contato', type: 'Tipo de relação',
      sectionHint: 'As relações são gravadas uma vez e aparecem dos dois lados',
      dialogTitle: 'Adicionar relação',
      preview: '{self} é {selfRole} de {other} · {other} é {otherRole} de {self}',
      self: 'Este contato',
      more_one: 'Mais {count} relação: {list}',
      more_other: 'Mais {count} relações: {list}',
    },
    category: { description: 'Descrição', category: 'Categoria' },
    /**
     * A PERSON's or a GROUP's children — recorded on the contact itself, never as contacts of
     * their own. A COMPANY has no children (see `validation.contactChildrenCompanyForbidden`).
     *
     * `sectionHint` says that out loud because on a GROUP the panel sits directly under Membros,
     * whose rows ARE contacts: without it the two lists look like the same thing rendered twice.
     *
     * `remove`, `moveUp` and `moveDown` name the child for the reason `group.removeMember` does —
     * every one of them is an icon, and a list whose buttons all read "Remover" names none of
     * them. An unnamed draft has its one-based position substituted for `{name}`, so a row the
     * user has not filled in yet is still reachable.
     *
     * The age is stored nowhere: it is calculated from the birth date on every render (see
     * `ageOnDate`), so the two sibling keys are what `plural` picks between rather than a number
     * with "anos" glued to it — "1 anos" is the bug that shape prevents.
     */
    children: {
      title: 'Filhos',
      sectionHint: 'Dados dos filhos deste contato, sem adicioná-los como contatos.',
      empty: 'Nenhum filho cadastrado',
      add: 'Adicionar filho',
      name: 'Nome do filho',
      birthDate: 'Data de nascimento',
      age_one: '{count} ano',
      age_other: '{count} anos',
      remove: 'Remover {name}',
      moveUp: 'Mover {name} para cima',
      moveDown: 'Mover {name} para baixo',
    },
    group: {
      noMembers: 'Nenhum membro',
      /** Joins the members' names on a group's row. */
      memberSeparator: ' · ',
      /** Names the remove control on ONE member's row. A list whose buttons are all called
       *  "Excluir" names none of them — and the member list is the one place several of them sit
       *  one under the other. */
      removeMember: 'Remover {name}',
      sectionHint: 'As pessoas que este grupo representa. O nome delas também encontra o grupo na busca.',
      /** The read-only Membros card on /contatos/:id. Distinct from `sectionHint`, which heads the
       *  EDITABLE panel on the form and talks about search; this one has to say what a member IS,
       *  because a group's own phones and addresses sit right below it and are not members. */
      membersHint: 'Contatos reais que compõem o grupo.',
      /**
       * The bubble captions of the member row's controls — every one of them an icon, and an icon
       * says nothing on its own.
       *
       * The split the star's four strings below already document, applied to the rest of the row:
       * these are what is SEEN (short, and no member's name — the bubble is anchored to the row it is
       * about), while `removeMember`, `editRole`, `editMemberData` and `editMember` remain what is
       * ANNOUNCED and keep naming the member, since several rows carry the same controls. `Tooltip`
       * is documented as purely visual, so none of these is ever read out.
       *
       * Shorter than their announced counterparts on purpose: "Remover do grupo" says what the trash
       * does to a membership without repeating the name already two columns to the left, and the two
       * role captions say which of the pair is which where a bare ✓/✕ does not.
       */
      editRoleTip: 'Editar papel',
      saveRoleTip: 'Salvar papel',
      cancelRoleTip: 'Cancelar edição do papel',
      memberDataTip: 'Editar dados do contato',
      editMemberTip: 'Editar membro',
      removeMemberTip: 'Remover do grupo',
      /**
       * The group's main contact — the one member the studio actually talks to.
       *
       * Four strings for one control, and the split is between what is SEEN and what is
       * ANNOUNCED. The row carries no badge any more: a filled yellow star is the marked state, and
       * a star says nothing on its own, so `primary` and `markPrimary` are the tooltip's two
       * captions — the bubble sits beside the row it is about, which is why neither names the
       * member.
       *
       * `setPrimary`/`unsetPrimary` are the button's accessible name, and those DO name the member,
       * for the same reason `removeMember` and `editRole` do: several rows carry the same controls,
       * and a list whose buttons are all called "Contato principal" names none of them. They also
       * name the direction the click would go, since `aria-pressed` carries the state.
       *
       * `primary` doubles as the caption of the read-only detail screen's badge, which has no star
       * and no control to hang a tooltip on.
       */
      primary: 'Contato principal',
      markPrimary: 'Definir como contato principal',
      setPrimary: 'Definir {name} como contato principal',
      unsetPrimary: 'Remover {name} como contato principal',
      /** Its own words rather than `contacts.saveError`, which this panel already uses for a failed
       *  list load, a failed add and a failed role save — four alerts printing one sentence is four
       *  alerts nobody can tell apart. */
      primarySaveError: 'Não foi possível definir {name} como contato principal',
      role: 'Papel',
      rolePlaceholder: 'Ex.: Esposa, Filho',
      /**
       * The inline edit of ONE member's papel, on the member list. Named after the member for the
       * same reason `removeMember` is: several rows carry the same three controls, and a list whose
       * buttons are all called "Editar" names none of them.
       *
       * `editRoleOf` is the field's accessible name while the row is open — the row shows no visible
       * label, and a bare "Papel" would collide with the add-a-member row's own Papel field sitting
       * directly underneath it.
       */
      editRole: 'Editar papel de {name}',
      editRoleOf: 'Papel de {name}',
      saveRole: 'Salvar papel de {name}',
      cancelRole: 'Cancelar edição do papel de {name}',
      /** Shown when a second row's pencil is clicked over an unsaved change. The panel neither
       *  discards what was typed nor saves it unasked — it says which of the two it is waiting
       *  for. */
      roleEditPending: 'Confirme ou cancele a alteração do papel de {name} antes de editar outro membro.',
      /** Its own words rather than `contacts.saveError`, which this panel already uses for a failed
       *  list load and a failed add. A role PATCH failing under one of those printed the same
       *  sentence twice, with nothing saying which alert was which. */
      roleSaveError: 'Não foi possível salvar o papel de {name}',
      /**
       * The whole-draft edit of a member the group cannot have yet — the create page only.
       *
       * Named after the member for the same reason `removeMember` and `editRole` are, and
       * deliberately NOT reusing `contacts.form.editTitle`, which is the same sentence about a
       * different thing: that one names the page you are on, this one names one row's control.
       *
       * `memberCreated` is why a row sometimes has no such control. Its contact was created before
       * the attach failed, so the draft no longer describes only itself — correcting it here would
       * change the list and nothing on the server. The sentence is on the row rather than absent
       * because the rows around it DO offer the control, and an asymmetry with no reason given
       * reads as a broken button.
       */
      editMember: 'Editar {name}',
      memberCreated: 'O contato de {name} já foi criado e não pode mais ser editado aqui.',
      /**
       * The one way a correction in progress can be thrown away by something other than the user:
       * the create page's flush drops each member as it lands, and the entry it dropped may be the
       * very one open in the row below. What went to the server is the draft as it was HELD, not as
       * it was being corrected — so the row is emptied and this says which member that cost and what
       * was written instead. Silence here would be the panel discarding a value and writing a stale
       * copy of it in the same act, which is the one thing it refuses everywhere else
       * (`roleEditPending`, `memberDataPending`).
       */
      memberEditDiscarded: 'A correção de {name} não foi salva: o membro entrou no grupo com os dados anteriores. Edite o contato de {name} para aplicá-la.',
      /**
       * And the refusal that stops the common case reaching `memberEditDiscarded` at all — the
       * third of this module's "finish what is open first" messages, worded like the other two
       * (`roleEditPending`, `memberDataPending`) rather than in a third voice.
       *
       * The create page's Salvar wrote the member as the panel HELD them, so a correction still in
       * the row went nowhere and was then wiped. Committing it unasked was rejected for the reason
       * this module has settled twice: a write nobody asked for is worse than asking the user to
       * finish. It renders on the PAGE, beside the button that was pressed — `memberEditDiscarded`
       * renders in the panel, because that one is about a row that has just changed under the user.
       */
      memberEditPending: 'Conclua ou cancele a correção de {name} antes de criar o contato.',
      /**
       * The third edit path: the member's OWN contact record, opened inline from their row.
       *
       * Named after the member like every other control on this list, and worded as "dados de" to
       * separate it from `editRole` (the membership) and `editMember` (a draft the group does not
       * have yet) — three controls on one row that would otherwise all read "Editar {name}".
       *
       * `memberDataOf` names the region the control opens, which is what gives the phone and
       * address sections inside it — whose own headings and buttons repeat the ones the group has
       * further up the page — the context that says whose they are.
       *
       * `memberDataPending` is the refusal when a second row's control is pressed. `ContactForm`
       * owns its draft and exposes no way to ask whether it is dirty, so "close it quietly if
       * nothing changed" is not available here: the honest choices are discard or refuse, and this
       * panel refuses and names the way out — the same answer `roleEditPending` gives.
       */
      editMemberData: 'Editar dados de {name}',
      memberDataOf: 'Dados de {name}',
      saveMemberData: 'Salvar dados de {name}',
      memberDataLoadError: 'Não foi possível carregar os dados de {name}',
      /**
       * A failed REFRESH, which is a different fact and has to say so: it sits over a form the
       * user is still editing, so denying that the data is there would contradict what is on
       * screen. The same distinction `contacts.detail.refreshFailed` draws from `notFound`.
       */
      memberDataRefreshError: 'Não foi possível atualizar os dados de {name}',
      /** The way back from a failed load. Several members can be open one after another, so the
       *  control is named after the one it would re-read; the visible word stays short. */
      retryMemberData: 'Tentar carregar os dados de {name} novamente',
      /** The save's only visible outcome. The editor stays open after one — closing it would
       *  discard whatever the sub-record lists were part-way through — so without this a corrected
       *  document, e-mail or note would land with nothing on screen changing at all. */
      memberDataSaved: 'Dados de {name} salvos',
      memberDataPending: 'Feche a edição dos dados de {name} antes de editar outro membro.',
      /** Names the chip in the contact header that links to a group this contact belongs to. A
       *  parameterized sentence, not `belongsTo` + the name: `belongsTo` is the plural caption
       *  'Grupos', and "Grupos Familia Sarmento" states no relationship and reads as a group with
       *  that name. The visible text stays the bare group name, which this CONTAINS, so
       *  "Label in Name" holds. */
      belongsToChip: 'Pertence ao grupo {name}',
    },
    /**
     * The inline row that adds one member to a group (`MemberRow`), on both the create and the
     * edit page.
     *
     * Only what is genuinely new lives here. The row's type label, its CPF/CNPJ labels and every
     * one of its validation messages are the contact form's own strings, read from
     * `contacts.type.label`, `contacts.fields.*` and `validation.*` — a second wording for the same
     * rule reads as a second rule.
     *
     * It has no "nobody matched" string of its own and no longer borrows `contacts.empty` for one:
     * a search that finds nobody now shows no panel and no message at all, because `hint` below is
     * on screen the whole time and already says what happens to a name nobody was picked for.
     */
    member: {
      /** The person's one field both searches and names; the company field names its persisted value. */
      namePerson: 'Nome — busque ou digite um novo',
      nameCompany: 'Nome fantasia',
      hint: 'Busque pelo nome. Se ninguém for selecionado, um novo contato é criado com o que você digitar.',
      hintLinked: '{name} já existe — será apenas vinculado ao grupo.',
      /** The button says which of the two things the row is about to do, never a bare "Salvar":
       *  creating a contact and merely pointing at one are not the same act to undo. */
      submitCreate: 'Criar e adicionar',
      submitLink: 'Vincular ao grupo',
      unlink: 'Desfazer a seleção',
      /**
       * The row while it holds a member that is already on the list.
       *
       * `submitEdit` overrides both of the two above, and is a bare "Salvar alterações" on purpose:
       * whether the member is a link or a create is no longer the choice being made — nothing is
       * created or attached by this button at all, it only replaces a draft the page is holding.
       * (The three other `save: 'Salvar alterações'` in this file belong to other modules; a shared
       * key across modules is a shared decision about wording, which these are not.)
       *
       * `hintEditing` replaces `hint`/`hintLinked`, whose promise — "a new contact is created with
       * what you type" — is about adding, and would read as a second member being made.
       */
      submitEdit: 'Salvar alterações',
      cancelEdit: 'Cancelar edição',
      hintEditing: 'Editando {name} — salvar substitui esse membro na lista.',
    },
    createdAt: 'Criado em {date}',
    /** Last write to the contact record itself. Its own phones, addresses and bank accounts
     *  are separate rows and do not touch it — see the note in ContactDetailScreen. */
    updatedAt: 'Atualizado em {date}',
    projects: {
      sectionHint: 'Projetos em que este contato aparece, com o papel de cada vínculo.',
      empty: 'Este contato não está em nenhum projeto.',
      add: 'Adicionar projeto',
      dialogTitle: 'Vincular contato a um projeto',
      projectLabel: 'Projeto',
      roleLabel: 'Papel',
      searchPlaceholder: 'Buscar projeto',
      pickProject: 'Selecione um projeto',
      noProject: 'Nenhum projeto encontrado',
      changeRole: 'Alterar o papel em {name}',
      // Mirrors `projetos.contacts.remove` ('Remover {name} do projeto') with the two ends
      // swapped: there, {name} is the contact being removed from the one project in view; here
      // the contact is implicit (this screen is already its own) and {name} is which of
      // possibly several projects the row names — a flat 'Remover deste projeto' gave every row
      // the same accessible name.
      remove: 'Remover {name} deste contato',
      loadError: 'Não foi possível carregar os projetos deste contato.',
    },
    /** The delete dialog's cascade note for project links, beside the relations note. */
    deleteProjectsNote_one: 'Este contato também será removido de 1 projeto:',
    deleteProjectsNote_other: 'Este contato também será removido de {count} projetos:',
    projectLinkSummary: '{role} em {name}',
    archive: 'Arquivar', restore: 'Restaurar', archived: 'Arquivado',
    archivedFilter: {
      label: 'Situação',
      active: 'Ativos',
      archived: 'Arquivados',
      all: 'Todos',
    },
    /** The sidebar's Tipo group lists contacts, so it pluralizes — unlike `contacts.type.*`,
     *  which names the type of one contact (a row's badge, the create form). */
    filters: {
      type: { all: 'Todos', person: 'Pessoas', company: 'Empresas', group: 'Grupos' },
      categorySearch: 'Buscar categoria ou subcategoria',
    },
    /** The "Busca avançada" block in the sidebar (`ContactFilterPanel`) and the dialog it opens —
     *  birth month, phone, city and community in a general section, plus one section per contact
     *  type listing that type's custom fields. Mirrors `projetos.filters.advanced.*` end to end:
     *  same button+badge+chip layout in the sidebar, same dialog shape. */
    advancedSearch: {
      button: 'Busca avançada',
      title: 'Busca avançada',
      generalSection: 'Contato',
      clear: 'Limpar',
      cancel: 'Cancelar',
      apply: 'Aplicar',
      birthMonth: 'Mês de nascimento',
      birthMonthAny: 'Qualquer mês',
      phone: 'Telefone',
      city: 'Cidade',
      community: 'Condomínio',
      selectOption: 'Selecione uma opção',
      /** A general-section chip's title, e.g. "Contato · Telefone". */
      chipGeneral: 'Contato · {label}',
      /** A custom-field chip's title, e.g. "Pessoa · Time favorito". */
      chipType: '{type} · {label}',
      removeChip: 'Remover filtro',
      months: {
        '1': 'Janeiro', '2': 'Fevereiro', '3': 'Março', '4': 'Abril', '5': 'Maio', '6': 'Junho',
        '7': 'Julho', '8': 'Agosto', '9': 'Setembro', '10': 'Outubro', '11': 'Novembro', '12': 'Dezembro',
      },
    },
    actions: { edit: 'Editar contato' },
    export: {
      /** Filename stem; the route appends `-AAAA-MM-DD.csv`. */
      filename: 'contatos',
      archivedYes: 'Sim',
      archivedNo: 'Não',
      /** Two contact types may define a custom field with the same name; only then is the type appended. */
      customFieldCollision: '{label} ({type})',
      columns: {
        name: 'Nome',
        tradeName: 'Nome fantasia',
        type: 'Tipo',
        document: 'Documento',
        rg: 'RG',
        email: 'E-mail',
        instagram: 'Instagram',
        birthDate: 'Data de nascimento',
        categories: 'Categorias',
        groups: 'Grupos',
        members: 'Membros',
        mainMember: 'Contato principal',
        relations: 'Relações',
        notes: 'Observações',
        archived: 'Arquivado',
        phone: {
          kind: 'Telefone {n} tipo',
          number: 'Telefone {n}',
          description: 'Telefone {n} descrição',
        },
        address: {
          kind: 'Endereço {n} tipo',
          zip: 'Endereço {n} CEP',
          street: 'Endereço {n} logradouro',
          number: 'Endereço {n} número',
          community: 'Endereço {n} condomínio',
          complement: 'Endereço {n} complemento',
          district: 'Endereço {n} bairro',
          city: 'Endereço {n} cidade',
          state: 'Endereço {n} UF',
          description: 'Endereço {n} descrição',
        },
        bank: {
          kind: 'Conta {n} tipo',
          bank: 'Conta {n} banco',
          branch: 'Conta {n} agência',
          accountNumber: 'Conta {n} número',
          pixKey: 'Conta {n} chave PIX',
          holderName: 'Conta {n} titular',
          description: 'Conta {n} descrição',
        },
      },
    },
    catalogs: {
      contact: 'Categorias de contato',
      phone: 'Categorias de telefone',
      address: 'Categorias de endereço',
      bankAccount: 'Categorias de conta bancária',
      relationTypes: 'Tipos de relação',
      itemName: 'Nome do item',
      addCategory: 'Adicionar categoria',
      addSubcategory: 'Adicionar subcategoria',
      addRelationType: 'Adicionar tipo',
      forwardName: 'Relação',
      inverseName: 'Relação inversa',
      symmetric: 'Mesma nos dois sentidos',
      inUse: 'Este item está em uso e não pode ser excluído',
      archivedType: 'Este tipo de relação está arquivado e não pode ser usado',
      duplicate: 'Já existe um item com esse nome',
      loadError: 'Não foi possível carregar esta lista',
      hint: 'A relação inversa é o que aparece no contato do outro lado. Ex.: Pai / Filho(a).',
      reorderType: 'Reordenar {name}',
      typeDragHint: 'Arraste para reordenar, ou use Alt com as setas para cima e para baixo.',
      typeReordered: '{name} movido para a posição {position} de {total}',
      orderHint: 'A ordem define qual relação aparece primeiro na lista de contatos.',
      hintCategories: 'Cada categoria pode ter subcategorias usadas nos registros de contato',
      subcategoryCountOne: '{count} subcategoria',
      subcategoryCountOther: '{count} subcategorias',
      /** aria-label of the expand/collapse chevron. Deliberately NOT "Mostrar subcategorias de…":
       *  the button also carries `aria-expanded`, and a label saying "Mostrar" while the row is
       *  open contradicts the state that same button announces. */
      toggleSubcategories: 'Subcategorias de {name}',
      showArchived: 'Mostrar arquivados',
      editName: 'Editar nome de {name}',
      pickColor: 'Cor de {name}',
      hasSubcategories: 'Exclua as subcategorias antes de excluir esta categoria',
      /** The draft row's colour dot, before it has a category name to interpolate into
       *  `pickColor`. Its own key rather than reaching into `etiquetas.color` — that namespace
       *  belongs to project tags, not contacts. */
      color: 'Cor',
      projectRoles: 'Papéis em projetos',
      projectRoleName: 'Nome do papel',
      addProjectRole: 'Adicionar papel',
      projectRolesHint: 'Papéis usados para ligar contatos a projetos — Cliente, Fornecedor, Engenheiro.',
    },
    /** Names the header's delete control on /contatos/:id. The visible word stays 'Excluir', but
     *  every sub-record row on the flattened page carries an 'Excluir' of its own, and several
     *  controls sharing one accessible name name none of them. */
    deleteContact: 'Excluir {name}',
    /** The delete dialog's heading. It names the contact because every row of the list carries the
     *  same "Excluir" button — a heading without the name cannot say which one is about to go. */
    deleteTitle: 'Excluir {name} permanentemente?',
    /** Heads the relations this delete will take with it. A relation is stored once and read from
     *  both ends, so removing this contact also changes the record on the other end — one the user
     *  is not looking at. Naming them is what replaced refusing the delete outright, so the count
     *  alone will not do: the lines themselves say whose record changes. */
    deleteRelationsNote_one: 'Também será removida {count} relação:',
    deleteRelationsNote_other: 'Também serão removidas {count} relações:',
    /** Either half of the cascade lookup (relations, project links, or both) could not be read,
     *  so the dialog cannot promise its list is complete — worded to hold for either half rather
     *  than naming "relations" specifically, since the half that failed can just as easily be the
     *  projects one while relations loaded and list fine underneath this note. The delete is
     *  still offered: refusing it while this endpoint is down is the very dead end that listing
     *  the cascade exists to remove. Distinct from `relationsLoadError`, which is the Relações tab
     *  failing to render a list of its own. */
    deleteRelationsUnknown: 'Não foi possível verificar tudo o que será removido junto com este contato.',
    categoryPicker: {
      placeholder: 'Selecione categorias',
      searchPlaceholder: 'Buscar categoria…',
      empty: 'Nenhuma categoria encontrada',
      /** Names each chip's ×. The chips are the only way to deselect — the list drops what is
       *  already picked — so an unnamed × is the only way back out being unreachable. */
      remove: 'Remover {name}',
    },
    subcategoryPicker: {
      placeholder: 'Selecione subcategorias',
      searchPlaceholder: 'Buscar subcategoria…',
      /** The disabled trigger's text: with no category picked there is nothing this control could
       *  offer, and saying so beats an enabled box that opens onto nothing. NOT the open list's
       *  empty state — see `notFound`. */
      empty: 'Escolha uma categoria primeiro',
      /** The open list with nothing left in it: a search that matched none of the offered
       *  subcategories, or a parent whose only child is already picked (the chips variant hides
       *  what is selected). `empty` would be telling the user to do the thing they just did — the
       *  mirror of `categoryPicker.empty`, which this deliberately parallels. */
      notFound: 'Nenhuma subcategoria encontrada',
      remove: 'Remover {name}',
    },
    /** A subcategory in the list's filter row, where its parent chip is not necessarily beside it.
     *  Names are only unique per parent now, so two different "Residencial" chips can share that
     *  row and a bare name would not say which one is being toggled. */
    subcategoryChipLabel: '{parent} › {name}',
    detail: {
      notFound: 'Contato não encontrado',
      /** A reload that failed with the contact already on screen. Distinct from `notFound`, which
       *  would be asserting the absence of the very record the page is showing. */
      refreshFailed: 'Não foi possível atualizar os dados deste contato',
      backToList: 'Voltar para contatos',
    },
  },
  projetos: {
    bannerTitle: 'Aplicativo de projetos',
    bannerSubtitle: 'Gerencie seus projetos e etapas',
    detailsTitle: 'Detalhes do projeto',
    newProject: 'Novo projeto',
    searchPlaceholder: 'Buscar projetos',
    noResults: 'Nenhum projeto encontrado.',
    resizeFilter: 'Redimensionar filtro',
    resizeList: 'Redimensionar lista',
    untitled: 'Projeto sem título',
    saveProject: 'Salvar projeto',
    filters: {
      all: 'Todos',
      recent: 'Recentes',
      starred: 'Favoritos',
      status: 'Status',
      tag: 'Etiquetas',
      scope: 'Serviços e Etapas',
      phase: 'Etapa atual',
      noPhase: 'Sem etapa',
      expandPhase: 'Expandir {name}',
      collapsePhase: 'Recolher {name}',
      button: 'Filtros',
      title: 'Filtros',
      clear: 'Limpar filtros',
      results: 'Ver resultados',
      close: 'Fechar',
      advanced: {
        button: 'Filtro avançado',
        title: 'Filtro avançado',
        projectSection: 'Projeto',
        apply: 'Aplicar',
        clear: 'Limpar',
        cancel: 'Cancelar',
        empty: 'Nenhum campo personalizado disponível.',
        chipProject: 'Projeto · {label}',
        chipService: '{service} · {label}',
        unknownService: 'Serviço',
        removeChip: 'Remover filtro',
      },
    },
    fields: {
      name: 'Nome do projeto', namePlaceholder: 'ex.: Reformulação do onboarding da Acme',
      client: 'Cliente',
    },
    phasesHeading: 'Etapas',
    currentPhaseLabel: 'Etapa atual',
    phaseCurrentBadge: 'Atual',
    phaseProgress: {
      completeAction: 'Concluir etapa',
      reopenAction: 'Reabrir',
      completeSubphaseAction: 'Concluir subetapa',
      reopenSubphaseAction: 'Reabrir subetapa',
      actionsMenu: 'Ações da etapa',
      completeConfirmTitle: 'Concluir etapa?',
      completeConfirmMessage: 'Concluir "{phase}" em {service}? A etapa atual passará a ser "{next}".',
      completeConfirmMessageLast: 'Concluir "{phase}" em {service}? Este é a última etapa e o serviço será marcado como concluído.',
      completeOutOfOrderConfirmMessage: 'Concluir "{phase}" em {service}? A etapa atual continua sendo "{current}".',
      completeOutOfOrderConfirmMessageNoCurrent: 'Concluir "{phase}" em {service}?',
      completeConfirmMessageLastPending: 'Concluir "{phase}" em {service}? Esta é a última etapa pendente e o serviço será marcado como concluído.',
      completeSubphaseConfirmTitle: 'Concluir subetapa?',
      completeSubphaseConfirmMessage: 'Concluir "{phase}" em {service}? A próxima subetapa será "{next}".',
      completeSubphaseConfirmMessageLast: 'Concluir "{phase}" em {service}? Esta é a última subetapa; a etapa será concluída e o serviço avançará automaticamente.',
      reopenConfirmTitle: 'Reabrir etapa?',
      reopenConfirmMessage: 'Reabrir "{phase}" em {service}? Etapas posteriores concluídas voltarão a ficar pendentes.',
      reopenSubphaseConfirmTitle: 'Reabrir subetapa?',
      reopenSubphaseConfirmMessage: 'Reabrir "{phase}" em {service}? A etapa e subetapas posteriores concluídas voltarão a ficar pendentes.',
      serviceCompletedBadge: 'Serviço concluído',
      phaseCompletedBadge: 'Concluída',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      errorGeneric: 'Não foi possível atualizar a etapa.',
    },
    expandAll: 'Expandir tudo',
    collapseAll: 'Recolher tudo',
    expandService: 'Expandir serviço {name}',
    collapseService: 'Recolher serviço {name}',
    colPhase: 'Etapa',
    colPlanned: 'Planejado',
    colLogged: 'Registrado',
    colRemaining: 'Saldo',
    colRemainingGross: 'Saldo bruto',
    colProgress: 'Progresso',
    colProgressGross: 'Progresso bruto',
    colPct: '%',
    currentPhaseNone: 'Nenhuma',
    phaseSelect: 'Etapa',
    phaseSelectPlaceholder: 'Selecione uma etapa',
    phaseSelectEmpty: 'Nenhuma etapa no catálogo. Cadastre em Configurações › Etapas.',
    serviceSelect: 'Serviço',
    serviceSelectPlaceholder: 'Selecione um serviço',
    serviceSelectEmpty: 'Nenhum serviço. Cadastre em Configurações › Serviços.',
    loadServicePhases: 'Carregar etapas padrão do serviço',
    loadServicePhasesHint: 'Este serviço tem um modelo de etapas padrão.',
    replacePhasesConfirm: 'Substituir as etapas pelo modelo do novo serviço?',
    addService: 'Adicionar serviço',
    addServiceDialogTitle: 'Adicionar serviço',
    newProjectDialogTitle: 'Novo projeto',
    startBlank: 'Começar do zero',
    templateMeta: '{services} serviços · {items} ambientes',
    serviceTabHasError: 'com erros',
    serviceTabDragHint: 'Arraste para reordenar, ou Alt+setas',
    serviceReordered: '{name} movido para a posição {position} de {total}',
    viewServiceTabAria: '{name}. Planejado {planned}. Registrado {logged}. Saldo {remaining}. {pct}%',
    viewServiceTabCompleted: 'Concluído',
    viewServiceTabCompletedOn: 'em {date}',
    servicesHeading: 'Serviços',
    noServicesHint: 'Este projeto ainda não tem serviços.',
    removeService: 'Remover serviço',
    tagsHeading: 'Etiquetas',
    addTag: 'Adicionar etiqueta',
    addTagDialogTitle: 'Escolher etiqueta',
    tagSelectEmpty: 'Nenhuma etiqueta disponível. Crie etiquetas em Configurações › Etiquetas.',
    removeTag: 'Remover etiqueta',
    tagsSaveError: 'Não foi possível salvar as etiquetas.',
    phaseDescription: 'Descrição',
    phaseDescriptionPlaceholder: 'Descreva esta etapa',
    phaseHours: 'Horas',
    noPhases: 'Nenhuma etapa ainda.',
    noDescription: 'Sem descrição',
    addPhase: 'Adicionar etapa',
    addSubphase: 'Adicionar subetapa',
    duplicatePhase: 'Duplicar etapa',
    copySuffix: '(cópia)',
    subphaseNamePlaceholder: 'Nome da subetapa',
    subphasesOne: '{count} subetapa',
    subphasesOther: '{count} subetapas',
    subphasesSectionTitle: 'Subetapas',
    removePhase: 'Remover etapa',
    reorderPhase: 'Reordenar etapa',
    totalHours: '{hours} no total',
    summary_one: '{count} etapa · {logged} / {hours}',
    summary_other: '{count} etapas · {logged} / {hours}',
    stats: {
      phases: 'Etapas',
      plannedHours: 'Planejadas',
      plannedCaption_one: '{count} etapa',
      plannedCaption_other: '{count} etapas',
      logged: 'Registradas',
      loggedCaption: '{pct}% do planejado',
      remaining: 'Saldo',
      grossRemaining: 'Saldo bruto',
      grossRemainingCaption: 'Planejado − registrado em todas as {count} etapas',
      netRemaining: 'Saldo efetivo',
      netRemainingCaption_one: 'Só a etapa em andamento',
      netRemainingCaption_other: 'Só as {count} etapas em andamento',
      closedInCompleted: 'Saldo bruto das etapas concluídas',
      closedInCompletedCaption_one: '{unused} não usada — {exceeded} excedida em {count} etapa concluída',
      closedInCompletedCaption_other: '{unused} não usadas — {exceeded} excedidas em {count} etapas concluídas',
    },
    consumption: {
      gross: 'Consumo sobre o planejado',
      grossCaption: 'Base bruta — todas as etapas',
      net: 'Consumo sobre o efetivo',
      netCaption: 'Base efetiva — concluídas fechadas no realizado',
      of: '{logged} de {total}',
    },
    legend: {
      gross: 'Bruto: todas as etapas',
      net: 'Efetivo: só etapas em andamento',
    },
    tabs: { overview: 'Visão geral', details: 'Detalhes', history: 'Histórico', items: 'Ambientes', contacts: 'Contatos', contracts: 'Contratos' },
    contacts: {
      title: 'Contatos do projeto',
      sectionHint: 'Pessoas e empresas ligadas a este projeto, cada uma com seu papel.',
      empty: 'Nenhum contato vinculado.',
      add: 'Adicionar contato',
      dialogTitle: 'Vincular contato ao projeto',
      contactLabel: 'Contato',
      roleLabel: 'Papel',
      changeRole: 'Alterar o papel de {name}',
      remove: 'Remover {name} do projeto',
      loadError: 'Não foi possível carregar os contatos do projeto.',
    },
    contracts: {
      title: 'Contratos do projeto',
      sectionHint: 'O contrato, os adicionais e o m² excedente fechados para este projeto.',
      empty: 'Nenhum contrato vinculado. Para vincular, abra o contrato em Contratos e escolha este projeto no campo Projeto.',
      loadError: 'Não foi possível carregar os contratos do projeto.',
      openList: 'Abrir Contratos',
      number: 'Nº contrato',
      service: 'Serviço',
      closedOn: 'Fechamento',
      value: 'Valor',
      noNumber: 'sem nº',
      none: '–',
      total: 'Total',
    },
    detail: {
      general: 'Geral',
      fieldsFilled: '{filled}/{total} preenchidos',
      completeness: 'Preenchimento',
      fieldsFilledCount: '{filled} de {total} campos preenchidos',
      missing: 'Faltando',
      lastUpdate: 'Última atualização',
      viewHistory: 'Ver histórico',
      editFields: 'Editar campos',
      editFieldsOf: 'Editar campos de {group}',
      saveError: 'Não foi possível salvar os campos.',
      notFound: 'Projeto não encontrado',
      backToList: 'Voltar para projetos',
      breadcrumbProjects: 'Projetos',
    },
    history: {
      empty: 'Nenhuma alteração registrada.',
      fieldStatus: 'o status',
      fieldPhase: 'a etapa',
      fieldServiceCompleted: 'a conclusão do serviço',
      fieldCustom: 'o campo "{label}"',
      entry: 'alterou {field}: {from} → {to}',
      none: '—',
    },
    hoursProgress: 'Progresso',
    percentLogged: '{pct}% registrado',
    phaseComplete: '{pct}% completo',
    remaining: 'Saldo {hours}',
    remainingGross: 'Bruto: {hours}',
    actions: { toggleStar: 'Favoritar', editProject: 'Editar projeto', deleteProject: 'Excluir projeto' },
    toast: {
      saved: 'Projeto salvo',
      saveError: 'Não foi possível salvar o projeto',
      deleteError: 'Não foi possível excluir o projeto',
      loadError: 'Não foi possível carregar os projetos',
      starError: 'Não foi possível atualizar os favoritos',
    },
    itemsHeading: 'Ambientes',
    itemsHint: 'Selecione um ambiente existente e descreva como ele se aplica aqui. Cada ambiente traz suas próprias fases e atividades.',
    itemsCount: '{count} adicionados',
    addItem: 'Adicionar ambiente',
    selectItem: 'Selecionar um ambiente…',
    itemSearchPlaceholder: 'Buscar ambientes',
    itemEmpty: 'Nenhum ambiente encontrado',
    itemRequired: 'Selecione um ambiente',
    itemDescriptionLabel: 'Descrição',
    itemDescriptionPlaceholder: 'Como este ambiente se aplica ao projeto',
    removeItem: 'Remover ambiente',
    noItems: 'Nenhum ambiente ainda.',
    itemMeta: '{phases} fases · {activities} atividades',
    itemsTabEmpty: 'Nenhum ambiente neste projeto. Adicione um na tela de edição.',
    phaseHoursShort: 'h',
    hoursFieldHours: 'Horas planejadas',
    hoursFieldMinutes: 'Minutos planejados',
    hoursModeLabel: 'Horas',
    hoursModeFixed: 'Fixas',
    hoursModeSum: 'Soma',
    sourceSeparator: ' — ',
    deactivateCatalogActivity: 'Remover atividade do projeto',
    activateCatalogActivity: 'Reativar atividade',
    deleteServiceTitle: 'Remover serviço do projeto?',
    deletePhaseTitle: 'Remover etapa do projeto?',
    deleteActivityTitle: 'Remover atividade do projeto?',
    deleteServiceBlocked: 'Não é possível remover este serviço',
    deletePhaseBlocked: 'Não é possível remover esta etapa',
    deleteActivityBlocked: 'Não é possível remover esta atividade',
    restoreActivity: 'Restaurar atividade',
    restoreActivityAria: 'Restaurar atividade: {name}',
    disableSubphase: 'Desativar subetapa',
    disableSubphaseAria: 'Desativar subetapa: {name}',
    enableSubphase: 'Reativar subetapa',
    enableSubphaseAria: 'Reativar subetapa: {name}',
    subphaseDisabledBadge: 'Desativada',
    activityAssignments: {
      column: 'Responsável',
      activityPicker: 'Definir responsável de {name}',
      phasePicker: 'Definir responsáveis de {name}',
      assign: 'Atribuir',
      assignPhase: 'Atribuir etapa',
      multiple: 'Vários',
      listLabel: 'Responsáveis disponíveis',
      searchLabel: 'Buscar responsável',
      searchPlaceholder: 'Buscar pessoa',
      empty: 'Nenhum responsável encontrado',
      loading: 'Carregando responsáveis…',
      loadError: 'Não foi possível carregar os responsáveis.',
      mutationError: 'Não foi possível atualizar o responsável.',
      removeAssignment: 'Remover atribuição',
      remove: 'Remover atribuição de {name}',
      removeAll: 'Remover atribuição de todas as atividades de {name}',
      stackLabel: 'Responsáveis pela atividade',
      more_one: 'Mais {count} responsável',
      more_other: 'Mais {count} responsáveis',
      moreWithNames_one: 'Mais {count} responsável: {names}',
      moreWithNames_other: 'Mais {count} responsáveis: {names}',
      overflow_one: '+{count}',
      overflow_other: '+{count}',
      unassigned_one: '{count} atividade sem responsável',
      unassigned_other: '{count} atividades sem responsável',
    },
  },
  roles: {
    bannerTitle: 'Perfis de acesso',
    bannerSubtitle: 'Defina perfis e as funcionalidades que cada um pode acessar',
    newRole: 'Novo perfil',
    searchPlaceholder: 'Buscar perfis',
    noResults: 'Nenhum perfil encontrado.',
    selectPrompt: 'Selecione um perfil',
    untitled: 'Perfil sem nome',
    systemTag: 'Sistema',
    systemRoleTag: 'Perfil do sistema',
    copySuffix: '(cópia)',
    detailsTitle: 'Detalhes do perfil',
    deleteRole: 'Excluir perfil',
    namePlaceholder: 'ex.: Gerente de projetos',
    descPlaceholder: 'Descreva o que este perfil pode fazer',
    systemNotice: 'Perfis do sistema não podem ser editados. Duplique este perfil para personalizar suas permissões.',
    featureAccess: 'Acesso a funcionalidades',
    enabledCount: '{count} de {total} ativadas',
    selectAll: 'Selecionar tudo',
    save: 'Salvar alterações',
    cancel: 'Cancelar',
    unsaved: 'Há alterações não salvas',
    duplicate: 'Duplicar perfil',
    duplicateDirtyHint: 'Salve ou cancele as alterações antes de duplicar',
    toastSaved: 'Perfil salvo',
    toastSaveError: 'Não foi possível salvar o perfil',
    toastDeleteError: 'Não foi possível excluir o perfil',
    toastLoadError: 'Não foi possível carregar os perfis',
    summary_one: '{count}/{total} permissão',
    summary_other: '{count}/{total} permissões',
    catalog: {
      projects: { label: 'Projetos', features: {
        read:   { label: 'Visualizar', desc: 'Ver projetos e suas etapas' },
        edit:   { label: 'Editar', desc: 'Alterar nomes, etapas e horas dos projetos' },
        create: { label: 'Criar', desc: 'Criar novos projetos' },
        delete: { label: 'Excluir', desc: 'Remover projetos permanentemente' },
        closePhase: { label: 'Concluir etapas', desc: 'Marcar etapas de serviço como concluídas e reabri-las' },
        editCustomFields: { label: 'Editar campos personalizados', desc: 'Preencher os campos personalizados do projeto e dos seus serviços sem editar o projeto' },
        editTags: { label: 'Editar etiquetas', desc: 'Atribuir e remover etiquetas do projeto sem editar o projeto nem gerenciar o catálogo geral de etiquetas' },
        assignActivities: { label: 'Atribuir atividades', desc: 'Definir responsáveis pelas atividades dos projetos' },
        viewContracts: { label: 'Ver contratos do projeto', desc: 'Ver a aba Contratos do projeto, com o número, a data e o valor de cada contrato vinculado' },
      }},
      contacts: { label: 'Contatos', features: {
        read:   { label: 'Visualizar', desc: 'Ver contatos, telefones, endereços e relações' },
        create: { label: 'Criar', desc: 'Criar novos contatos' },
        edit:   { label: 'Editar', desc: 'Alterar contatos e suas listas' },
        delete: { label: 'Excluir', desc: 'Arquivar e remover contatos' },
        export: { label: 'Exportar', desc: 'Baixar a lista de contatos em arquivo' },
        bankAccounts: { label: 'Contas bancárias', desc: 'Ver e editar os dados bancários dos contatos' },
        manage: { label: 'Gerenciar catálogos', desc: 'Criar e arquivar categorias e tipos de relação' },
      }},
      services: { label: 'Serviços', features: {
        manage: { label: 'Gerenciar', desc: 'Criar serviços e editar suas etapas e atividades' },
      }},
      tags: { label: 'Etiquetas', features: {
        manage: { label: 'Gerenciar', desc: 'Criar, editar e arquivar etiquetas de projeto' },
      }},
      jobRoles: { label: 'Cargos', features: {
        manage: { label: 'Gerenciar', desc: 'Criar, editar e arquivar cargos utilizados no histórico de pagamento' },
      }},
      projectItems: { label: 'Ambientes', features: {
        manage: { label: 'Gerenciar', desc: 'Criar, editar e arquivar ambientes' },
      }},
      adminActivities: {
        label: 'Atividades administrativas',
        features: {
          manage: {
            label: 'Gerenciar atividades administrativas',
            desc: 'Criar, renomear, reordenar e arquivar atividades administrativas',
          },
        },
      },
      holidays: { label: 'Feriados', features: {
        manage: { label: 'Gerenciar', desc: 'Criar, editar e arquivar feriados do calendário' },
      }},
      workModels: { label: 'Modelos de trabalho', features: {
        manage: { label: 'Gerenciar', desc: 'Criar, editar e arquivar modelos de trabalho' },
      }},
      templates: { label: 'Modelos', features: {
        manage: { label: 'Gerenciar', desc: 'Criar, editar e arquivar modelos de projeto' },
      }},
      projectStatus: { label: 'Status de projeto', features: {
        manage: { label: 'Gerenciar', desc: 'Criar, editar e arquivar os status dos projetos' },
      }},
      customFields: { label: 'Campos personalizados', features: {
        manage: { label: 'Gerenciar', desc: 'Criar e editar os campos personalizados dos projetos' },
      }},
      agents: { label: 'Agentes de IA', features: {
        read:      { label: 'Visualizar', desc: 'Ver agentes e seus status' },
        run:       { label: 'Executar', desc: 'Iniciar e parar execuções de agentes' },
        configure: { label: 'Configurar', desc: 'Editar prompts e configurações dos agentes' },
        delete:    { label: 'Excluir', desc: 'Remover agentes' },
      }},
      datasets: { label: 'Conjuntos de dados', features: {
        read:   { label: 'Visualizar', desc: 'Navegar por conjuntos de dados e registros' },
        upload: { label: 'Enviar', desc: 'Adicionar e importar dados' },
        delete: { label: 'Excluir', desc: 'Remover conjuntos de dados' },
      }},
      pipelines: { label: 'Pipelines', features: {
        read:   { label: 'Visualizar', desc: 'Ver execuções e logs de pipelines' },
        run:    { label: 'Executar', desc: 'Disparar execuções de pipelines' },
        manage: { label: 'Gerenciar', desc: 'Editar a configuração das pipelines' },
      }},
      members: { label: 'Membros', features: {
        read:   { label: 'Visualizar', desc: 'Ver membros do workspace' },
        invite: { label: 'Convidar', desc: 'Enviar convites a membros' },
        manage: { label: 'Gerenciar perfis', desc: 'Atribuir e editar perfis dos membros' },
        payroll: {
          label: 'Histórico de pagamento',
          desc: 'Ver e gerenciar o histórico de pagamento dos usuários.',
        },
      }},
      earnings: {
        label: 'Proventos e Descontos',
        features: {
          read: { label: 'Visualizar', desc: 'Ver os lançamentos de proventos e descontos da equipe.' },
          manage: { label: 'Gerenciar', desc: 'Criar, editar e remover lançamentos de proventos e descontos.' },
        },
      },
      reimbursements: {
        label: 'Reembolsos',
        features: {
          read: { label: 'Visualizar', desc: 'Ver a página de reembolsos e os próprios lançamentos.' },
          manage: { label: 'Gerenciar', desc: 'Criar, editar e remover os próprios lançamentos de reembolso.' },
          readAll: { label: 'Visualizar de todos', desc: 'Ver os lançamentos de reembolso de qualquer usuário.' },
          manageOthers: { label: 'Lançar em nome de outros', desc: 'Registrar lançamentos de reembolso em nome de outra pessoa.' },
          manageTypes: { label: 'Gerenciar tipos de despesa', desc: 'Criar, editar e arquivar os tipos de despesa, e gerenciar as vigências do valor do km.' },
        },
      },
      budgets: {
        label: 'Orçamentos',
        features: {
          read: { label: 'Ver orçamentos', desc: 'Ver a lista de orçamentos, abrir cada um e consultar os custos por hora agregados.' },
          create: { label: 'Criar orçamentos', desc: 'Criar novos orçamentos na calculadora.' },
          edit: { label: 'Editar orçamentos', desc: 'Alterar os dados, os valores e o status dos orçamentos, exceto fechá-los.' },
          delete: { label: 'Excluir orçamentos', desc: 'Remover orçamentos permanentemente.' },
          close: { label: 'Fechar orçamentos', desc: 'Marcar um orçamento como fechado.' },
          manageParameters: { label: 'Editar parâmetros dos orçamentos', desc: 'Alterar as margens, os padrões e as listas usadas pela calculadora de orçamentos.' },
          manageTeam: { label: 'Editar equipe e custos fixos', desc: 'Ver e alterar a planilha da equipe, com os salários individuais, e os custos fixos do escritório.' },
          generateProposal: { label: 'Gerar proposta', desc: 'Baixar a proposta do orçamento em PDF, no modelo do escritório, para enviar ao cliente.' },
        },
      },
      contracts: {
        label: 'Contratos',
        features: {
          read: { label: 'Ver contratos', desc: 'Ver a lista de contratos fechados e os dados de cada um.' },
          create: { label: 'Lançar contratos', desc: 'Incluir lançamentos avulsos de contratos, aditivos e m² excedente.' },
          edit: { label: 'Editar dados dos contratos', desc: 'Preencher e alterar número, contratante, valor, assinatura e demais dados dos contratos.' },
          delete: { label: 'Excluir lançamentos', desc: 'Remover lançamentos avulsos de contratos.' },
        },
      },
      contractForms: {
        label: 'Fichas para contrato',
        features: {
          read: { label: 'Ver fichas', desc: 'Abrir a ficha para contrato de um orçamento, com os dados do fechamento para o financeiro.' },
          edit: { label: 'Preencher fichas', desc: 'Preencher, salvar como rascunho e concluir fichas para contrato. Concluir marca o orçamento como Fechado (para isso também é preciso poder fechar orçamentos).' },
        },
      },
      clientRegistrations: {
        label: 'Cadastros de clientes',
        features: {
          read: { label: 'Ver cadastros', desc: 'Abrir o cadastro do cliente de um contrato: documentos, endereços e contatos de quem assina.' },
          edit: { label: 'Preencher cadastros', desc: 'Preencher, salvar como rascunho e concluir o cadastro do cliente.' },
        },
      },
      commercialDashboard: {
        label: 'Painel comercial',
        features: {
          read: { label: 'Ver painel comercial', desc: 'Ver os indicadores de propostas e contratos calculados a partir dos orçamentos e contratos.' },
        },
      },
      projectProfit: {
        label: 'Lucro por projeto',
        features: {
          read: { label: 'Ver lucro por projeto', desc: 'Ver a receita, os custos e o lucro de cada contrato, calculados a partir dos contratos, RT, Previsão, Movimentação e orçamentos.' },
        },
      },
      hours: {
        label: 'Horas',
        features: {
          read: { label: 'Visualizar', desc: 'Ver a página de horas e os próprios registros.' },
          manage: { label: 'Gerenciar', desc: 'Registrar, editar e excluir os próprios registros de horas.' },
          manageAll: { label: 'Gerenciar de todos', desc: 'Registrar, editar e excluir os registros de horas de qualquer usuário.' },
          report: { label: 'Relatório geral', desc: 'Ver as horas registradas de todos os usuários para análise.' },
          logLate: { label: 'Registrar fora do prazo', desc: 'Lançar e editar horas em datas fora do limite de dias configurado, mesmo com o bloqueio ativo.' },
        },
      },
      tokens: {
        label: 'Tokens de acesso',
        features: {
          manage: { label: 'Gerenciar', desc: 'Gerar e revogar tokens de acesso pessoais.' },
        },
      },
      settings: {
        label: 'Configurações gerais',
        features: {
          manage: { label: 'Gerenciar', desc: 'Editar as configurações gerais do sistema, como o limite de dias e o bloqueio de lançamentos de horas fora do prazo.' },
        },
      },
      billing: { label: 'Cobrança', features: {
        read:   { label: 'Visualizar', desc: 'Ver faturas e uso' },
        manage: { label: 'Gerenciar', desc: 'Alterar plano e formas de pagamento' },
      }},
      technicalReserves: {
        label: 'RT – reservas técnicas',
        features: {
          read: { label: 'Ver RTs', desc: 'Ver a aba RT no menu Comercial: indicadores, lista de RTs e totais por cliente, fornecedor, categoria e ano.' },
          create: { label: 'Lançar RTs', desc: 'Lançar novas RTs a receber.' },
          edit: { label: 'Editar RTs', desc: 'Alterar as datas, os valores e a situação das RTs na lista.' },
          delete: { label: 'Excluir RTs', desc: 'Remover RTs permanentemente.' },
          commissionRead: { label: 'Ver comissão da equipe', desc: 'Ver a comissão da equipe sobre as RTs recebidas em cada semestre e os pagamentos registrados.' },
          commissionPay: { label: 'Registrar pagamentos de comissão', desc: 'Registrar e excluir os pagamentos da comissão da equipe.' },
        },
      },
      supplierQuotes: {
        label: 'Controle de orçamentos',
        features: {
          read: { label: 'Ver orçamentos', desc: 'Ver a aba Controle de orçamentos do Relacionamento: os orçamentos pedidos a fornecedores e os totais por cliente e por fornecedor.' },
          create: { label: 'Lançar orçamentos', desc: 'Anotar novos orçamentos pedidos a fornecedores.' },
          edit: { label: 'Editar orçamentos', desc: 'Mudar o status, o valor, a data e a observação dos orçamentos e marcar como fechado (o que também gera a RT, para quem pode lançar RTs).' },
          delete: { label: 'Excluir orçamentos', desc: 'Remover orçamentos permanentemente.' },
        },
      },
      forecast: {
        label: 'Previsão',
        features: {
          read: { label: 'Ver previsão de entradas', desc: 'Ver a aba Previsão no menu Financeiro: parcelas a receber dos contratos, entradas avulsas e RTs previstas.' },
          manageReceivables: { label: 'Editar previsão de entradas', desc: 'Criar, alterar e excluir planos de recebimento e mudar a situação das parcelas.' },
          readPayables: { label: 'Ver previsão de saídas', desc: 'Ver as contas a pagar, com salários, pró-labore e contas pessoais das sócias.' },
          managePayables: { label: 'Editar previsão de saídas', desc: 'Lançar, alterar e excluir contas e registrar pagamentos.' },
          readCashFlow: { label: 'Ver fluxo de caixa', desc: 'Ver a previsão do fluxo de caixa, com os saldos bancários e os fundos de reserva.' },
          manageCashFlow: { label: 'Informar saldos', desc: 'Informar e apagar os saldos e os fundos de reserva de cada mês.' },
        },
      },
      financialEntries: {
        label: 'Movimentação',
        features: {
          read: { label: 'Ver movimentação', desc: 'Ver a aba Movimentação no menu Financeiro: lançamentos das contas PJ e PF, baixas na Previsão sem lançamento e resultado por categoria.' },
          create: { label: 'Lançar entradas e saídas', desc: 'Lançar entradas e saídas, dando baixa nas parcelas da Previsão de entradas e nas contas da Previsão de saídas.' },
          edit: { label: 'Editar lançamentos', desc: 'Alterar os lançamentos; a data e o valor de um lançamento que deu baixa também mudam na Previsão.' },
          delete: { label: 'Excluir lançamentos', desc: 'Excluir lançamentos; a parcela ou a conta que ele deu baixa volta a ficar em aberto na Previsão.' },
        },
      },
      closings: {
        label: 'Fechamentos',
        features: {
          read: { label: 'Ver fechamentos', desc: 'Ver a aba Fechamentos no menu Financeiro: o que foi fechado em cada mês do ano, em contratos, adicionais e m² excedente.' },
          editCategory: { label: 'Mudar a categoria', desc: 'Trocar a categoria de um fechamento entre contrato, adicionais e m² excedente.' },
        },
      },
      today: {
        label: 'Hoje',
        features: {
          read: { label: 'Ver o painel Hoje', desc: 'Ver a aba Hoje: as pendências e os números do dia. Cada quadro só aparece para quem tem acesso à tela de onde ele vem.' },
        },
      },
      cityHall: {
        label: 'Processos na prefeitura',
        features: {
          read: { label: 'Ver processos na prefeitura', desc: 'Ver a tela Processos na prefeitura: os processos em andamento, as fichas, o pós-alvará, os indicadores e os prazos.' },
          create: { label: 'Criar processos', desc: 'Cadastrar um novo processo na prefeitura.' },
          edit: { label: 'Registrar e editar (entradas, retornos, alvará, pós-alvará)', desc: 'Registrar entradas e retornos das análises, o alvará e o pós-alvará, e mudar os dados e as datas de um processo.' },
          delete: { label: 'Arquivar e recuperar', desc: 'Arquivar um processo e recuperá-lo da lista de arquivados.' },
          manageDeadlines: { label: 'Alterar os prazos', desc: 'Mudar o prazo padrão de análise da prefeitura, a forma de contar os dias e o prazo de cada cidade.' },
        },
      },
      detailingFlow: {
        label: 'Fluxo do projeto e detalhamento',
        features: {
          read: { label: 'Ver detalhamento e fluxo do projeto', desc: 'Ver as abas Detalhamento e Fluxo do projeto e a ficha de cada fluxo.' },
          create: { label: 'Incluir projetos no detalhamento', desc: 'Incluir um projeto no detalhamento com a data de aprovação do 3D e o prazo.' },
          edit: { label: 'Registrar no fluxo (entregas, reunião, documentos, condomínio, pausas)', desc: 'Mudar o status, registrar entregas, a reunião de conferência e as correções, pausar e retomar, marcar os documentos, acompanhar o condomínio e protocolar na prefeitura (que pede também a permissão de criar processos).' },
          delete: { label: 'Arquivar e recuperar fluxos', desc: 'Arquivar um fluxo e recuperá-lo da lista de arquivados.' },
          manageSettings: { label: 'Alterar os parâmetros do fluxo', desc: 'Mudar os nomes dos status, a lista de documentos e os prazos dos condomínios.' },
          approve3d: { label: 'Aprovar o 3D', desc: 'Usar o botão Aprovar 3D na página do projeto, na etapa Fachada: registra a data em que o cliente aprovou e coloca o projeto no detalhamento como A detalhar.' },
          newAlert: { label: 'Receber aviso de novos detalhamentos', desc: 'Ver na tela Hoje o aviso dos projetos A detalhar. Ligue só para a equipe de detalhamento.' },
        },
      },
      projectSchedule: {
        label: 'Prazos dos projetos',
        features: {
          read: { label: 'Ver os prazos', desc: 'Ver as abas Prazos e Resumo: as datas previstas e a situação de cada etapa dos projetos.' },
          edit: { label: 'Preencher e editar os prazos', desc: 'Preencher as datas de início, os prazos de cada etapa, as apresentações, aprovações e entregas, e os detalhamentos adicionais.' },
          personalizationAlert: { label: 'Receber aviso de 1ª análise para personalização', desc: 'Ver na tela Hoje os projetos cuja 1ª análise da prefeitura voltou, para agendar o briefing de pontos. Ligue só para a equipe de personalização / interiores.' },
        },
      },
    },
  },
  fases: {
    add: 'Adicionar etapa',
    empty: 'Nenhuma etapa cadastrada.',
    archived: 'Arquivada',
    archive: 'Arquivar',
    restore: 'Restaurar',
    rename: 'Renomear',
    collapseAll: 'Recolher tudo',
    expandAll: 'Expandir tudo',
    createError: 'Não foi possível criar a etapa',
    updateError: 'Não foi possível atualizar a etapa',
    nameTaken: 'Já existe uma etapa com esse nome',
    addSubphase: 'Adicionar subetapa',
    subphasesOne: '{count} subetapa',
    subphasesOther: '{count} subetapas',
    subphasesSectionTitle: 'Subetapas',
    activitiesCountOne: '{count} atividade',
    activitiesCountOther: '{count} atividades',
    newPhase: 'Nova etapa',
    reorderPhase: 'Reordenar etapa',
    hoursModeLabel: 'Horas padrão',
    hoursModeFixed: 'Fixas',
    hoursModeSum: 'Soma',
    delete: 'Excluir etapa',
    deleteTitle: 'Excluir etapa?',
    deleteArchivedTitle: 'Excluir etapa permanentemente?',
    deleteSuccess: 'Etapa excluída',
    deleteError: 'Não foi possível excluir a etapa',
    deleteInUse: 'Etapa em uso',
    activities: {
      title: 'Atividades',
      addRoot: 'Adicionar atividade',
      addChild: 'Adicionar subatividade',
      addPlaceholder: 'Nome da atividade',
      empty: 'Nenhuma atividade nesta etapa.',
      loadError: 'Não foi possível carregar as atividades',
      saveError: 'Não foi possível salvar a atividade',
      expand: 'Expandir',
      collapse: 'Recolher',
      moveEntries: 'Mover lançamentos',
      loggedHours: 'Lançadas {hours}: {name}',
      delete: 'Excluir atividade',
      deleteTitle: 'Excluir atividade?',
      deleteArchivedTitle: 'Excluir atividade permanentemente?',
      deleteSuccess: 'Atividade excluída',
      deleteError: 'Não foi possível excluir a atividade',
      deleteInUse: 'Atividade em uso',
    },
    propagate: {
      title: 'Incluir "{name}" em projetos?',
      serviceLine: 'Serviço: {service}',
      parentLine: 'Etapa superior: {name}',
      missingParent: 'etapa superior ausente',
      noStatus: 'Sem status',
      // Same wording as roles.selectAll, kept as its own key so the two screens stay independent.
      selectAll: 'Selecionar tudo',
      selectedOne: '{count} de {total} selecionado',
      selectedOther: '{count} de {total} selecionados',
      confirm: 'Incluir',
      cancel: 'Cancelar',
      loadError: 'Etapa criada, mas não foi possível carregar os projetos',
      error: 'Não foi possível incluir a etapa nos projetos',
    },
  },
  projectItems: {
    bannerTitle: 'Ambientes',
    bannerSubtitle: 'Ambientes reutilizáveis que adicionam etapas e atividades a um projeto',
    newItem: 'Novo ambiente',
    newItemName: 'Novo ambiente',
    searchPlaceholder: 'Buscar ambientes',
    showInactive: 'Mostrar inativos',
    empty: 'Nenhum ambiente cadastrado.',
    selectPrompt: 'Selecione um ambiente',
    namePlaceholder: 'Nome',
    descPlaceholder: 'Descrição',
    detailTitle: 'Detalhes do ambiente',
    servicesHeading: 'Serviços',
    servicesHint: 'Cada serviço adiciona suas etapas e atividades ao projeto',
    addService: 'Adicionar serviço',
    removeService: 'Remover serviço',
    serviceSelect: 'Selecione um serviço',
    noServices: 'Nenhum serviço ainda. Adicione o primeiro abaixo.',
    phasesHeading: 'Etapas e atividades',
    phasesHint: 'Adicionadas a um projeto quando o ambiente é aplicado',
    addPhase: 'Adicionar etapa',
    addSubphase: 'Adicionar subetapa',
    subphaseNamePlaceholder: 'Nome da subetapa',
    addActivity: 'Adicionar atividade',
    noActivities: 'Nenhuma atividade ainda.',
    noPhases: 'Nenhuma etapa ainda. Adicione a primeira abaixo.',
    phasePlaceholder: 'Selecione uma etapa',
    save: 'Salvar alterações',
    cancel: 'Cancelar',
    unsaved: 'Você tem alterações não salvas',
    delete: 'Excluir ambiente',
    deleteTitle: 'Excluir ambiente?',
    deleteArchivedTitle: 'Excluir ambiente permanentemente?',
    deleteError: 'Não foi possível excluir o ambiente',
    deleteInUse: 'O ambiente está em uso e não pode ser excluído permanentemente',
    archive: 'Arquivar',
    restore: 'Restaurar',
    toastSaved: 'Ambiente salvo',
    toastDeleted: 'Ambiente excluído permanentemente',
    createError: 'Não foi possível criar o ambiente',
    updateError: 'Não foi possível salvar o ambiente',
    countPhasesOne: '{count} etapa',
    countPhasesOther: '{count} etapas',
    countActivitiesOne: '{count} atividade',
    countActivitiesOther: '{count} atividades',
    addSubActivity: 'Adicionar subatividade',
    removeActivity: 'Remover atividade',
    removePhase: 'Remover etapa',
    activityPlaceholder: 'Nome da atividade',
    duplicate: 'Duplicar ambiente',
    copySuffix: '(cópia)',
    changePhase: 'Alterar etapa',
    hoursModeFromServiceTip: 'O modo de horas é definido na etapa do serviço. Para alterar, edite a etapa em Serviços.',
    hoursFromServiceTip: 'Horas definidas na etapa do serviço.',
    hoursSumTip: 'Soma das atividades e subetapas.',
    activitiesTitle: 'Atividades',
    renameActivity: 'Renomear',
    duplicateActivity: 'Duplicar atividade',
    dragActivity: 'Arrastar para mover',
    dragItemGroup: 'Arrastar grupo do ambiente',
    activityMoved: 'Atividade movida',
    expand: 'Expandir',
    collapse: 'Recolher',
    collapseAll: 'Recolher tudo',
    expandAll: 'Expandir tudo',
  },
  templates: {
    bannerTitle: 'Modelos',
    bannerSubtitle: 'Modelos reutilizáveis que pré-configuram um novo projeto',
    newTemplate: 'Novo modelo',
    newTemplateName: 'Novo modelo',
    searchPlaceholder: 'Buscar modelos',
    empty: 'Nenhum modelo cadastrado.',
    selectPrompt: 'Selecione um modelo',
    namePlaceholder: 'Nome',
    descPlaceholder: 'Descrição',
    detailTitle: 'Detalhes do modelo',
    statusHeading: 'Status padrão',
    servicesHeading: 'Serviços',
    itemsHeading: 'Ambientes',
    tagsHeading: 'Etiquetas',
    addService: 'Adicionar serviço',
    reorderService: 'Reordenar {name}',
    serviceDragHint: 'Arraste para reordenar, ou Alt+setas',
    serviceReordered: '{name} movido para a posição {position} de {total}',
    expandPhases: 'Ver fases de {name}',
    collapsePhases: 'Ocultar fases de {name}',
    phasesLoadError: 'Não foi possível carregar as fases',
    excludePhase: 'Excluir {name} deste modelo',
    restorePhase: 'Restaurar {name} neste modelo',
    excludedPhaseHint: 'Excluída deste modelo',
    addItem: 'Adicionar ambiente',
    itemDescriptionLabel: 'Descrição',
    itemDescriptionPlaceholder: 'Como este ambiente se aplica ao projeto',
    remove: 'Remover',
    restore: 'Restaurar',
    delete: 'Excluir',
    save: 'Salvar',
    cancel: 'Cancelar',
    createError: 'Não foi possível criar o modelo',
    updateError: 'Não foi possível salvar o modelo',
    toastSaved: 'Modelo salvo',
    countServicesOne: '{count} serviço',
    countServicesOther: '{count} serviços',
    countItemsOne: '{count} ambiente',
    countItemsOther: '{count} ambientes',
  },
  servicos: {
    bannerTitle: 'Serviços',
    bannerSubtitle: 'Cada serviço define a sua própria árvore de etapas.',
    addPlaceholder: 'Descrição do novo serviço',
    add: 'Adicionar serviço',
    empty: 'Nenhum serviço cadastrado.',
    description: 'Descrição',
    archived: 'Arquivada',
    archive: 'Arquivar',
    restore: 'Restaurar',
    templateHeading: 'Etapas do serviço',
    save: 'Salvar serviço',
    toastSaved: 'Serviço salvo',
    createError: 'Não foi possível criar o serviço',
    updateError: 'Não foi possível atualizar o serviço',
    customFieldsHeading: 'Campos personalizados do serviço',
    detailTabPhases: 'Etapas',
    detailTabCustomFields: 'Campos personalizados',
    detailTabsAriaLabel: 'Seções do serviço',
    delete: 'Excluir serviço',
    deleteTitle: 'Excluir serviço?',
    deleteArchivedTitle: 'Excluir serviço permanentemente?',
    deleteSuccess: 'Serviço excluído',
    deleteError: 'Não foi possível excluir o serviço',
    deleteInUse: 'Serviço em uso',
  },
  etiquetas: {
    bannerTitle: 'Etiquetas',
    bannerSubtitle: 'Crie etiquetas coloridas para classificar seus projetos.',
    namePlaceholder: 'Nome da nova etiqueta',
    add: 'Adicionar etiqueta',
    empty: 'Nenhuma etiqueta cadastrada.',
    name: 'Nome',
    color: 'Cor',
    archive: 'Arquivar',
    restore: 'Restaurar',
    save: 'Salvar etiqueta',
    toastSaved: 'Etiqueta salva',
    createError: 'Não foi possível criar a etiqueta',
    updateError: 'Não foi possível atualizar a etiqueta',
  },
  cargos: {
    bannerTitle: 'Cargos',
    bannerSubtitle: 'Cargos disponíveis para o histórico de pagamento dos usuários.',
    namePlaceholder: 'Nome do novo cargo',
    add: 'Adicionar cargo',
    empty: 'Nenhum cargo cadastrado.',
    name: 'Nome',
    archive: 'Arquivar',
    restore: 'Restaurar',
    save: 'Salvar cargo',
    toastSaved: 'Cargo salvo',
    createError: 'Não foi possível criar o cargo',
    updateError: 'Não foi possível atualizar o cargo',
  },
  feriados: {
    bannerTitle: 'Feriados',
    bannerSubtitle: 'Calendário de feriados e dias não úteis da empresa.',
    add: 'Adicionar feriado',
    empty: 'Nenhum feriado cadastrado.',
    emptyActive: 'Nenhum feriado ativo. Todos os dias de semana estão sendo tratados como dias úteis.',
    name: 'Nome',
    namePlaceholder: 'Nome do feriado',
    kind: 'Tipo',
    kindFixed: 'Data fixa anual',
    kindEaster: 'Derivado da Páscoa',
    kindOneOff: 'Data pontual',
    fieldMonthDay: 'Dia e mês',
    fieldOffset: 'Deslocamento da Páscoa (dias)',
    fieldDate: 'Data',
    showArchived: 'Mostrar arquivados',
    archive: 'Arquivar',
    restore: 'Restaurar',
    save: 'Salvar feriado',
    toastSaved: 'Feriado salvo',
    createError: 'Não foi possível salvar. Tente novamente.',
    updateError: 'Não foi possível salvar. Tente novamente.',
    readOnlyHint: 'Você não tem permissão para gerenciar feriados.',
    retroTitle: 'Alteração retroativa',
    retroMessage: 'Este feriado é anterior a hoje. Saldos e pendências de meses já encerrados serão recalculados.',
    retroConfirm: 'Confirmar',
    retroCancel: 'Cancelar',
    calendar: {
      caption: '{month} {year}',
      months: {
        '1': 'Janeiro', '2': 'Fevereiro', '3': 'Março', '4': 'Abril', '5': 'Maio', '6': 'Junho',
        '7': 'Julho', '8': 'Agosto', '9': 'Setembro', '10': 'Outubro', '11': 'Novembro', '12': 'Dezembro',
      },
      weekdaysShort: {
        '0': 'Dom', '1': 'Seg', '2': 'Ter', '3': 'Qua', '4': 'Qui', '5': 'Sex', '6': 'Sáb',
      },
      weekdaysLong: {
        '0': 'Domingo', '1': 'Segunda-feira', '2': 'Terça-feira', '3': 'Quarta-feira', '4': 'Quinta-feira', '5': 'Sexta-feira', '6': 'Sábado',
      },
      prevMonth: 'Mês anterior',
      nextMonth: 'Mês seguinte',
      prevYear: 'Ano anterior',
      nextYear: 'Ano seguinte',
      gridLabel: 'Calendário de {month} de {year}',
      dayLabel: '{weekday}, {date}',
      dayLabelHoliday: '{weekday}, {date} · feriado: {names}',
      dayLabelToday: 'Hoje, {label}',
      namesSeparator: ', ',
    },
    yearList: {
      title: 'Feriados em {year}',
      empty: 'Nenhum feriado ativo neste ano.',
    },
    archivedSection: {
      title: 'Arquivados',
      expand: 'Mostrar arquivados',
      collapse: 'Ocultar arquivados',
      empty: 'Nenhum feriado arquivado.',
    },
  },
  modelosDeTrabalho: {
    bannerTitle: 'Modelos de trabalho',
    bannerSubtitle: 'Catálogo de modelos de trabalho disponíveis para lançamentos de horas.',
    add: 'Adicionar modelo de trabalho',
    empty: 'Nenhum modelo de trabalho cadastrado.',
    emptyActive: 'Nenhum modelo de trabalho ativo.',
    name: 'Nome',
    namePlaceholder: 'Nome do modelo de trabalho',
    hoursKind: 'Carga horária',
    hoursKindWorked: 'Hora trabalhada',
    hoursKindDiscount: 'Desconto',
    hoursKindExcused: 'Abono',
    vt: 'VT',
    vr: 'VR',
    showArchived: 'Mostrar arquivados',
    archive: 'Arquivar',
    restore: 'Restaurar',
    save: 'Salvar modelo de trabalho',
    toastSaved: 'Modelo de trabalho salvo',
    createError: 'Não foi possível criar o modelo de trabalho',
    updateError: 'Não foi possível atualizar o modelo de trabalho',
    readOnlyHint: 'Você não tem permissão para gerenciar modelos de trabalho.',
  },
  tiposDeDespesa: {
    bannerTitle: 'Tipos de despesa',
    bannerSubtitle: 'Catálogo de tipos de despesa disponíveis para lançamentos de reembolso.',
    add: 'Adicionar tipo de despesa',
    empty: 'Nenhum tipo de despesa cadastrado.',
    emptyActive: 'Nenhum tipo de despesa ativo.',
    name: 'Nome',
    namePlaceholder: 'Nome do tipo de despesa',
    calcKind: 'Cálculo',
    calcKindDistance: 'Por quilometragem',
    calcKindAmount: 'Por valor',
    showArchived: 'Mostrar arquivados',
    archive: 'Arquivar',
    restore: 'Restaurar',
    save: 'Salvar tipo de despesa',
    toastSaved: 'Tipo de despesa salvo',
    createError: 'Não foi possível criar o tipo de despesa',
    updateError: 'Não foi possível atualizar o tipo de despesa',
    readOnlyHint: 'Você não tem permissão para gerenciar tipos de despesa.',
  },
  valorDoKm: {
    bannerTitle: 'Valor do KM',
    bannerSubtitle: 'Vigências da taxa paga por quilômetro rodado. Cada dia usa a vigência que o cobre — ou, na falta de uma, a última cadastrada antes dele.',
    add: 'Adicionar vigência',
    empty: 'Nenhuma vigência cadastrada.',
    startDate: 'Início',
    endDate: 'Fim',
    endDateOpenPlaceholder: 'Em vigor',
    rate: 'Valor por km',
    delete: 'Excluir',
    save: 'Salvar vigência',
    toastSaved: 'Vigência salva',
    toastDeleted: 'Vigência excluída',
    createError: 'Não foi possível criar a vigência',
    updateError: 'Não foi possível atualizar a vigência',
    deleteError: 'Não foi possível excluir a vigência',
    readOnlyHint: 'Você não tem permissão para gerenciar o valor do km.',
    dialogs: {
      deleteTitle: 'Excluir vigência',
      deleteDesc: 'Essa vigência será removida do cadastro. Lançamentos já registrados mantêm o valor aplicado na época.',
    },
    cancel: 'Cancelar',
  },
  status: {
    bannerTitle: 'Status de projeto',
    bannerSubtitle: 'Lista de status configuráveis usados pelos projetos.',
    addPlaceholder: 'Rótulo do novo status',
    add: 'Adicionar status',
    empty: 'Nenhum status cadastrado.',
    label: 'Rótulo',
    color: 'Cor',
    default: 'Padrão',
    setDefault: 'Definir como padrão',
    closed: 'Concluído (encerra o projeto)',
    moveUp: 'Mover para cima',
    moveDown: 'Mover para baixo',
    archived: 'Arquivado',
    archive: 'Arquivar',
    restore: 'Restaurar',
    createError: 'Não foi possível criar o status',
    updateError: 'Não foi possível atualizar o status',
    defaultArchiveError: 'Defina outro status como padrão antes de arquivar este',
  },
  activityStatus: {
    bannerTitle: 'Situações de atividade',
    bannerSubtitle: 'Lista de situações configuráveis usadas pelas atividades dos projetos.',
    addPlaceholder: 'Rótulo da nova situação',
    add: 'Adicionar situação',
    empty: 'Nenhuma situação cadastrada.',
    color: 'Cor',
    icon: 'Ícone',
    iconPicker: 'Escolher ícone',
    default: 'Padrão',
    done: 'Concluída (encerra a atividade)',
    blocked: 'Bloqueada (trabalho travado)',
    moveUp: 'Mover para cima',
    moveDown: 'Mover para baixo',
    archive: 'Arquivar',
    restore: 'Restaurar',
    createError: 'Não foi possível criar a situação',
    updateError: 'Não foi possível atualizar a situação',
    defaultArchiveError: 'Defina outra situação como padrão antes de arquivar esta',
    loadError: 'Não foi possível carregar as situações',
  },
  customFields: {
    bannerTitle: 'Campos personalizados',
    bannerSubtitle: 'Campos extras exibidos em todos os projetos.',
    addPlaceholder: 'Rótulo do novo campo',
    add: 'Adicionar campo',
    empty: 'Nenhum campo personalizado.',
    label: 'Rótulo',
    type: 'Tipo',
    required: 'Obrigatório',
    options: 'Opções',
    optionPlaceholder: 'Nova opção',
    addOption: 'Adicionar opção',
    removeOption: 'Remover opção',
    archive: 'Arquivar',
    restore: 'Restaurar',
    save: 'Salvar campo',
    createError: 'Não foi possível criar o campo',
    updateError: 'Não foi possível atualizar o campo',
    sectionHeading: 'Campos personalizados',
    selectPlaceholder: 'Selecione...',
    defaultValue: 'Valor padrão',
    defaultValueHint: 'Valor a ser preenchido na criação de novos projectos ou serviços.',
    orderHint: 'Arraste os campos para definir a ordem em que aparecem.',
    reorderField: 'Reordenar {name}',
    dragHint: 'Arraste para reordenar, ou use Alt com as setas para cima e para baixo.',
    fieldReordered: '{name} movido para a posição {position} de {total}',
    reorderError: 'Não foi possível salvar a nova ordem',
    types: {
      TEXT: 'Texto',
      LONG_TEXT: 'Texto longo',
      NUMBER: 'Número',
      DATE: 'Data',
      SELECT: 'Seleção',
      MULTI_SELECT: 'Múltipla escolha',
    },
    entity: { project: 'Projetos', contactPerson: 'Pessoas', contactCompany: 'Empresas', contactGroup: 'Grupos' },
  },
  tokens: {
    bannerTitle: 'Tokens de acesso',
    bannerSubtitle: 'Gere tokens para conectar o allmanager ao Claude ou ChatGPT.',
    generate: 'Gerar token',
    labelPlaceholder: 'Nome do token (ex.: Claude no meu notebook)',
    created: 'Token criado — copie agora, ele não será exibido novamente.',
    copy: 'Copiar',
    copied: 'Copiado!',
    revoke: 'Revogar',
    empty: 'Nenhum token ativo.',
    neverUsed: 'Nunca usado',
    lastUsed: 'Último uso: {when}',
    createError: 'Não foi possível gerar o token',
    revokeError: 'Não foi possível revogar o token',
    oauthConnection: 'Conexão de aplicativo (OAuth)',
  },
  users: {
    bannerTitle: 'Usuários',
    bannerSubtitle: '{count} membros · {active} ativos · {pending} pendentes',
    membersSummary: '{count} membros · {active} ativos',
    inviteUser: 'Convidar usuário',
    searchPlaceholder: 'Buscar usuários',
    noResults: 'Nenhum usuário encontrado.',
    resizeList: 'Redimensionar lista',
    selectPrompt: 'Selecione um usuário',
    detailsTitle: 'Detalhes do usuário',
    removeUser: 'Remover usuário',
    role: 'Perfil',
    accountActive: 'Conta ativa',
    accountActiveDesc: 'Usuários inativos não podem acessar o workspace.',
    lastActive: 'Último acesso',
    joined: 'Ingressou em',
    never: 'Nunca',
    removeTitle: 'Remover usuário',
    removeDesc: 'Remove este usuário permanentemente. Esta ação não pode ser desfeita.',
    remove: 'Remover',
    back: 'Voltar',
    save: 'Salvar alterações',
    cancel: 'Cancelar',
    unsaved: 'Há alterações não salvas',
    notFound: 'Usuário não encontrado',
    emailTaken: 'Já existe um usuário com este e-mail.',
    toastSaved: 'Alterações salvas',
    toastSaveError: 'Não foi possível salvar o usuário',
    toastDeleteError: 'Não foi possível remover o usuário',
    toastLoadError: 'Não foi possível carregar os usuários',
    toastInvited: 'Convite enviado',
    regenerateLink: 'Gerar novo link de acesso',
    regenerateConfirm: 'Gerar um novo link cancela o link anterior. Continuar?',
    regenerateSuccess: 'Novo link gerado',
    regenerateError: 'Não foi possível gerar o link',
    filters: {
      status: 'Status',
      role: 'Perfil',
      all: 'Todos',
      active: 'Ativos',
      pending: 'Pendentes',
      inactive: 'Inativos',
    },
    status: {
      active: 'Ativo',
      pending: 'Pendente',
      inactive: 'Inativo',
    },
    invite: {
      title: 'Convidar usuário',
      subtitle: 'Um e-mail de convite será enviado para o endereço abaixo.',
      email: 'E-mail',
      fullName: 'Nome completo',
      optional: 'Opcional',
      emailPlaceholder: 'colega@empresa.com',
      role: 'Perfil',
      note: 'O usuário convidado receberá um e-mail com um link para configurar a conta. Convites pendentes expiram após 7 dias.',
      send: 'Enviar convite',
    },
    payroll: {
      title: 'Histórico de pagamento',
      addRecord: 'Adicionar registro',
      current: 'Atual',
      ongoing: 'em vigor',
      jobRole: 'Cargo',
      earningType: 'Tipo de remuneração',
      earningTypeHourly: 'Valor por hora',
      earningTypeMonthly: 'Remuneração mensal',
      startDate: 'Data inicial',
      endDate: 'Data final',
      hourlyRate: 'Valor por hora',
      monthly: 'Mensal',
      formMonthly: 'Remuneração mensal',
      hoursPerDay: 'Horas/dia',
      formHoursPerDay: 'Horas por dia',
      vr: 'VR',
      formVr: 'Valor VR (diário)',
      vt: 'VT',
      formVt: 'Valor VT (diário)',
      advances: 'Adiantamentos',
      advancesVr: 'Adianta VR',
      advancesVt: 'Adianta VT',
      advancesNone: 'Nenhum',
      edit: 'Editar registro',
      delete: 'Remover registro',
      dialogTitle: 'Registro de pagamento',
      saveRecord: 'Salvar registro',
      deleteTitle: 'Remover registro',
      deleteDesc: 'Remove este registro de pagamento permanentemente. Esta ação não pode ser desfeita.',
      saveError: 'Não foi possível salvar o registro',
      deleteError: 'Não foi possível remover o registro',
      loadError: 'Não foi possível carregar o histórico de pagamento',
      notFound: 'Registro de pagamento não encontrado',
      empty: 'Nenhum registro de pagamento ainda.',
      errors: {
        START_DATE_NOT_AFTER_CURRENT: 'A data de início deve ser posterior à data de início do registro atual.',
        START_DATE_OUT_OF_BOUNDS: 'A data de início deve ficar entre os registros vizinhos.',
      },
    },
  },
  earnings: {
    title: 'Proventos e Descontos',
    subtitle: 'Lançamentos avulsos da equipe: bônus, horas extras, vales e descontos.',
    newEntry: 'Novo lançamento',
    saveEntry: 'Salvar lançamento',
    addEntry: 'Adicionar lançamento',
    editEntry: 'Editar lançamento',
    deleteEntry: 'Remover lançamento',
    cancel: 'Cancelar',
    saved: 'Lançamento salvo',
    deleted: 'Lançamento removido',
    searchPlaceholder: 'Buscar por descrição ou membro',
    empty: 'Nenhum lançamento encontrado.',
    loadError: 'Não foi possível carregar os lançamentos',
    saveError: 'Não foi possível salvar o lançamento',
    deleteError: 'Não foi possível remover o lançamento',
    notFound: 'Lançamento não encontrado',
    deleteTitle: 'Remover lançamento',
    deleteDesc: 'Remove este lançamento permanentemente. Esta ação não pode ser desfeita.',
    resultCount_one: '{count} lançamento',
    resultCount_other: '{count} lançamentos',
    totalEarnings: 'Proventos {value}',
    totalDeductions: 'Descontos {value}',
    balance: 'Saldo {value}',
    filters: {
      allTypes: 'Todos os tipos',
      earnings: 'Proventos',
      deductions: 'Descontos',
      allMembers: 'Todos os membros',
      search: 'Buscar…',
      noResults: 'Nada encontrado',
      week: 'Esta semana',
      month: 'Este mês',
      year: 'Este ano',
      custom: 'Personalizado',
      from: 'De',
      to: 'Até',
      apply: 'Aplicar',
    },
    fields: {
      member: 'Membro',
      date: 'Data',
      type: 'Tipo',
      description: 'Descrição',
      descriptionPlaceholder: 'Ex.: bônus de entrega, vale adiantado',
      value: 'Valor',
    },
    type: {
      ganho: 'Provento',
      desconto: 'Desconto',
    },
    table: {
      date: 'Data',
      member: 'Membro',
      type: 'Tipo',
      description: 'Descrição',
      value: 'Valor',
    },
  },
  reembolsos: {
    title: 'Reembolsos',
    subtitle: 'Lançamentos de despesas de reembolso da equipe.',
    /** Banner subtitle when a single member is in view (`?userId=` set). `{rate}` arrives already suffixed — "R$ 1,70/km" — or as `rateMissing`. */
    bannerSubtitleMember: '{name} · {count} · taxa de combustível {rate}',
    bannerSubtitleAll: '{count} · taxa de combustível {rate}',
    entryCount_one: '{count} lançamento',
    entryCount_other: '{count} lançamentos',
    /** `{rate}` in the banner subtitles when no km rate covers the month — reads "taxa de combustível não configurada". */
    rateMissing: 'não configurada',
    rateHint: 'taxa {value}/km',
    memberPlaceholder: 'Selecionar membro…',
    memberSearchPlaceholder: 'Buscar membro…',
    memberEmpty: 'Nenhum membro encontrado',
    projectPlaceholder: 'Selecionar projeto…',
    projectSearchPlaceholder: 'Buscar projeto…',
    projectEmpty: 'Nenhum projeto encontrado',
    newEntry: 'Novo lançamento',
    newReimbursement: 'Novo reembolso',
    saveEntry: 'Salvar lançamento',
    editEntry: 'Editar lançamento',
    archiveEntry: 'Remover lançamento',
    cancel: 'Cancelar',
    saved: 'Lançamento salvo',
    archived: 'Lançamento removido',
    empty: 'Nenhum lançamento encontrado para os filtros selecionados.',
    loadError: 'Não foi possível carregar os lançamentos',
    saveError: 'Não foi possível salvar o lançamento',
    notFound: 'Lançamento não encontrado',
    noProject: '',
    prevMonth: 'Mês anterior',
    nextMonth: 'Próximo mês',
    /** R6: the system has no way of noticing the same expense paid again as a provento. */
    manualPaymentNotice: 'O pagamento em Proventos e Descontos, se houver, é manual.',
    /** No approval workflow — the only edit/archive gate is the month lock in `isEntryEditable`. */
    notCurrentMonthHint: 'Lançamentos de meses anteriores só podem ser editados ou removidos no mês em que foram criados ou por um gestor.',
    dialogs: {
      archiveTitle: 'Remover lançamento?',
      archiveDesc: 'O lançamento deixa de aparecer na lista, mas o registro é preservado.',
    },
    filters: {
      month: 'Mês',
      allMembers: 'Todos os membros',
      allProjects: 'Todos os projetos',
      search: 'Buscar…',
      noResults: 'Nada encontrado',
      /** The sidebar's projeto → categoria tree; each node shows the sum of its reimbursements. */
      tree: 'Projetos e categorias',
      all: 'Todos',
      /** The tree node for the entries logged with no project. */
      noProject: 'Sem projeto',
      expand: 'Expandir {name}',
      collapse: 'Recolher {name}',
    },
    fields: {
      member: 'Membro',
      date: 'Data',
      project: 'Projeto',
      expenseType: 'Tipo de despesa',
      purpose: 'Finalidade',
      documentNumber: 'Nº do documento',
      route: 'Trecho',
      km: 'Quilometragem',
      value: 'Valor',
      appliedRate: 'Taxa aplicada',
      loggedBy: 'Lançado por',
    },
    totals: {
      km: 'Quilometragem {value}',
      value: 'Valor {value}',
      byMember: 'Total por membro',
    },
    stats: {
      total: 'Total do mês',
      km: 'Quilometragem',
      kmValue: '{value} km',
    },
    export: {
      action: 'Exportar PDF',
      actionXlsx: 'Exportar Excel',
      pdf: {
        docTitle: 'Relatório de Reembolsos',
        pageTitle: 'RELATÓRIO DE REEMBOLSOS',
        periodLabel: 'PERÍODO',
        memberLabel: 'MEMBRO',
        projectLabel: 'PROJETO',
        allPeriods: 'Todos os períodos',
        allMembers: 'Todos os membros',
        allProjects: 'Todos os projetos',
        statCount: 'REGISTROS',
        statTotalKm: 'TOTAL EM KM',
        statTotalValue: 'TOTAL EM VALOR',
        colDate: 'DATA',
        colMember: 'MEMBRO',
        colProject: 'PROJETO',
        colExpenseType: 'TIPO',
        colPurpose: 'FINALIDADE',
        colDocumentNumber: 'Nº DOC.',
        colRoute: 'TRECHO',
        colKm: 'KM',
        colAppliedRate: 'TAXA',
        colValue: 'VALOR',
        totalRowLabel: 'Total do período',
      },
      xlsx: {
        sheetName: 'Reembolsos',
        colDate: 'Data',
        colMember: 'Membro',
        colProject: 'Projeto',
        colExpenseType: 'Tipo',
        colPurpose: 'Finalidade',
        colDocumentNumber: 'Nº documento',
        colRoute: 'Trecho',
        colKm: 'KM',
        colAppliedRate: 'Taxa (R$/km)',
        colValue: 'Valor (R$)',
        totalRowLabel: 'Total',
      },
    },
  },
  adminActivities: {
    bannerTitle: 'Atividades administrativas',
    bannerSubtitle: 'Atividades que não pertencem a nenhum projeto — reuniões internas, treinamentos, ausências.',
    treeTitle: 'Árvore de atividades',
    empty: 'Nenhuma atividade administrativa ainda. Adicione a primeira abaixo.',
    addRoot: 'Adicionar atividade',
    addChild: 'Adicionar subatividade',
    addPlaceholder: 'Nome da atividade',
    expand: 'Expandir',
    collapse: 'Recolher',
    rename: 'Renomear',
    archive: 'Arquivar',
    restore: 'Restaurar',
    archived: 'Arquivadas',
    loadError: 'Não foi possível carregar as atividades administrativas.',
    saveError: 'Não foi possível salvar a atividade.',
    /** The pseudo-project label shown in both reports and in the hours log. */
    pseudoProjectName: 'Horas administrativas',
    /** Muted badge marking the pseudo-project as not a real project. */
    badge: 'Administrativo',
    delete: 'Excluir atividade',
    deleteTitle: 'Excluir atividade?',
    deleteArchivedTitle: 'Excluir atividade permanentemente?',
    deleteSuccess: 'Atividade excluída',
    deleteError: 'Não foi possível excluir a atividade',
    deleteInUse: 'Atividade em uso',
  },
  contractForms: {
    title: 'Ficha para contrato',
    dialogAria: 'Ficha para contrato de {client}',
    close: 'Fechar ficha',
    loading: 'Carregando a ficha…',
    discardWarning: 'Há alterações não salvas. Feche de novo para descartar.',
    loadError: 'Não foi possível carregar a ficha.',
    legend: 'Os itens já vêm preenchidos com o que está no orçamento. Confira e ajuste o que foi negociado.',
    notClosed: 'Este orçamento está como {status}. Ao concluir a ficha, ele passa para Fechado, com a data de aprovação informada aqui.',
    cannotClose: 'Para concluir a ficha é preciso poder fechar orçamentos, porque ela marca o orçamento como Fechado.',
    stateNew: 'Nova',
    stateDraft: 'Rascunho',
    stateCompleted: 'Concluída',
    stateCompletedOn: 'Concluída em {date}',
    saveDraft: 'Salvar rascunho',
    complete: 'Concluir ficha',
    saveChanges: 'Salvar alterações',
    saving: 'Salvando…',
    copy: 'Copiar ficha',
    copied: 'Ficha copiada.',
    copyError: 'Não foi possível copiar a ficha.',
    draftSaved: 'Rascunho da ficha salvo.',
    completed: 'Ficha concluída. Orçamento marcado como Fechado.',
    updated: 'Ficha atualizada.',
    saveError: 'Não foi possível salvar a ficha. Tente novamente.',
    missing: 'Falta preencher: {items}',
    missingTag: 'falta preencher',
    unsaved: 'Alterações não salvas',
    contactName: 'Nome',
    contactPhone: 'Telefone',
    readOnly: 'Você pode ver a ficha, mas não preenchê-la.',
    copyHeader: 'FICHA PARA CONTRATO – {client}',
    copyDate: 'Penha Moraes Arquitetura · {date}',
    empty: '–',
    sections: {
      client: 'Cliente e contato',
      project: 'Projeto',
      commercial: 'Fechamento comercial',
      scope: 'Escopo contratado',
      nextSteps: 'Próximos passos e documentos',
    },
    other: 'Outro',
    reference: {
      budget: 'Considerado no orçamento',
      proposal: 'Previsto na proposta',
      commission: '{percent} para {name}',
      commissionPercent: '% prevista: {percent}',
      commissionTo: 'Para quem: {name}',
      commissionNoName: 'não informado no orçamento',
      noCommission: 'Sem comissão de indicação',
      taxes: 'Nota fiscal (impostos) prevista: {percent}',
      taxesValue: '{percent} sobre {total} = {value}',
      taxesMissing: 'Para calcular, informe o valor fechado (item 11).',
      noTaxes: 'Sem impostos de nota fiscal na composição',
      deadline: '{stage}: {text}',
      area: '{area} m²',
      perM2: '{name}: {value} por m²',
      overArea: 'Novo valor do m² excedente: {value} ({total} ÷ {area} m²)',
      overAreaMissing: 'Para calcular, informe o valor fechado (item 11) e os m² contratados (item 16).',
    },
    value: {
      negotiated: 'Valor negociado',
      notNegotiated: 'Ainda não negociado',
      negotiatedDetail: 'Valor negociado (R$)',
      option: '{name} – {total}',
    },
    docOptions: {
      yesRequest: 'Sim - Solicitar para cliente nos enviar',
      yesSent: 'Sim - Cliente já nos enviou',
      noTeam: 'Não - equipe pode pedir ao cliente ou orientar como proceder',
      noCondoWorks: 'Não - não tem como pedir pois condomínio em obras ainda',
      noOther: 'Não - não tem como pedir por outros motivos (descreva no campo abaixo quais motivos)',
      na: 'Não se aplica',
      other: 'Outro',
    },
    docDetails: {
      noOther: 'Quais motivos?',
      other: 'Descreva',
    },
    questions: {
      projectName: { label: 'Nome do projeto', hint: 'Favor informar o nome do casal, se souber' },
      phone: { label: 'Contato do cliente (telefone)', placeholder: '(41) 99999-9999' },
      initialContact: { label: 'Com quem devo falar (contato inicial)' },
      origin: { label: 'Origem do cliente', details: { other: 'Qual?' } },
      referredBy: { label: 'Indicado por', placeholder: 'Nome de quem indicou' },
      commission: { label: 'Comissão por indicação?', options: { yes: 'Sim', no: 'Não', toConfirm: 'A confirmar' } },
      commissionValue: {
        label: 'Comissão: valor e para quem pagar',
        options: { asCalculated: 'Conforme calculado', different: 'Valor diferente', other: 'Outro' },
        details: { different: 'Valor e para quem pagar', other: 'Descreva' },
        percent: 'Comissão (%)',
        percentPlaceholder: 'Ex.: 5',
        to: 'Para quem pagar',
        toPlaceholder: 'Nome de quem recebe',
      },
      purpose: {
        label: 'Finalidade do projeto',
        options: { familyHome: 'Casa da Família', investor: 'Investidor', commercial: 'Uso Comercial', other: 'Outro' },
        details: { other: 'Qual?' },
      },
      projectType: { label: 'Tipo do projeto', details: { other: 'Qual?' } },
      approvalDate: { label: 'Data da aprovação da proposta', hint: 'Vem com a data em que o orçamento foi fechado (ou a de hoje). Confirme se é a data em que o cliente aprovou a proposta.' },
      contractDate: {
        label: 'Data do contrato',
        options: { sameAsApproval: 'Mesma data da aprovação da proposta', clientData: 'Data em que o cliente passou os dados pessoais', otherDate: 'Outra data' },
        details: { otherDate: 'dd/mm/aaaa' },
      },
      value: { label: 'Valor fechado', hint: 'Selecione o pacote fechado e, se o valor foi negociado, marque também Valor negociado e informe o valor.' },
      payment: {
        label: 'Condição de pagamento',
        options: { sameAsProposal: 'Igual à proposta', fewerInstallments: 'Tentar reduzir parcelas', cashDiscount: 'Desconto negociado para pagamento à vista', notNegotiated: 'Ainda não negociado', other: 'Outra' },
        details: { cashDiscount: 'Desconto e valor', other: 'Descreva a condição' },
      },
      deadlines: {
        label: 'Prazos de entrega do projeto',
        options: { feasibility: 'Tem viabilidade?', sameAsProposal: 'Igual da Proposta', negotiated: 'Negociado com Cliente um prazo de entrega diferente da Proposta', other: 'Outro' },
        details: { negotiated: 'Informar quais serão os prazos negociados', other: 'Descreva' },
      },
      invoice: {
        label: 'Nota fiscal',
        options: { yes: 'Sim', no: 'Não', checkIncluded: 'Verificar com o cliente – NF considerada na composição', checkNotIncluded: 'Verificar com o cliente – NF não considerada na composição' },
      },
      package: {
        label: 'Pacote contratado',
        options: {
          arqStandard: 'Arquitetônico - Plano Padrão', arqPersonal: 'Arquitetônico - Plano Personal', arqSupreme: 'Arquitetônico - Plano Supremo', arqComfort: 'Arquitetônico - Plano Conforto',
          intWithout: 'Interiores - SEM detalhamento de marcenaria', intWith: 'Interiores - COM detalhamento de marcenaria', other: 'Outro',
        },
        details: { other: 'Qual?' },
      },
      area: {
        label: 'Arquitetônico: m² contratados',
        options: { asProposal: 'Conforme proposta', otherArea: 'Outra metragem', na: 'Não se aplica' },
        details: { otherArea: 'Metragem em m²' },
      },
      excessArea: {
        label: 'Arquitetônico: valor do m² excedente',
        options: { asCalculated: 'Conforme proposta', valueOverArea: 'Valor fechado ÷ m² contratados', different: 'Valor diferente', na: 'Não se aplica' },
        details: { different: 'Valor por m²' },
      },
      floors: {
        label: 'Arquitetônico: pavimentos',
        options: { subsolo: 'Subsolo', terreo: 'Térreo', superior: 'Superior', atico: 'Ático', na: 'Não se aplica', other: 'Outro' },
        details: { other: 'Quais?' },
      },
      rooms: {
        label: 'Interiores: ambientes contratados',
        options: { allFromProposal: 'Seguir todos da proposta', changed: 'Houve alteração', na: 'Não se aplica' },
        details: { changed: 'Quais ambientes mudaram' },
      },
      extraServices: { label: 'Serviços adicionais fora do pacote', hint: 'Informe se houve algum ajuste nos serviços contratados além do pacote fechado', placeholder: 'Se não houve ajuste, escreva: Sem ajustes' },
      visits: { label: 'Nº de visitas técnicas contratadas', hint: 'Informe o nº de visitas do pacote na proposta, ou o que foi combinado', placeholder: 'Ex.: 8' },
      clientRegistration: {
        label: 'Cadastro de clientes',
        options: { sendLink: 'Enviar link para clientes preencherem dados cadastrais', linkSent: 'Já enviado o link para cliente preencher', returning: 'Não precisa - Re-clientes', other: 'Outro' },
        details: { other: 'Descreva' },
      },
      briefing: {
        label: 'Briefing',
        options: { notNeeded: 'Não precisa de briefing', done: 'Briefing já realizado', sendWithDraft: 'Enviar Briefing com Minuta', sent: 'Já enviado', schedule: 'Agendar Reunião de Briefing', other: 'Outro' },
        details: { other: 'Descreva' },
      },
      condo: {
        label: 'Estágio do condomínio',
        options: { notCondo: 'Terreno não está em condomínio', released: 'Condomínio liberado para construção', underConstruction: 'Condomínio em obras', other: 'Outro' },
        details: { other: 'Descreva' },
      },
      topography: { label: 'Levantamento topográfico: cliente já possui?' },
      registry: { label: 'Registro de imóveis: cliente já possui?' },
      bylaws: { label: 'Convenção do condomínio: cliente já possui?' },
      notes: { label: 'Observações sobre a comunicação com o cliente ou o perfil dele', placeholder: 'Como o cliente prefere ser atendido, cuidados na comunicação, perfil' },
    },
  },
  /** Prazos: each project's deadlines, stage by stage (app/prazos). */
  projectSchedule: {
    title: 'Prazos Arq',
    hint: 'Os prazos do arquitetônico de cada projeto, etapa por etapa, em dias úteis.',
    tabs: { aria: 'Seções dos prazos', list: 'Prazos Arq', summary: 'Resumo' },
    sections: {
      viability: 'Em viabilidade', layout: 'Em layout', model3d: 'Em 3D', detailing: 'Em detalhamento',
      personalization: 'Em personalização', done: 'Etapas concluídas', notSaved: 'Sem prazos preenchidos',
    },
    situation: {
      notSaved: 'Sem prazos', toReview: 'A conferir', late: 'Atrasado', withClient: 'Com o cliente',
      running: 'No prazo', waiting: 'Aguardando', done: 'Concluído',
    },
    stages: { viability: 'Viabilidade', layout: 'Layout', model3d: '3D', detailing: 'Detalhamento', personalization: 'Personalização' },
    addition: 'Detalhamento adicional {number}',
    startFrom: { topography: 'Recebimento do topográfico', briefing: 'Briefing', contract: 'Assinatura do contrato' },
    status: { notContracted: 'Não contratado', waiting: 'Aguardando', running: 'No prazo', late: 'Atrasado', withClient: 'Com o cliente', done: 'Concluído' },
    cell: {
      notContracted: 'não contratado',
      waitingStart: 'aguardando a etapa anterior',
      waitingDays: 'prazo a definir',
      planned: 'previsto',
      lateBy: 'atrasado {days}',
      presented: 'apresentado {date}',
      withClientFor: 'com o cliente há {days}',
      doneLate: 'concluído com {days} de atraso',
      doneLateShort: '{days} após o previsto',
      done: 'concluído',
      toReview: 'a conferir',
    },
    columns: { planned: 'Previsto', real: 'Real' },
    review: {
      chip: 'a conferir',
      hint: 'Histórico importado da planilha. Não conta nos atrasados até alguém conferir.',
    },
    list: {
      search: 'Buscar',
      searchPlaceholder: 'Cliente ou projeto',
      filterAria: 'Filtrar os projetos',
      all: 'Todos',
      late: 'Atrasados',
      withClient: 'Com o cliente',
      notSaved: 'Sem prazos',
      toReview: 'A conferir',
      notSavedNote: 'projetos ativos sem nenhum prazo',
      client: 'Cliente',
      situation: 'Situação',
      dates: 'Datas',
      dateColumns: { contract: 'Contrato', briefing: 'Briefing', topography: 'Receb. topográfico' },
      startMark: 'início do prazo',
      start: 'Conta a partir de',
      noStart: 'sem data de início',
      notFilled: 'prazos não preenchidos',
      empty: 'Nenhum projeto encontrado.',
      project_one: '{count} projeto ativo',
      project_other: '{count} projetos ativos',
      footer: 'clique no projeto para preencher ou ver os prazos',
      open: 'Abrir os prazos de {client}',
    },
    dialog: {
      eyebrow: 'Prazos do projeto',
      close: 'Fechar',
      readOnly: 'Você pode ver estes prazos, mas não editá-los.',
      intro: 'Os prazos contam em dias úteis. Cada etapa começa na aprovação da anterior; as etapas não contratadas ficam de fora.',
      startFrom: 'Prazo conta a partir de',
      contractSignedOn: 'Assinatura do contrato',
      briefingOn: 'Briefing',
      topographyOn: 'Recebimento do topográfico',
      stagesTitle: 'Etapas',
      stage: 'Etapa',
      contracted: 'Contratada',
      contractedAria: '{stage} contratada',
      days: 'Prazo (dias úteis)',
      daysAria: 'Prazo de {stage} em dias úteis',
      presentedOn: 'Apresentado em',
      presentedAria: '{stage} apresentado em',
      briefingPoints: 'Briefing de pontos',
      approvedOn: 'Aprovado em',
      deliveredOn: 'Entregue em',
      doneAria: '{stage} {label}',
      plannedOn: 'Previsto',
      fromFlow: 'A aprovação do 3D e a entrega do detalhamento vêm do detalhamento quando não preenchidas aqui.',
      personalizationHint: 'A personalização conta a partir da emissão do alvará.',
      permitIssuedOn: 'Alvará emitido em {date}.',
      noPermit: 'Alvará ainda não emitido.',
      firstReview: '1ª análise da prefeitura saiu em {date}.',
      additionsTitle: 'Detalhamentos adicionais',
      additionsHint: 'Cada um conta a partir da entrega do detalhamento, com o prazo combinado à parte.',
      additionsEmpty: 'Nenhum detalhamento adicional.',
      addAddition: 'Adicionar detalhamento adicional',
      description: 'Descrição',
      descriptionAria: 'Descrição do detalhamento adicional {number}',
      removeAddition: 'Remover o detalhamento adicional {number}',
      notes: 'Observações',
      needsReview: 'A conferir',
      needsReviewHint: 'Histórico importado: enquanto marcado, o projeto não conta nos atrasados nem no Resumo. Desmarque depois de conferir as datas.',
      dateInvalid: 'Data inválida.',
      daysInvalid: 'Prazo de 1 a 999 dias úteis.',
      datePlaceholder: 'dd/mm/aaaa',
      cancel: 'Cancelar',
      save: 'Salvar',
      saving: 'Salvando…',
      saved: 'Prazos de {client} salvos.',
      saveError: 'Não foi possível salvar os prazos.',
      fixErrors: 'Confira os campos marcados.',
    },
    summary: {
      lateProjects: 'Projetos atrasados',
      lateProjectsNote: 'alguma etapa passou do previsto',
      thisWeek: 'Entregas nesta semana',
      nextWeek: 'Entregas na próxima semana',
      deliveriesNote: 'etapas previstas, ainda em andamento',
      withClient: 'Com o cliente',
      withClientNote: 'apresentadas, aguardando aprovação',
      avgClientDays: 'Média de aprovação do cliente',
      avgClientDaysNote: 'dias úteis entre apresentar e aprovar',
      toReview: 'A conferir',
      toReviewNote: 'históricos importados, fora destes números',
      byStageTitle: 'Etapas',
      byStageAria: 'Situação por etapa',
      stage: 'Etapa',
      deliveriesTitle: 'Próximas entregas',
      deliveriesAria: 'Próximas entregas',
      deliveriesEmpty: 'Nada previsto para estas duas semanas.',
      week: { this: 'Nesta semana', next: 'Na próxima semana' },
      date: 'Previsto',
      client: 'Cliente',
      projectsTitle: 'Projetos ativos',
      projectsAria: 'Projetos ativos',
      current: 'Etapa atual',
      next: 'Próxima data',
      situation: 'Situação',
      allDone: 'todas concluídas',
      stageFilterAria: 'Filtrar pela etapa atual',
      all: 'Todas',
      empty: 'Nenhum projeto nesta etapa.',
    },
  },
  today: {
    title: 'Hoje',
    loading: 'Carregando o dia…',
    loadError: 'Não foi possível carregar o painel de hoje.',
    nothing: 'Nada para mostrar com o seu acesso.',
    viewAria: 'Painel de',
    views: { finance: 'Financeiro', commercial: 'Comercial', partners: 'Sócias' },
    when: { today: 'hoje', tomorrow: 'amanhã', yesterday: 'ontem', ago: 'há {n} dias', in: 'em {n} dias' },
    /** The detailing team's alert (detailingFlow.newAlert). */
    newDetailing: {
      title: 'Novos projetos a detalhar · {count}',
      aria: 'Novos projetos a detalhar',
      openList: 'Ver no detalhamento',
      approvedOn: '3D aprovado em {date}',
      approvedBy: '3D aprovado em {date} · fachada {name}',
      open: 'Abrir',
      openAria: 'Abrir o detalhamento de {client}',
    },
    /** The personalization team's alert (projectSchedule.personalizationAlert). */
    personalization: {
      title: 'Agendar briefing de pontos · {count}',
      aria: 'Projetos para agendar o briefing de pontos',
      openList: 'Ver os prazos',
      returnedOn: '1ª análise da prefeitura saiu em {date}',
      open: 'Abrir prazos',
      openAria: 'Abrir os prazos de {client}',
    },
    reviews: {
      title: 'Pendências para conferir',
      subtitle: 'cadastros que o cliente preencheu pelo link',
      empty: 'Nenhum cadastro aguardando conferência.',
      item: 'Cadastro preenchido pelo cliente, pendente para conferência',
      sentOn: 'enviado {when}',
      open: 'Conferir',
      openAria: 'Conferir o cadastro de {client}',
    },
    birthdays: {
      title: 'Aniversariantes do dia',
      empty: 'Nenhum contato faz aniversário hoje.',
      age_one: '{count} ano',
      age_other: '{count} anos',
    },
    kpis: {
      payToday: 'A pagar hoje',
      payTodayNote: '{count}',
      payOverdue: '{count} em atraso ({value})',
      receiveMonth: 'A receber em {month}',
      receiveOverdue: '{count} em atraso ({value})',
      documents: 'Fichas novas',
      documentsNote: 'concluídas nos últimos 7 dias',
      documentsRegistrations: '{count} de cliente',
      closedMonth: 'Fechado em {month}',
      closedOthers: '{count} adicional/m² excedente',
      closedLost: '{count} não fecharam',
      openBudgets: 'Propostas em aberto',
      stalled: '{count} há mais de 15 dias sem fechar',
      noneStalled: 'nenhuma parada há mais de 15 dias',
      rt: 'RT a receber',
      rtNext: '{count} prevista(s) nos próximos 7 dias',
      rtOverdue: '{count} atrasada(s)',
    },
    bills_one: '{count} conta',
    bills_other: '{count} contas',
    installments_one: '{count} parcela',
    installments_other: '{count} parcelas',
    contracts_one: '{count} contrato',
    contracts_other: '{count} contratos',
    registrations_one: '{count} cadastro',
    registrations_other: '{count} cadastros',
    groups: { overdue: 'Atrasadas', today: 'Hoje', next: 'Próximos 7 dias', overdueReceivables: 'Atrasados', month: 'Previstos no mês' },
    payables: {
      title: 'Contas a pagar', subtitle: 'atrasadas, de hoje e dos próximos 7 dias', empty: 'Nenhuma conta vencendo nos próximos 7 dias.',
      colDue: 'Vencimento', colBill: 'Conta', colValue: 'Valor', account: 'conta {account}', open: 'Abrir saídas',
    },
    receivables: {
      title: 'Recebimentos dos contratos', subtitle: 'atrasados e previstos para {month}', empty: 'Nada a receber dos contratos neste mês.',
      colMonth: 'Mês', colContract: 'Contrato', colValue: 'Valor', toConfirm: 'a confirmar', open: 'Abrir previsão',
    },
    documents: {
      title: 'Fichas e cadastros novos', subtitle: 'concluídos nos últimos 7 dias', empty: 'Nenhuma ficha ou cadastro concluído nos últimos 7 dias.',
      colDate: 'Concluído em', colClient: 'Cliente', form: 'ficha', registration: 'cadastro', open: 'Abrir contratos',
    },
    closings: {
      title: 'Fechamentos', subtitle: 'últimos 7 dias', empty: 'Nenhum fechamento nos últimos 7 dias.',
      colDate: 'Fechado em', colClient: 'Cliente', colValue: 'Valor', open: 'Abrir contratos',
    },
    openBudgets: {
      title: 'Propostas em aberto', subtitle: 'da mais antiga para a mais recente', empty: 'Nenhuma proposta em aberto.',
      colSince: 'Desde', colClient: 'Cliente', colStatus: 'Status', open: 'Abrir orçamentos', more: 'e mais {count}',
    },
    technicalReserves: {
      title: 'RTs a receber', subtitle: 'atrasadas e previstas para os próximos 7 dias', empty: 'Nenhuma RT atrasada ou prevista para os próximos 7 dias.',
      colExpected: 'Previsto', colClient: 'Cliente', colValue: 'Valor', open: 'Abrir RT',
    },
  },
  clientRegistrations: {
    title: 'Cadastro do cliente',
    titleKind: 'Cadastro do cliente · {kind}',
    dialogAria: 'Cadastro do cliente de {client}',
    close: 'Fechar cadastro',
    loading: 'Carregando o cadastro…',
    loadError: 'Não foi possível carregar o cadastro.',
    kindLabel: 'Tipo de cliente',
    kinds: { individual: 'Pessoa física', company: 'Pessoa jurídica' },
    kindsLower: { individual: 'pessoa física', company: 'pessoa jurídica' },
    legend: 'O que já existe no orçamento e nos dados do contrato vem preenchido. Confira com o cliente.',
    readOnly: 'Você pode ver este cadastro, mas não alterá-lo.',
    stateNew: 'Novo',
    stateDraft: 'Rascunho',
    stateCompleted: 'Concluído',
    stateCompletedOn: 'Concluído em {date}',
    optional: 'opcional',
    missingTag: 'falta preencher ou corrigir',
    missing: 'Falta preencher ou corrigir: {items}',
    unsaved: 'Alterações não salvas',
    discardWarning: 'Há alterações não salvas. Feche de novo para descartar.',
    copy: 'Copiar cadastro',
    copied: 'Cadastro copiado',
    copyError: 'Não foi possível copiar o cadastro.',
    copyHeader: 'CADASTRO DO CLIENTE ({kind}) – {client}',
    copyDate: 'Penha Moraes Arquitetura · {date}',
    empty: '–',
    saveDraft: 'Salvar rascunho',
    saving: 'Salvando…',
    complete: 'Concluir cadastro',
    saveChanges: 'Salvar alterações',
    draftSaved: 'Rascunho do cadastro salvo',
    completed: 'Cadastro concluído',
    updated: 'Cadastro atualizado',
    saveError: 'Não foi possível salvar o cadastro. Tente novamente.',
    yesNo: { yes: 'Sim', no: 'Não' },
    share: {
      title: 'Enviar ao cliente',
      intro: 'Gere um link para o cliente preencher os próprios dados. As respostas chegam aqui, para você conferir e concluir o cadastro.',
      create: 'Gerar link para o cliente',
      created: 'Link para o cliente gerado',
      error: 'Não foi possível gerar o link. Tente novamente.',
      sentOn: 'Link gerado em {date} · vale até {until}',
      linkAria: 'Link do cadastro para o cliente',
      copyMessage: 'Copiar mensagem',
      messageCopied: 'Mensagem copiada',
      copyLink: 'Copiar link',
      linkCopied: 'Link copiado',
      whatsapp: 'Abrir no WhatsApp',
      renew: 'Gerar novo link',
      received: 'O cliente enviou os dados pelo link em {date}. Confira e conclua o cadastro.',
      message: 'Olá, {name}, tudo bem? Para prepararmos o seu contrato, pedimos que preencha os seus dados neste formulário:\n\n{link}\n\nAs informações são confidenciais e usadas somente para o contrato e o projeto. Qualquer dúvida, estamos à disposição.',
      messageCompany: 'Olá, {name}, tudo bem? Para prepararmos o contrato, pedimos que preencha os dados da empresa e do representante legal neste formulário:\n\n{link}\n\nAs informações são confidenciais e usadas somente para o contrato e o projeto. Qualquer dúvida, estamos à disposição.',
    },
    public: {
      pageTitle: 'Cadastro do cliente · Penha Moraes Arquitetura',
      office: 'Penha Moraes Arquitetura',
      title: 'Cadastro do cliente',
      intro: 'Para prepararmos o seu contrato, preencha os dados abaixo. As informações são confidenciais e usadas somente para o contrato e o projeto.',
      alreadySent: 'Você já enviou este cadastro. Se precisar corrigir algo, ajuste e envie de novo.',
      send: 'Enviar cadastro',
      sending: 'Enviando…',
      thanks: 'Obrigado! Recebemos os seus dados. Se precisar corrigir algo, abra o mesmo link e envie de novo.',
      error: 'Não foi possível enviar. Tente novamente em instantes.',
      closed: 'Este link não está mais disponível. Fale com o escritório para receber um novo.',
      invalid: 'Este link não é válido ou expirou. Fale com o escritório para receber um novo.',
      completed: 'Este cadastro já foi concluído pelo escritório. Se precisar alterar algum dado, fale com o escritório.',
    },
    dependentName: 'Nome',
    dependentAge: 'Idade',
    dependentNameAria: 'Nome do dependente {n}',
    dependentAgeAria: 'Idade do dependente {n}',
    dependentAgeText: '{age} anos',
    addDependent: 'Adicionar dependente',
    removeDependent: 'Remover dependente {n}',
    warnings: {
      cpf: 'CPF inválido: confira os números',
      cnpj: 'CNPJ inválido: confira os números',
      email: 'E-mail incompleto',
      emails: 'Há um e-mail incompleto',
    },
    sections: {
      contractor: 'Contratante',
      spouse: 'Cônjuge',
      contacts: 'Contatos',
      dependents: 'Dependentes',
      company: 'Empresa',
      representative: 'Representante legal',
    },
    fields: {
      name: { label: 'Nome completo do contratante' },
      nickname: { label: 'Como prefere ser chamado(a)' },
      cpf: { label: 'CPF' },
      rg: { label: 'RG' },
      birthDate: { label: 'Data de nascimento' },
      homeAddress: { label: 'Endereço residencial', placeholder: 'Rua, nº, complemento, bairro, cidade, estado, CEP' },
      siteAddress: { label: 'Endereço da obra', placeholder: 'Rua, nº, complemento, bairro, cidade, estado, CEP' },
      spouse: { label: 'Possui cônjuge?' },
      spouseName: { label: 'Nome completo do cônjuge' },
      spouseNickname: { label: 'Como o cônjuge prefere ser chamado(a)' },
      spouseCpf: { label: 'CPF do cônjuge' },
      spouseRg: { label: 'RG do cônjuge' },
      spouseBirthDate: { label: 'Data de nascimento do cônjuge' },
      mobile: { label: 'Celular do contratante' },
      email: { label: 'E-mail do contratante' },
      instagram: { label: 'Instagram do contratante', placeholder: '@usuario' },
      spouseMobile: { label: 'Celular do cônjuge' },
      spouseEmail: { label: 'E-mail do cônjuge' },
      spouseInstagram: { label: 'Instagram do cônjuge', placeholder: '@usuario' },
      homePhone: { label: 'Telefone residencial' },
      workPhone: { label: 'Telefone comercial' },
      socialMedia: { label: 'Autoriza a Penha Moraes a marcá-lo em postagens nas redes sociais?' },
      dependents: { label: 'Possui dependentes?' },
      dependentList: { label: 'Nome e idade dos dependentes' },
      legalName: { label: 'Nome empresarial (razão social)' },
      tradeName: { label: 'Nome fantasia' },
      cnpj: { label: 'CNPJ' },
      stateRegistration: { label: 'Inscrição estadual / inscrição municipal', placeholder: 'Número, ou Isento' },
      businessAddress: { label: 'Endereço comercial', placeholder: 'Rua, nº, complemento, bairro, cidade, estado, CEP' },
      repName: { label: 'Nome completo do representante legal' },
      repRole: { label: 'Cargo do representante legal', placeholder: 'Ex.: sócio administrador, diretor' },
      repCpf: { label: 'CPF do representante legal' },
      repPhone: { label: 'Telefone do representante legal' },
      contactPeople: { label: 'Pessoas de contato no dia a dia', placeholder: 'Nome e telefone de quem vai participar das decisões do projeto' },
      companyEmails: { label: 'E-mail', placeholder: 'nome@empresa.com.br' },
      socialMediaCompany: { label: 'Autoriza a Penha Moraes a marcar a empresa em postagens nas redes sociais?' },
    },
  },
  budgets: {
    title: 'Orçamentos',
    newBudget: 'Novo orçamento',
    parametersTitle: 'Parâmetros',
    subTabs: { aria: 'Seções de parâmetros', parameters: 'Parâmetros', team: 'Equipe', fixedCosts: 'Custos fixos' },
    status: { draft: 'Em elaboração', presented: 'Apresentado', sent: 'Enviado', negotiation: 'Em negociação', closed: 'Fechado', lost: 'Perdido' },
    saved: {
      title: 'Orçamentos salvos',
      filterAria: 'Filtrar pelo status',
      filterCount: '{label}: {count}',
      filterOnly: 'Mostrar só este status',
      filterClear: 'Mostrar todos',
      sourceAria: 'Filtrar pela origem do orçamento',
      sourceAll: 'Todos',
      sourceCalculator: 'Sistema',
      sourceSpreadsheet: 'Planilha',
      searchPlaceholder: 'Buscar pelo nome do cliente',
      searchAria: 'Buscar orçamento pelo nome do cliente',
      colClient: 'Cliente',
      colDate: 'Data',
      colStatus: 'Status',
      colArea: 'Área',
      colOrigin: 'Origem',
      colContact: 'Contato',
      colValues: 'Valores',
      colClosing: 'Fechamento',
      area: '{area} m²',
      revision: 'Revisão {revision}',
      loading: 'Carregando orçamentos…',
      loadError: 'Não foi possível carregar os orçamentos.',
      empty: 'Nenhum orçamento salvo ainda.',
      emptyFiltered: 'Nenhum orçamento encontrado.',
      actionsAria: 'Ações do orçamento de {client}',
      statusAria: 'Status do orçamento de {client}: {status}. Mudar status',
      delete: 'Excluir',
      statusError: 'Não foi possível alterar o status.',
      statusChanged: 'Status alterado.',
      deleteTitle: 'Excluir orçamento',
      deleteMessage: 'Excluir o orçamento de {client}? Esta ação não pode ser desfeita.',
      deleteConfirm: 'Excluir',
      deleteCancel: 'Cancelar',
      deleteError: 'Não foi possível excluir o orçamento.',
      deleted: 'Orçamento excluído.',
      duplicate: 'Duplicar',
      duplicateAria: 'Duplicar o orçamento de {client}',
      duplicated: 'Cópia criada. Edite e salve.',
      duplicateError: 'Não foi possível duplicar o orçamento.',
      copySuffix: '(cópia)',
      form: 'Gerar ficha',
      formDraft: 'Ficha: rascunho',
      formCompleted: 'Ficha ✓',
      formTitle: 'Ficha com os dados do fechamento para o financeiro',
      deleteAria: 'Excluir o orçamento de {client}',
    },
    thirdParties: {
      extraFallback: 'Item de terceiros {n}',
    },
    settings: {
      loading: 'Carregando…',
      loadError: 'Não foi possível carregar os dados.',
      saveError: 'Não foi possível salvar. Confira os valores e tente de novo.',
      unsaved: 'Alterações não salvas',
      removeAria: 'Remover {name}',
      parameters: {
        title: 'Parâmetros',
        saved: 'Parâmetros salvos.',
        save: 'Salvar todos os parâmetros',
        saving: 'Salvando…',
        reset: 'Restaurar valores padrão',
        resetTitle: 'Restaurar valores padrão',
        resetMessage: 'Preencher o formulário com os valores padrão da calculadora? Nada é salvo até você clicar em "Salvar todos os parâmetros".',
        resetConfirm: 'Restaurar',
        resetCancel: 'Cancelar',
        footerHint: 'As alterações valem para os próximos cálculos de todos que usam a calculadora. Orçamentos já salvos mantêm os custos do dia em que foram feitos.',
        hourCost: {
          title: 'Custo da hora',
          hint: 'Calculado a partir das abas Equipe e Custos fixos. Para alterar, edite as pessoas e os custos fixos lá. Horas produtivas já descontam o aproveitamento de cada equipe.',
          fixedHour: 'Hora fixa do escritório',
          arq: 'Valor/h arquitetônico',
          int: 'Valor/h interiores',
          obra: 'Valor/h obras',
          productiveHours: 'Horas produtivas / mês',
          loadError: 'Não foi possível carregar o custo da hora.',
        },
        commission: {
          title: 'Comissão padrão',
          hint: 'Valor sugerido ao iniciar um orçamento.',
          packages: 'Pacotes (%)',
          interiors: 'Somente interiores (%)',
        },
        personalization: {
          title: 'Personalização',
          hint: 'Valores sugeridos ao iniciar um orçamento. A personalização entra nos pacotes Personal, Supremo e Conforto.',
          points: 'Pontos (h)',
          coverings: 'Revestimentos e forro (h)',
          meetings: 'Reuniões (h)',
          mode: 'Forma de cálculo padrão',
          modes: { fixed: 'Valor fixo', hours: 'Horas × hora de interiores', perM2: 'm² × valor por m²' },
          coveringsFixed: 'Personalização de revestimentos e forro (R$ fixo)',
          pointsFixed: 'Lançamento de pontos (R$ fixo)',
          coveringsPerM2: 'Personalização de revestimentos e forro (R$/m²)',
          pointsPerM2: 'Lançamento de pontos (R$/m²)',
        },
        interiors: {
          title: 'Interiores',
          revisionMargin: 'Margem de revisões de projeto — padrão (%)',
          reducedPoints: 'Opção reduzida: pontos (h)',
          reducedCoverings: 'Opção reduzida: revestimentos e forro (h)',
          reducedMeetings: 'Opção reduzida: reuniões (h)',
        },
        margins: {
          title: 'Margens e encargos',
          hint: 'Margens sugeridas ao iniciar um orçamento; cada orçamento pode ajustá-las.',
          profitPadrao: 'Lucro Padrão (%)',
          profitPersonal: 'Lucro Personal (%)',
          profitSupremo: 'Lucro Supremo (%)',
          profitConforto: 'Lucro Conforto (%)',
          financial: 'Custo financeiro (%)',
          taxes: 'Tributos (%)',
          siProfit: 'Interiores: lucro sem detalhamento (%)',
          siProfitWithDetail: 'Interiores: lucro com detalhamento (%)',
          siFinancial: 'Interiores: custo financeiro (%)',
          siTaxes: 'Interiores: tributos (%)',
          reducedProfit: 'Opção reduzida: lucro (%)',
          reducedProfitWithDetail: 'Opção reduzida: lucro com detalhamento (%)',
        },
        travel: {
          title: 'Deslocamento',
          ratePerKm: 'Valor por km (R$)',
        },
        ownCostsArq: { title: 'Custos próprios — arquitetônico', add: 'Adicionar item', nameLabel: 'Item', valueLabel: 'Valor (R$)' },
        ownCostsInt: { title: 'Custos próprios — somente interiores', add: 'Adicionar item', nameLabel: 'Item', valueLabel: 'Valor (R$)' },
        projectTypes: { title: 'Tipos de projeto', hint: 'Opções da caixa "Tipo de projeto" no orçamento.', add: 'Adicionar tipo', nameLabel: 'Tipo' },
        origins: { title: 'Origens de cliente', hint: 'Opções da caixa "Origem do cliente" no orçamento.', add: 'Adicionar origem', nameLabel: 'Origem' },
        stages: {
          title: 'Modelo de etapas do arquitetônico',
          hint: 'Usado ao iniciar um novo orçamento.',
          name: 'Etapa',
          hours: 'Horas',
          r1: 'Horas R1',
          r2: 'Horas R2',
          add: 'Adicionar etapa',
          nameAria: 'Etapa {n}',
          hoursAria: 'Horas da etapa {n}',
          r1Aria: 'Horas R1 da etapa {n}',
          r2Aria: 'Horas R2 da etapa {n}',
          removeAria: 'Remover etapa {n}',
        },
        rooms: {
          title: 'Modelo de ambientes',
          hint: 'Horas de criação e marcenaria usadas ao iniciar um novo orçamento.',
          name: 'Ambiente',
          qty: 'Qtd.',
          creation: 'Criação (h/un.)',
          joinery: 'Marcenaria (h/un.)',
          add: 'Adicionar ambiente',
          nameAria: 'Ambiente {n}',
          qtyAria: 'Quantidade do ambiente {n}',
          creationAria: 'Criação do ambiente {n}',
          joineryAria: 'Marcenaria do ambiente {n}',
          removeAria: 'Remover ambiente {n}',
        },
        services: {
          title: 'Modelo de outros serviços de interiores',
          hint: 'Serviços que aparecem abaixo dos ambientes ao iniciar um novo orçamento, com as horas por unidade.',
          name: 'Serviço',
          qty: 'Qtd.',
          hours: 'Horas (h/un.)',
          add: 'Adicionar serviço',
          nameAria: 'Serviço {n}',
          qtyAria: 'Quantidade do serviço {n}',
          hoursAria: 'Horas do serviço {n}',
          removeAria: 'Remover serviço {n}',
        },
      },
      team: {
        title: 'Equipe',
        hint: 'Mesma estrutura da aba Base 2025. Os totais alimentam automaticamente o custo da hora usado em todos os orçamentos.',
        notice: 'Valores individuais visíveis somente para quem tem acesso à equipe.',
        save: 'Salvar equipe',
        saved: 'Equipe salva.',
        groups: {
          arq: 'Equipe arquitetônico',
          int: 'Equipe interiores',
          obra: 'Gerenciamento de obra',
          gestao: 'Gestão, administrativo e pró-labore',
        },
        managementNote: 'Entra no custo fixo do escritório',
        utilization: 'Aproveitamento das horas (%)',
        name: 'Profissional',
        salary: 'Salário',
        transport: 'VT',
        meals: 'Alimentação',
        vacationThird: '1/3 férias',
        thirteenth: '13º',
        fgtsVacation13: 'FGTS férias e 13º',
        fgts: 'FGTS',
        hours: 'Horas/mês',
        monthlyTotal: 'Total mensal',
        hourlyValue: 'Valor/h',
        total: 'Total',
        addPerson: 'Adicionar pessoa',
        personAria: 'Pessoa {n} ({group})',
        fieldAria: '{field} da pessoa {n} ({group})',
        removeAria: 'Remover pessoa {n} ({group})',
        productive: 'Horas produtivas: {hours} · hora variável usada nos orçamentos: {rate}',
      },
      fixedCosts: {
        title: 'Custos fixos gerais',
        hint: 'Despesas mensais do escritório. O total entra no custo da hora fixa usado em todos os orçamentos.',
        notice: 'Visível e editável somente por quem tem acesso à equipe.',
        nameLabel: 'Item',
        valueLabel: 'Valor mensal (R$)',
        add: 'Adicionar custo',
        total: 'Total',
        save: 'Salvar custos fixos',
        saved: 'Custos fixos salvos.',
      },
    },
    editor: {
      expand: 'Expandir',
      collapse: 'Recolher',
      expandAria: 'Expandir {title}',
      collapseAria: 'Recolher {title}',
      resultsAria: 'Valores do orçamento',
      remove: '×',
      project: {
        title: 'Projeto',
        revision: 'Revisão {revision}',
        clientName: 'Nome do cliente',
        clientPlaceholder: 'Nome completo do cliente',
        projectType: 'Tipo de projeto',
        floors: 'Pavimentos previstos',
        floor: { subsolo: 'Subsolo', terreo: 'Térreo', superior: 'Superior', atico: 'Ático' },
        area: 'Metragem (m²)',
        interiorArea: 'Metragem de interiores (m²)',
        description: 'Descrição do projeto (para a proposta)',
        descriptionPlaceholder: 'Preencha a metragem e os pavimentos para gerar o texto',
        descriptionAutoHint: 'Montada a partir da metragem e dos pavimentos. Você pode editar; apague o texto para voltar ao automático.',
        descriptionManualHint: 'Texto editado por você. Apague para voltar ao automático (metragem e pavimentos).',
        address: 'Endereço da obra – rua, número e lote',
        condominium: 'Condomínio',
        city: 'Cidade',
        phone: 'Telefone',
        phonePlaceholder: '(41) 99999-9999',
        email: 'E-mail',
        emailPlaceholder: 'cliente@email.com',
        kind: 'Tipo de proposta',
        kinds: { packages: 'Arquitetura + pacotes', interiors: 'Somente interiores' },
        commission: 'Comissão de indicação (%)',
        commissionTo: 'Comissão para',
        commissionToPlaceholder: 'Nome de quem recebe a comissão',
        origin: 'Origem do cliente',
        select: 'Selecione…',
      },
      stages: {
        title: 'Horas do arquitetônico',
        hint: 'Horas previstas por etapa, mais as horas da 1ª e da 2ª revisão (R1 e R2), que também entram no valor. Ajuste conforme o porte e a complexidade deste projeto.',
        name: 'Etapa',
        hours: 'Horas',
        r1: 'Horas R1',
        r2: 'Horas R2',
        r1Title: 'Horas da 1ª revisão do projeto',
        r2Title: 'Horas da 2ª revisão do projeto',
        totalHours: 'Total de horas',
        totalWithRevisions: 'Total com revisões (entra no valor)',
        missing: 'Etapas do modelo fora deste orçamento:',
        missingTitle: 'Incluir de novo com as horas do modelo',
        add: 'Adicionar etapa',
        reset: 'Voltar às etapas padrão',
        nameAria: 'Etapa {n}',
        hoursAria: 'Horas da etapa {n}',
        r1Aria: 'Horas R1 da etapa {n}',
        r2Aria: 'Horas R2 da etapa {n}',
        removeAria: 'Remover etapa {n}',
      },
      personalization: {
        title: 'Personalização',
        hintPackages: 'Revestimentos e forro, pontos e reuniões. Entra nos pacotes Personal, Supremo e Conforto, calculada pela forma escolhida abaixo; essas horas não entram mais nas horas de interiores dos pacotes.',
        hintInteriors: 'Horas de pontos, revestimentos e forro e reuniões, somadas às horas de interiores.',
        points: 'Pontos (h)',
        coverings: 'Revestimentos e forro (h)',
        meetings: 'Reuniões (h)',
        mode: 'Como calcular',
        modeAria: 'Como calcular a personalização',
        modes: { fixed: 'Valor fixo', hours: 'Horas × hora de interiores', perM2: 'm² × valor por m²' },
        coveringsFixed: 'Revestimentos e forro (R$)',
        pointsFixed: 'Pontos (R$)',
        coveringsPerM2: 'Revestimentos e forro (R$/m²)',
        pointsPerM2: 'Pontos (R$/m²)',
        calcFixed: 'Total da personalização: {value} (valores fixos). As horas acima ficam só como referência.',
        calcHours: '{hours} × ({int} da equipe de interiores + {fixed} de custo fixo) = {value}',
        calcPerM2: '{area} m² × ({coverings} + {points}) = {value}. As horas acima ficam só como referência.',
        compare: 'Comparação das três formas (por pacote com personalização, antes de lucro e encargos):',
        chosen: 'escolhida',
        highest: 'maior valor',
        lowest: 'menor valor',
      },
      rooms: {
        title: 'Ambientes de interiores',
        hint: 'Informe a quantidade de cada ambiente e as horas por unidade; o total é multiplicado automaticamente. A margem de revisões de projeto, editável na linha de total, é somada às horas.',
        name: 'Ambiente',
        qty: 'Qtd.',
        creation: 'Criação (h/un.)',
        joinery: 'Marcenaria (h/un.)',
        reduced: 'Reduzida',
        reducedTitle: 'Ambientes incluídos na opção reduzida',
        total: 'Total',
        totalHours: 'Total de horas',
        withMargin: 'Com margem de revisões de projeto',
        marginAria: 'Margem de revisões de projeto (%)',
        reducedCount: '{count} amb.',
        sum: '{creation} + {joinery} marcenaria',
        sumWithServices: '{creation} + {joinery} marcenaria + {services} serviços',
        add: 'Adicionar ambiente',
        reset: 'Voltar aos valores, ambientes e serviços padrão',
        resetConfirm: 'Substituir os ambientes atuais? Clique de novo',
        nameAria: 'Ambiente {n}',
        qtyAria: 'Quantidade do ambiente {n}',
        creationAria: 'Criação do ambiente {n} (h/un.)',
        joineryAria: 'Marcenaria do ambiente {n} (h/un.)',
        reducedAria: 'Incluir o ambiente {n} na opção reduzida',
        removeAria: 'Remover ambiente {n}',
        services: {
          title: 'Outros serviços',
          hint: 'Serviços de interiores além dos ambientes, como medição e planta de especificação. As horas entram em todas as opções de interiores, sem a margem de revisões.',
          name: 'Serviço',
          qty: 'Qtd.',
          hours: 'Horas (h/un.)',
          total: 'Total',
          totalHours: 'Total de horas',
          add: 'Adicionar serviço',
          nameAria: 'Serviço {n}',
          qtyAria: 'Quantidade do serviço {n}',
          hoursAria: 'Horas do serviço {n} (h/un.)',
          removeAria: 'Remover serviço {n}',
        },
      },
      reduced: {
        title: 'Opção reduzida',
      },
      thirdParties: {
        title: 'Serviços de terceiros',
        hint: 'Custos repassados ao cliente. Arquitetura + pacotes e Somente interiores têm valores separados.',
        topo: 'Levantamento topográfico (R$)',
        drone: 'Fotos drone (R$)',
        video: 'Vídeo 3D externo (R$)',
        compl: 'Projetos complementares (R$)',
        detal: 'Det. técnico – freela (R$)',
        outros: 'Outros (R$)',
        outrosDesc: 'Descrição de outros',
        outrosDescPlaceholder: 'Ex.: sondagem do terreno, consultoria de iluminação',
        extraNameAria: 'Serviço de terceiro {n}',
        extraValueAria: 'Valor do serviço de terceiro {n} (R$)',
        removeAria: 'Remover serviço de terceiro {n}',
        add: 'Adicionar item',
        useDefault: 'Usar como padrão nos próximos orçamentos',
        defaultSaved: 'Padrão atualizado',
        defaultToast: 'Serviços de terceiros salvos como padrão',
        defaultError: 'Não foi possível salvar o padrão.',
      },
      travel: {
        title: 'Deslocamento extra',
        hint: 'Previsão de viagens para obras fora da região de atendimento. O total entra em todas as opções da proposta.',
        km: 'Distância até a obra (km, só ida)',
        trips: 'Número de viagens',
        ratePerKm: 'Valor por km (R$)',
        toll: 'Pedágio por viagem, ida e volta (R$)',
        roadHours: 'Horas de estrada por viagem, ida e volta',
        other: 'Hospedagem, alimentação e outros (R$)',
        extraNameAria: 'Despesa de deslocamento {n}',
        extraValueAria: 'Valor da despesa de deslocamento {n} (R$)',
        removeAria: 'Remover despesa de deslocamento {n}',
        add: 'Adicionar outro',
        perTrip: 'Cada viagem: {value} (km ida e volta, pedágio e horas de estrada a {rate}/h).',
      },
      notes: {
        title: 'Observações internas',
        placeholder: 'Anotações sobre este orçamento',
      },
    },
    autoDescription: {
      base: 'Residência Unifamiliar',
      area: ' de até {area} m²',
      floors_one: ', composta por {count} pavimento ({list})',
      floors_other: ', composta por {count} pavimentos ({list})',
      and: ' e ',
      floor: {
        subsolo: 'subsolo',
        terreo: 'térreo',
        superior: 'superior',
        atico: 'ático',
      },
    },
    matrix: {
      siteVisit: 'Visita ao terreno / levantamento fotográfico',
      topographicSurvey: 'Levantamento topográfico',
      briefing: 'Briefing / levantamento de necessidades',
      preliminaryLayout: 'Estudo preliminar – layout',
      preliminaryFacade3d: 'Estudo preliminar – 3D fachada',
      landscape3d: '3D paisagismo',
      droneViews: 'Fotos drone / análise de vistas e níveis',
      exteriorVideo: 'Vídeo 3D Full HD – externo',
      technicalDetailing: 'Detalhamento técnico',
      cityApprovals: 'Aprovações PMC / regulamentação',
      coveringsCustomization: 'Personalização de revestimentos e forro',
      auxiliaryDetailing: 'Detalhamentos auxiliares – lançamento de pontos (elétrico, luminotécnico, hidráulico e forro)',
      technicalSpecification: 'Especificação técnica – visitas em fornecedores',
      siteVisits: 'Visitas em obra',
      complementaryProjects: 'Projetos complementares',
      complementaryValidation: 'Validação dos projetos complementares',
      complementaryCompatibility: 'Compatibilização dos projetos complementares',
      interiorsWithoutJoinery: 'Projeto de interiores (sem det. de marcenaria)',
      interiorsComplete: 'Projeto de interiores completo',
      onlineSupport: 'Suporte online',
      occupancyCertificate: 'CVCO',
      projectManagement: 'Gestão do projeto / profissionais envolvidos',
    },
    results: {
      title: 'Investimento',
      viewAria: 'Visão dos valores',
      viewInternal: 'Composição interna',
      viewClient: 'Visão do cliente',
      includeAria: 'Incluir {name} na proposta',
      cardPerM2: '{value} / m²',
      nonePackages: 'Marque ao menos um pacote para montar a proposta.',
      noneInteriors: 'Marque ao menos uma opção para montar a proposta.',
      reducedHint: 'Para montar a opção reduzida, marque na coluna Reduzida os ambientes que entram nela.',
      noJoineryTitle: 'Marcenaria sem horas.',
      noJoineryPackages: 'Nenhum ambiente tem horas de detalhamento de marcenaria, então o Conforto está com as mesmas horas de interiores do Supremo.',
      noJoineryInteriors: 'Preencha as horas de detalhamento de marcenaria por ambiente para diferenciar o projeto completo.',
      rows: {
        team: 'Equipe arquitetônico',
        interiorsTeam: 'Equipe interiores',
        plannedHours: 'Horas previstas',
        fixedCost: 'Custo fixo do escritório',
        ownCosts: 'Custos próprios do projeto',
        thirdParties: 'Serviços de terceiros',
        travel: 'Deslocamento extra',
        projectCost: 'Custo do projeto',
        profit: 'Lucro',
        financial: 'Custo financeiro',
        commission: 'Comissão',
        taxes: 'Tributos',
        investment: 'Investimento',
        perM2: 'Valor por m²',
        isolatedInteriors: 'Projeto de interiores isolado',
      },
      chips: {
        hoursTimesRate: '{hours} × {rate}',
        perHour: '{rate}/h',
        fixedValue: 'valor fixo',
        roomsPlusPersonalization: 'ambientes e serviços + personalização',
        hoursSplit: '{rooms} + {personalization}',
      },
      extra: {
        coveringsFixed: 'Personalização de revestimentos e forro',
        pointsFixed: 'Lançamento de pontos',
        personalizationHours: 'Personalização (horas)',
        coveringsPerM2: 'Personalização de revestimentos e forro',
        pointsPerM2: 'Lançamento de pontos',
        interiorsWithoutDetail: 'Interiores sem det. de marcenaria',
        interiorsComplete: 'Interiores completo',
        topo: 'Levantamento topográfico',
        drone: 'Fotos drone',
        video: 'Vídeo 3D externo',
        compl: 'Projetos complementares',
        detal: 'Det. técnico – freela',
        outros: 'Outros serviços de terceiros',
        outrosNamed: 'Outros: {label}',
      },
      percentAria: 'Percentual de {row}',
      profitAria: 'Percentual de lucro do {name}',
      perM2Aria: 'Valor por m² de {row} (R$)',
      perM2Suffix: '/m²',
      client: {
        services: 'Serviços',
        rooms: 'Ambientes',
        joinery: 'Detalhamento de marcenaria',
        included: 'incluso',
        notIncluded: 'não incluso',
        allVisible: 'Todas as linhas visíveis',
        hidden_one: '{count} linha oculta para este cliente',
        hidden_other: '{count} linhas ocultas para este cliente',
        chooseLines: 'Escolher linhas visíveis',
        doneChoosing: 'Concluir',
        showAll: 'Mostrar todas',
        showLineAria: 'Mostrar ao cliente: {line}',
        addService: 'Adicionar serviço à proposta',
        newService: 'Novo serviço',
        serviceNamePlaceholder: 'Nome do serviço',
        serviceNameAria: 'Nome do serviço adicionado',
        servicePackageAria: '{service} no pacote {package}',
        removeService: 'Remover',
        removeServiceAria: 'Remover {service}',
        contractArea: 'Área prevista em contrato: {area} m².',
        interiorsArea: 'Área de interiores prevista: {area} m².',
        areaNote: 'Áreas que excederem o previsto são cobradas proporcionalmente, pelo valor do m² do pacote contratado.',
      },
      specialCondition: {
        label: 'Condição especial',
        placeholder: 'Ex.: desconto especial para fechamento até o dia 30 · aparece na visão do cliente e na proposta',
        hint: 'Deixe em branco se não houver. Na proposta, aparece num quadro logo abaixo da tabela de serviços.',
        clientTitle: 'CONDIÇÃO ESPECIAL',
      },
      rounding: {
        label: 'Arredondar para cima',
        none: 'Sem arredondamento',
        multiple: 'Múltiplos de R$ {value}',
      },
      margins: {
        reset: 'Voltar aos valores padrão',
        useDefault: 'Usar margens como padrão nos próximos orçamentos',
        resetDone: 'Margens voltaram aos valores padrão.',
        defaultSaved: 'Margens salvas como padrão.',
        defaultError: 'Não foi possível salvar as margens como padrão.',
      },
      costBasis: {
        note: 'Este orçamento usa a equipe, os custos fixos e os custos próprios vigentes em {date}. Alterações feitas depois nos parâmetros não afetam estes valores.',
        update: 'Atualizar para os custos atuais',
        choose: 'Como deseja seguir?',
        newRevision: 'Criar nova revisão com os custos atuais',
        keep: 'Manter valores anteriores',
        explain: 'A revisão atual fica arquivada neste orçamento, com os custos e valores que tinha. O orçamento continua sendo um só na lista.',
        kept: 'Valores anteriores mantidos',
      },
    },
    revisions: {
      title: 'Revisões anteriores',
      count_one: '{count} revisão',
      count_other: '{count} revisões',
      hint: 'Cada revisão fica arquivada como estava quando foi substituída: custos, horas, margens e valores.',
      item: 'R{revision}',
      archivedAt: 'arquivada em {date}',
      noTotals: 'sem valores',
    },
    leave: {
      back: 'Voltar para orçamentos',
      close: 'Fechar',
      closeAria: 'Fechar esta tela e voltar para a lista de orçamentos',
      title: 'Salvar as alterações?',
      message: 'Você preencheu informações que ainda não foram salvas. Deseja salvar antes de sair?',
      save: 'Salvar e sair',
      discard: 'Sair sem salvar',
      stay: 'Continuar editando',
      missingTitle: 'Falta preencher para salvar',
      missingMessage: 'Para salvar e deixar este orçamento na lista, preencha: {fields}.',
      fill: 'Preencher agora',
      fields: { clientName: 'nome do cliente', phone: 'telefone com DDD', origin: 'origem' },
    },
    actions: {
      save: 'Salvar orçamento',
      newRevision: 'Nova revisão',
      close: 'Fechar orçamento',
      copy: 'Copiar resumo',
      saving: 'Salvando…',
      stateSaved: 'Salvo',
      stateDirty: 'Alterações não salvas',
      stateNew: 'Orçamento ainda não salvo',
      saved: 'Orçamento salvo',
      created: 'Orçamento criado',
      revisionCreated: 'Revisão R{revision} criada. A anterior ficou arquivada.',
      revisionRefreshed: 'Revisão R{revision} criada com os custos atuais. A anterior ficou arquivada.',
      closed: 'Orçamento fechado',
      copied: 'Resumo copiado',
      copyFailed: 'Não foi possível copiar o resumo.',
      saveError: 'Não foi possível salvar. Tente novamente.',
      revisionError: 'Não foi possível criar a revisão. Tente novamente.',
      closeError: 'Não foi possível fechar o orçamento. Tente novamente.',
      clientRequired: 'Informe o cliente antes de salvar',
      phoneRequired: 'Informe o telefone com DDD',
      originRequired: 'Selecione a origem do cliente',
    },
    summary: {
      title: 'Proposta de honorários',
      titleClient: ' – {client}',
      project: 'Projeto: {type}',
      floors: 'Pavimentos: {list}',
      contractArea: 'Área prevista em contrato: {area} m²',
      interiorsArea: 'Área de interiores: {area} m²',
      areaNote: 'Áreas que excederem o previsto são cobradas proporcionalmente, pelo valor do m² do pacote contratado.',
      specialCondition: 'CONDIÇÃO ESPECIAL: {text}',
    },
    proposal: {
      button: 'Gerar proposta',
      buttonTitle: 'Gera a proposta para o cliente em PDF, no modelo do escritório',
      title: 'Proposta – {client}',
      intro: 'Seu modelo de 17 páginas, com {packages} e a tabela exatamente como está na visão do cliente.',
      close: 'Fechar',
      attention: 'A/C – como o cliente aparece na proposta',
      description: 'Descrição do projeto',
      location: 'Localização',
      paymentTerms: 'Condições de pagamento e observações',
      deadlines: 'Prazos',
      stages: {
        briefing: 'Briefing e assinatura do contrato',
        layout: 'Apresentação do layout',
        images: 'Apresentação das imagens 3D',
        detailing: 'Detalhamento técnico',
        approvals: 'Aprovações',
      },
      useAsDefault: 'Usar condições e prazos como padrão',
      useAsDefaultTitle: 'Novos orçamentos começam com estas condições e prazos',
      restoreDefaults: 'Restaurar condições e prazos padrão',
      defaultsRestored: 'Condições e prazos padrão aplicados',
      defaultsSaved: 'Condições e prazos salvos como padrão',
      defaultsError: 'Não foi possível salvar o padrão',
      savedHint: 'Os textos ficam guardados no orçamento ao salvar.',
      readOnlyHint: 'A proposta sai com os textos salvos no orçamento.',
      download: 'Baixar PDF',
      building: 'Montando o PDF…',
      downloadError: 'Não foi possível gerar o PDF.',
      successTitle: 'PDF gerado com sucesso',
      successWhere: 'Onde foi salvo',
      successFolder: 'Pasta de downloads do navegador (ou a pasta que você escolheu na confirmação)',
      done: 'Concluir',
      problems: {
        interiors: 'O modelo de proposta de Somente interiores ainda não foi cadastrado',
        noPackages: 'Marque ao menos um pacote para gerar a proposta',
        area: 'Informe a metragem (m²) para gerar a proposta',
        description: 'Preencha os campos obrigatórios da proposta: descrição e endereço da obra',
        address: 'Preencha os campos obrigatórios da proposta: descrição e endereço da obra',
      },
      /** File name of the PDF; `{revision}` is empty on the first revision, else revisionSuffix. */
      fileName: 'Proposta Penha Moraes - {client}{revision}.pdf',
      revisionSuffix: ' R{revision}',
      clientFallback: 'cliente',
      pdf: {
        attention: 'A/C : {name}',
        location: 'Localização: ',
        defaultProjectType: 'Projeto arquitetônico',
        services: 'DESCRIÇÃO DOS SERVIÇOS',
        plan: 'Plano',
        investment: 'Investimento',
        specialCondition: 'CONDIÇÃO ESPECIAL',
        title: 'Proposta – {client}',
        author: 'Penha Moraes Arquitetura',
        creator: 'Calculadora de orçamentos',
      },
    },
  },
  contracts: {
    title: 'Contratos',
    panelTitle: 'Contratos fechados',
    newEntry: 'Novo lançamento',
    hint: 'Todo orçamento marcado como Fechado aparece aqui. A coluna Andamento mostra em que pé estão a ficha para contrato e o cadastro do cliente de cada um. Complete os dados do contrato; o botão Gerar contrato será ativado quando o modelo de contrato for configurado. Cada serviço de um contrato ocupa uma linha.',
    loading: 'Carregando contratos…',
    loadError: 'Não foi possível carregar os contratos.',
    filterAria: 'Filtrar por situação',
    segments: {
      all: 'Todos',
      formPending: 'Ficha pendente',
      formDraft: 'Rascunho',
      formCompleted: 'Concluída',
      other: 'Histórico e avulsos',
    },
    segmentLabel: '{label} {count}',
    yearAria: 'Ano do fechamento',
    allYears: 'Todos os anos',
    searchPlaceholder: 'Buscar cliente, contratante, nº ou projeto',
    searchAria: 'Buscar contratos',
    summary: '{contracts} · {entries} · {total}',
    summaryContracts_one: '{count} contrato',
    summaryContracts_other: '{count} contratos',
    summaryEntries_one: '{count} lançamento',
    summaryEntries_other: '{count} lançamentos',
    columns: {
      number: 'Nº contrato',
      client: 'Cliente',
      service: 'Serviço',
      closedOn: 'Fechamento',
      value: 'Valor',
      origin: 'Origem',
      signature: 'Assinatura',
      progress: 'Andamento',
      actions: 'Ações',
    },
    noNumber: 'sem nº',
    empty: 'Nenhum contrato fechado ainda. Quando um orçamento for marcado como Fechado, ele aparece aqui.',
    emptyFiltered: 'Nenhum contrato encontrado com esse filtro.',
    none: '–',
    standaloneTag: 'Avulso',
    standaloneTagTitle: 'Lançado direto na lista de contratos',
    historicalTag: 'Histórico',
    historicalTagTitle: 'Fechado antes da calculadora (planilha de controle de contratos)',
    progress: {
      formPending: 'Ficha pendente',
      formDraft: 'Rascunho',
      formCompleted: 'Concluída',
      formCompletedTitle: 'Ficha concluída em {date}',
      toGenerate: 'Contrato a gerar',
      toGenerateTitle: 'A ficha e o cadastro estão concluídos; falta gerar o contrato',
      awaitingForm: 'Aguarda a ficha',
      awaitingRegistration: 'Aguarda o cadastro',
      awaitingBoth: 'Aguarda ficha e cadastro',
      registrationPending: 'Cadastro pendente',
      registrationDraft: 'Cadastro em rascunho',
      registrationShared: 'Link enviado ao cliente',
      registrationReceived: 'Recebido do cliente',
      registrationReceivedTitle: 'O cliente enviou os dados em {date}; falta conferir e concluir',
      registrationCompleted: 'Cadastro concluído',
      registrationCompletedTitle: 'Cadastro concluído em {date}',
      historical: 'Fechado antes da calculadora',
      standalone: 'Sem ficha (lançamento avulso)',
    },
    fillForm: 'Preencher ficha',
    continueForm: 'Continuar ficha',
    viewForm: 'Ver ficha',
    formAria: 'Ficha para contrato de {client}',
    fillRegistration: 'Cadastrar cliente',
    continueRegistration: 'Continuar cadastro',
    viewRegistration: 'Ver cadastro',
    registrationAria: 'Cadastro do cliente de {client}',
    receivable: 'Recebimento',
    createReceivable: 'Criar recebimento',
    receivableTitle: 'Parcelas previstas e recebidas deste contrato, na Previsão de entradas',
    receivableAria: 'Recebimento do contrato de {client}',
    contractorTitle: 'Contratante',
    projectLine: 'Projeto: {name}',
    projectLineTitle: 'Projeto a que este contrato pertence',
    linkProject: 'vincular projeto',
    linkProjectTitle: 'Escolher o projeto a que este contrato pertence',
    addContractor: 'informar contratante',
    addContractorTitle: 'Informar o nome que vai no contrato',
    addValue: 'informar valor',
    addValueTitle: 'Informar pacote e valor fechado',
    cash: 'à vista',
    installments: '{count} parcelas',
    contractData: 'Dados do contrato',
    generate: 'Gerar contrato',
    generateDisabled: 'Desativado porque o modelo de contrato ainda não foi configurado no sistema.',
    editData: 'Editar dados',
    actionsAria: 'Ações do contrato de {client}',
    accountShort: {
      PF: 'Pessoa física',
      PJ: 'Pessoa jurídica',
    },
    account: {
      PF: 'PF – pessoa física',
      PJ: 'PJ – pessoa jurídica',
    },
    signature: {
      digital: 'Assinado digitalmente',
      printed: 'Impresso assinado',
      signedUnknown: 'Assinado (forma não informada)',
      email: 'Aprovado por e-mail',
      whatsapp: 'Aprovado por WhatsApp',
      none: 'Sem contrato',
      unsigned: 'Não assinado',
      archived: 'Em arquivo',
      other: 'Outro',
    },
    category: {
      contract: 'Contrato',
      additions: 'Adicionais',
      excessArea: 'M² excedente',
    },
    dialog: {
      titleNew: 'Novo lançamento',
      titleEdit: 'Dados do contrato – {client}',
      newHint: 'Use para aditivos, m² excedente, ajustes de projeto e outros fechamentos que não passam por um orçamento. Para um contrato novo com proposta, marque o orçamento como Fechado.',
      close: 'Fechar',
      budgetLine: 'Orçamento de {service}',
      contractDate: 'Data do contrato',
      contractDateHint: 'É o mês do contrato que vale nos Fechamentos, no Painel comercial e no Lucro.',
      budgetPackage: 'Pacote fechado',
      budgetPackagePlaceholder: 'Selecione o pacote',
      budgetValue: 'Valor fechado',
      client: 'Cliente',
      clientPlaceholder: 'Como o cliente é chamado no escritório',
      project: 'Projeto',
      projectHint: 'O projeto a que este contrato pertence. Aditivos e m² excedente vão no mesmo projeto do contrato.',
      noProject: 'Sem projeto vinculado',
      projectSearch: 'Buscar projeto',
      projectEmpty: 'Nenhum projeto encontrado',
      contractor: 'Contratante (nome no contrato)',
      contractorPlaceholder: 'Nome completo ou razão social',
      number: 'Nº do contrato',
      useNext: 'Usar o próximo: {number}',
      numberTaken: 'Este número já está com {client} ({date}).',
      noDate: 'sem data',
      service: 'Serviço',
      servicePlaceholder: 'Selecione o serviço',
      package: 'Pacote',
      noPackage: 'Sem pacote',
      closedOn: 'Data do fechamento',
      closedOnPlaceholder: 'dd/mm/aaaa',
      value: 'Valor (R$)',
      installments: 'Nº de parcelas',
      account: 'Conta',
      notInformed: 'Não informado',
      signature: 'Assinatura do contrato',
      origin: 'Origem do cliente',
      category: 'Categoria do fechamento',
      categoryHint: 'Usada na aba Fechamentos',
      notes: 'Observação',
      notesPlaceholder: 'Ex.: M² excedente, aditivo, fechamento 3',
      missing: 'Falta: {fields}',
      missingSeparator: ', ',
      missingFields: {
        client: 'cliente',
        service: 'serviço',
        closedOn: 'data',
        value: 'valor',
      },
      delete: 'Excluir lançamento',
      cancel: 'Cancelar',
      save: 'Salvar',
      saving: 'Salvando…',
      deleteTitle: 'Excluir lançamento',
      deleteMessage: 'Excluir o lançamento de {client}? Esta ação não pode ser desfeita.',
      deleteConfirm: 'Excluir',
      deleteCancel: 'Cancelar',
    },
    toasts: {
      created: 'Lançamento incluído',
      saved: 'Dados do contrato salvos',
      deleted: 'Lançamento excluído',
      saveError: 'Não foi possível salvar. Tente novamente.',
      deleteError: 'Não foi possível excluir. Tente novamente.',
    },
  },
  commercialDashboard: {
    title: 'Painel comercial',
    hint: 'Calculado a partir dos orçamentos salvos e dos contratos fechados. Atualiza sozinho.',
    viewAria: 'Indicadores de',
    views: { proposals: 'Propostas', contracts: 'Contratos' },
    year: 'Ano',
    allYears: 'Todos os anos',
    inYear: 'em {year}',
    loading: 'Carregando o painel…',
    loadError: 'Não foi possível carregar o painel.',
    notInformed: 'Não informado',
    notClassified: 'Não classificado',
    noData: 'Sem dados no período.',
    ofTotal: '{share} do total',
    chartAria: 'Gráfico de barras: {title}',
    chartTotal: 'total {value}',
    monthsShort: {
      '1': 'Jan', '2': 'Fev', '3': 'Mar', '4': 'Abr', '5': 'Mai', '6': 'Jun',
      '7': 'Jul', '8': 'Ago', '9': 'Set', '10': 'Out', '11': 'Nov', '12': 'Dez',
    },
    proposals: {
      empty: 'Nenhuma proposta no período. Os indicadores aparecem assim que houver orçamentos salvos.',
      total: 'Total de propostas',
      closed: 'Fechadas',
      open: 'Em aberto',
      openNote: '{share} do total, ainda em negociação',
      lost: 'Não fecharam',
      status: { closed: 'Fechado', open: 'Em aberto', lost: 'Não fechou' },
      funnelTitle: 'Evolução mensal do funil',
      funnelHint: 'propostas por status, por mês',
      distributionTitle: 'Distribuição geral',
      distributionHint_one: 'status da {count} proposta',
      distributionHint_other: 'status das {count} propostas',
      donutLabel: 'Propostas',
      byTypeTitle: 'Propostas por tipo de projeto',
      byOriginTitle: 'Propostas por origem',
      byOriginHint: 'com a taxa de fechamento de cada origem',
      closeRate: '{share} fecham',
      originMonthTitle: 'Propostas por mês de uma origem',
      origin: 'Origem',
      otherSeries: 'Em aberto ou não fechou',
    },
    contracts: {
      empty: 'Nenhum contrato fechado {period}. Os indicadores aparecem quando um orçamento for marcado como Fechado.',
      count: 'Contratos fechados',
      countNote_one: '{period} · {count} lançamento',
      countNote_other: '{period} · {count} lançamentos (serviços, aditivos)',
      revenue: 'Receita contratada',
      revenueNote: '{withValue} de {entries} lançamentos com valor',
      ticket: 'Ticket médio',
      ticketNote: 'valor médio por contrato, somando os serviços',
      discount: 'Desconto médio',
      discountNote: 'sobre a proposta, em {count} de {total} lançamentos com valor',
      discountNone: 'sem valor de proposta para comparar',
      perM2: 'Valor médio por m²',
      perM2Note_one: 'arquitetônico, {count} contrato com metragem',
      perM2Note_other: 'arquitetônico, {count} contratos com metragem',
      perM2None: 'sem metragem informada',
      days: 'Tempo até fechar',
      daysValue_one: '{count} dia',
      daysValue_other: '{count} dias',
      daysNote_one: 'média entre proposta e fechamento, {count} contrato',
      daysNote_other: 'média entre proposta e fechamento, {count} contratos',
      daysNone: 'sem datas para calcular',
      commissions: 'Comissões estimadas',
      commissionsNote_one: '{count} indicação a pagar',
      commissionsNote_other: '{count} indicações a pagar',
      commissionsNone: 'nenhuma comissão no período',
      revenueByMonth: 'Receita contratada por mês',
      revenueByYear: 'Receita contratada por ano',
      revenueHint: 'soma dos valores fechados, pela data de fechamento',
      revenueSeries: 'Receita contratada',
      pendingTitle: 'Pendências dos contratos',
      pendingHint: '{count} de {total} orçamentos fechados com algo a completar',
      pendingNone: 'tudo em dia',
      pendingMissing: { number: 'número do contrato', value: 'valor fechado' },
      pendingAllDone: 'Todos os orçamentos fechados no período estão com número e valor do contrato.',
      pendingNoBudgets: 'Nenhum orçamento fechado no período; lançamentos avulsos não têm pendências.',
      pendingMore: 'e mais {count}. Veja todos na tela Contratos.',
      openContracts: 'Completar em Contratos',
      packagesTitle: 'Pacotes fechados',
      packagesHint: 'receita e quantidade por pacote',
      noPackage: 'Sem pacote',
      typesTitle: 'Receita por tipo de projeto',
      contractCount_one: '{count} contrato',
      contractCount_other: '{count} contratos',
      originTitle: 'Origem dos contratos fechados',
      originHint_one: 'participação de cada origem no contrato fechado',
      originHint_other: 'participação de cada origem entre os {count} contratos fechados',
      commissionsTitle: 'Comissões por indicação',
      commissionsHint: 'estimadas pela comissão informada no orçamento',
      commissionsEmpty: 'Nenhuma comissão por indicação nos contratos do período.',
      rule: '{rate} sobre o valor sem impostos',
      total: 'Total',
      discountTitle: 'Desconto em relação à proposta',
      discountHint: 'valor da proposta do pacote fechado x valor fechado',
      discountEmpty: 'Sem contratos com valor de proposta e valor fechado para comparar.',
      noDiscount: 'sem desconto',
      columns: {
        client: 'Cliente', to: 'Para', rule: 'Regra', commission: 'Comissão',
        package: 'Pacote', proposal: 'Proposta', closed: 'Fechado', difference: 'Diferença',
      },
    },
  },
  projectProfit: {
    title: 'Lucro por projeto',
    hint: 'Cada contrato é um projeto. Receita: contrato, adicionais, m² excedente e toda a RT recebida do cliente. Custos: custos diretos lançados para o cliente (saídas da Movimentação e contas de projeto pagas na Previsão), impostos, comissão de indicação, comissão da equipe sobre a RT e as horas da equipe e do escritório.',
    year: 'Ano',
    allYears: 'Todos os anos',
    loading: 'Carregando…',
    loadError: 'Não foi possível carregar o lucro por projeto.',
    hoursAria: 'Horas consideradas',
    hours: { planned: 'Horas previstas', real: 'Horas reais · em breve', both: 'Mostrar as duas' },
    realSoon: 'Disponível quando o sistema de horas do escritório for ligado aos contratos',
    searchPlaceholder: 'Buscar por cliente, nº do contrato ou serviço',
    searchAria: 'Buscar projeto',
    kpis: {
      revenue: 'Receita',
      revenueNote: 'contratos {contracts} · adicionais/m² {additions} · RT {rt}',
      received: 'Já recebido',
      receivedNote: 'dos contratos ligados a um plano de recebimento',
      costs: 'Custos',
      costsNote: 'diretos {direct} · impostos {taxes} · comissões {commissions} · horas {hours}',
      profit: 'Lucro',
      profitNote: 'margem média {margin}',
      profitNoteMissing: 'margem média {margin} · sem as horas dos projetos sem orçamento',
      projects: 'Projetos',
      projectsAllHours: 'todos com custo de horas',
      projectsMissing_one: '{count} sem custo de horas (sem orçamento)',
      projectsMissing_other: '{count} sem custo de horas (sem orçamento)',
      projectsPending_one: '{count} aguardando o valor do contrato, fora dos totais',
      projectsPending_other: '{count} aguardando o valor do contrato, fora dos totais',
    },
    empty: 'Nenhum projeto fechado em {year}.',
    emptyAll: 'Nenhum projeto fechado ainda.',
    emptyFiltered: 'Nenhum projeto com esses filtros.',
    columns: {
      project: 'Projeto', contracted: 'Contrato', additions: 'Adicionais / m²', rt: 'RT', received: 'Recebido',
      directCosts: 'Custos diretos', taxesCommissions: 'Impostos e comissões', plannedHours: 'Horas (previstas)',
      realHours: 'Horas (reais)', profit: 'Lucro', margin: 'Margem',
    },
    noData: 'sem dado',
    noHours: 'sem horas',
    valuePending: 'valor a informar',
    valuePendingTitle: 'Informe o valor do contrato na aba Contratos para calcular o lucro',
    soon: 'em breve',
    toggleAria: 'Ver o detalhe de {client}',
    footnote: 'Clique no projeto para ver o detalhe. Custos de projeto entram quando a saída da Movimentação ou a conta de projeto da Previsão tem o cliente informado. Cliente com mais de um contrato: RT e custos vão para o contrato mais recente anterior à data do lançamento.',
    detail: {
      revenue: 'Receitas',
      costs: 'Custos',
      category: { contract: 'Contrato', additions: 'Adicionais', excessArea: 'M² excedente' },
      rt: 'RT',
      directCost: 'custo direto',
      source: { entry: 'Movimentação', payable: 'conta de projeto da Previsão' },
      taxes: 'Impostos',
      taxesNote: '{rate} sobre contratos, adicionais e m²',
      taxesNoteDefault: '{rate} sobre contratos, adicionais e m² (percentual padrão dos Parâmetros)',
      referral: 'Comissão de indicação',
      referralNote: '{rate} do valor sem impostos, como no orçamento',
      rtCommission: 'Comissão da equipe sobre RT',
      rtCommissionNote: '{rate} da RT',
      plannedHours: 'Horas da equipe e custo fixo (previsto)',
      plannedNote: '{hours} h no orçamento · pacote {package}',
      plannedNoteEstimated: '{hours} h no orçamento · pacote {package} (estimado pelo valor fechado)',
      plannedNone: 'projeto sem orçamento na calculadora',
      realHours: 'Horas reais',
      realHoursNote: 'virão do sistema de horas do escritório',
      toReceive: 'A receber dos contratos',
      toReceiveNote: 'parcelas ainda não recebidas no plano de recebimento',
    },
  },
  closings: {
    title: 'Fechamentos',
    yearTitle: 'Fechamentos do ano',
    hint: 'Tudo o que foi fechado em cada mês, separado em contratos, adicionais e m² excedente. Montado sozinho a partir da aba Contratos, pela data do fechamento: não precisa lançar de novo.',
    year: 'Ano',
    loading: 'Carregando os fechamentos…',
    loadError: 'Não foi possível carregar os fechamentos.',
    empty: 'Nenhum fechamento em {year}.',
    kpis: {
      total: 'Total fechado em {year}',
      januaryTo: 'janeiro a {month}',
      januaryOnly: 'janeiro',
      wholeYear: 'o ano todo',
      totalNote: '{period} · {variation} sobre o mesmo período de {year} ({value})',
      monthlyAverage: 'Média mensal',
      months_one: '{count} mês ({period})',
      months_other: '{count} meses ({period})',
      firstHalf: '1º semestre',
      secondHalf: '2º semestre',
      halfAverage: 'média de {value} por mês',
      halfAverageTo: 'média de {value} por mês (julho a {month})',
      notStarted: 'ainda não começou',
      entries: 'Lançamentos',
      contracts_one: '{count} contrato',
      contracts_other: '{count} contratos',
      additions_one: '{count} adicional',
      additions_other: '{count} adicionais',
      excessArea_one: '{count} m² excedente',
      excessArea_other: '{count} m² excedente',
    },
    matrix: {
      title: 'Quadro mensal',
      hint: 'valores fechados em {year}',
      aria: 'Quadro mensal de {year}',
      total: 'Total',
      share: '%',
      monthTotal: 'Total mensal',
      count: 'Lançamentos',
    },
    list: {
      title: 'Lançamentos',
      hint: 'Para mudar a categoria, clique nela.',
      categoryAria: 'Filtrar por categoria',
      all: 'Todos',
      withCount: '{label} {count}',
      orderAria: 'Ordem dos lançamentos',
      asc: 'Janeiro → dezembro',
      desc: 'Mais recente primeiro',
      searchPlaceholder: 'Buscar por cliente ou nº do contrato',
      searchAria: 'Buscar lançamento',
      info: '{shown} de {total} · {value}',
      expandAll: 'Expandir todos',
      collapseAll: 'Recolher todos',
      toggleAllDisabled: 'Durante a busca, todos os meses ficam abertos',
      emptyFiltered: 'Nenhum lançamento com esse filtro.',
      columns: { date: 'Data', client: 'Cliente', service: 'Serviço', category: 'Categoria', value: 'Valor' },
      month_one: '{month} · {count} lançamento',
      month_other: '{month} · {count} lançamentos',
      historicalTag: 'Planilha',
      historicalTagTitle: 'Veio da planilha antiga de contratos',
      categoryButton: 'Categoria de {client}: {category}',
      categoryMenu: 'Categoria de {client}',
      changed: '{client}: {category}',
      changeError: 'Não foi possível mudar a categoria',
    },
    chart: {
      title: 'Fechado por mês',
      hint: 'soma dos lançamentos, pela data do fechamento',
      aria: 'Fechado por mês em {year}, por categoria',
    },
  },
  validation: {
    nameRequired: 'Nome é obrigatório',
    tokenLabelRequired: 'Informe um nome para o token',
    clientRequired: 'Cliente é obrigatório',
    descriptionRequired: 'Descrição é obrigatória',
    hoursNumber: 'Deve ser um número',
    hoursPositive: 'Horas devem ser maiores que zero',
    hoursRequired: 'Informe as horas planejadas',
    hoursNegative: 'Horas não podem ser negativas',
    emailRequired: 'E-mail é obrigatório',
    emailInvalid: 'E-mail inválido',
    roleRequired: 'Perfil é obrigatório',
    passwordRequired: 'Senha é obrigatória',
    passwordMin: 'A senha deve ter ao menos 8 caracteres',
    passwordMismatch: 'As senhas não coincidem',
    payrollJobRoleRequired: 'Cargo é obrigatório',
    payrollAmountInvalid: 'Deve ser um número maior ou igual a zero',
    payrollHoursInvalid: 'Horas por dia devem ser maiores que zero',
    payrollStartDateInvalid: 'Informe uma data de início válida',
    payrollHourlyRateRequired: 'Valor por hora é obrigatório',
    payrollMonthlyRequired: 'Remuneração mensal é obrigatória',
    earningsMemberRequired: 'Selecione um membro',
    earningsDateInvalid: 'Informe uma data válida',
    earningsDescriptionRequired: 'Descrição é obrigatória',
    earningsValueInvalid: 'Deve ser um número maior que zero',
    projectContactProjectRequired: 'Selecione um projeto.',
    projectContactContactRequired: 'Selecione um contato.',
    projectContactRoleRequired: 'Selecione um papel.',
    projectContactRoleNameRequired: 'Informe o nome do papel.',
    projectContactRoleUpdateEmpty: 'Informe ao menos um campo para atualizar',
    projectContactDuplicate: 'Este contato já tem esse papel neste projeto.',
    projectContactRoleArchived: 'Esse papel está arquivado. Escolha outro.',
    projectContactProjectMissing: 'Esse projeto não existe mais. Atualize a página.',
    projectContactContactMissing: 'Esse contato não existe mais. Atualize a página.',
    projectContactRoleMissing: 'Esse papel não existe mais. Atualize a página.',
    // Shown by both the project-side and contact-side link dialogs — same key, since a fully
    // empty role catalog is the same dead end from either tab, and the sentence names neither a
    // project nor a contact, so it reads correctly regardless of which one opened it.
    projectContactNoRoles: 'Nenhum papel cadastrado. Cadastre em Configurações › Contatos › Papéis em projetos.',
    projectRequired: 'Selecione um projeto',
    hoursServiceRequired: 'Selecione um serviço',
    phaseRequired: 'Selecione uma etapa',
    subphaseNameRequired: 'Informe o nome da subetapa',
    currentPhaseRequired: 'Selecione a etapa atual',
    projectItemNameRequired: 'Informe o nome do ambiente',
    templateNameRequired: 'Informe um nome para o modelo',
    activityNameRequired: 'Nome da atividade é obrigatório',
    phaseNameRequired: 'Nome da etapa é obrigatório',
    phaseNameTaken: 'Já existe uma etapa com esse nome',
    phaseCycle: 'Uma etapa não pode ser movida para dentro dela mesma',
    contactNameRequired: 'Nome é obrigatório',
    contactTradeNameRequired: 'Nome fantasia é obrigatório',
    contactTypeInvalid: 'Tipo de contato inválido',
    contactCategoryRequired: 'Empresas precisam de ao menos uma categoria',
    contactSubcategoryOrphan: 'Selecione também a categoria da subcategoria escolhida',
    contactTradeNamePersonForbidden: 'Nome fantasia só se aplica a empresas',
    contactBirthDateInvalid: 'Data de nascimento inválida',
    contactBirthDateCompanyForbidden: 'Data de nascimento só se aplica a pessoas',
    contactDocumentGroupForbidden: 'Grupos não têm CPF ou CNPJ',
    contactRgPersonOnly: 'RG só se aplica a pessoas',
    /** A bound, not a format — the RG varies by estado emissor, so there is no "RG inválido" to say. */
    contactRgTooLong: 'RG deve ter no máximo 20 caracteres',
    contactCpfInvalid: 'CPF inválido',
    contactCnpjInvalid: 'CNPJ inválido',
    /** Says what a handle may contain, because the box accepts a pasted link too — a bare "inválido"
     *  over a URL the user knows is right would look like a broken field. */
    contactInstagramInvalid: 'Instagram inválido. Use apenas letras, números, ponto e sublinhado',
    contactDocumentTaken: 'Já existe um contato com esse documento',
    contactTypeChangeWouldNest: 'Um grupo não pode pertencer a outro grupo. Remova este contato dos grupos a que ele pertence antes de transformá-lo em grupo',
    contactTypeChangeHasMembers: 'Este grupo ainda tem membros. Remova todos os membros na aba Membros antes de mudar o tipo',
    contactTypeChangeHasChildren: 'Este contato ainda tem filhos cadastrados. Remova-os antes de transformá-lo em empresa',
    contactCategoryNameRequired: 'Nome da categoria é obrigatório',
    contactCategoryKindInvalid: 'Tipo de categoria inválido',
    contactCategoryKindMismatch: 'A categoria não pertence a esta lista',
    contactCategoryArchived: 'Esta categoria está arquivada',
    contactPhoneRequired: 'Informe o telefone',
    contactUfInvalid: 'UF inválida',
    contactRelationForwardRequired: 'Informe o nome da relação',
    contactRelationInverseRequired: 'Informe o nome da relação inversa',
    contactRelationSelf: 'Um contato não pode se relacionar consigo mesmo',
    contactRelationDuplicate: 'Essa relação já existe',
    contactRelationTargetRequired: 'Selecione o contato relacionado',
    contactRelationTypeRequired: 'Selecione o tipo de relação',
    contactRelationTargetMissing: 'O contato selecionado não existe mais',
    contactRelationTypeMissing: 'O tipo de relação selecionado não existe mais',
    contactMemberRequired: 'Selecione um contato',
    contactMemberDuplicate: 'Este contato já é membro do grupo',
    contactMemberMissing: 'O contato selecionado não existe mais',
    contactMemberIsGroup: 'Um grupo não pode ser membro de outro grupo',
    contactMemberParentNotGroup: 'Só grupos têm membros',
    contactChildNameRequired: 'Informe o nome do filho',
    contactChildBirthDateInvalid: 'Data de nascimento inválida',
    contactChildBirthDateFuture: 'A data de nascimento não pode estar no futuro',
    contactChildrenCompanyForbidden: 'Filhos não podem ser cadastrados em empresas',
    phaseParentInvalid: 'Etapa superior inválida',
    phaseReorderConflict: 'A lista de etapas mudou. Recarregue e tente novamente.',
    activityNameTaken: 'Já existe uma atividade com esse nome neste nível',
    activityLeafRequired: 'Selecione a atividade até o último nível',
    serviceRequired: 'Selecione ao menos um serviço',
    serviceDuplicate: 'Serviço repetido — cada serviço só pode ser adicionado uma vez',
    serviceDescriptionRequired: 'Descrição do serviço é obrigatória',
    tagNameRequired: 'Nome da etiqueta é obrigatório',
    tagColorInvalid: 'Cor inválida (use um hex de 6 dígitos, ex.: #3f9c19)',
    jobRoleNameRequired: 'Nome do cargo é obrigatório',
    projectStatusLabelRequired: 'Rótulo do status é obrigatório',
    projectStatusColorInvalid: 'Cor inválida (use um hex de 6 dígitos, ex.: #3f9c19)',
    projectStatusDefaultArchive: 'Defina outro status como padrão antes de arquivar este',
    activityStatusLabelRequired: 'Informe o rótulo da situação',
    activityStatusColorInvalid: 'Escolha uma cor válida',
    activityStatusIconInvalid: 'Escolha um ícone da lista',
    activityStatusDefaultArchive: 'Defina outra situação como padrão antes de arquivar esta',
    activityStatusDeleteRefused: 'Situações não são excluídas, apenas arquivadas',
    dateRequired: 'Informe a data',
    dateNotFuture: 'A data não pode estar no futuro',
    lateEntryBlocked: 'Lançamento fora do prazo: a data mais antiga permitida é {date}. Peça a um responsável com permissão para registrar horas anteriores.',
    monthInvalid: 'Mês inválido (use AAAA-MM)',
    dateInvalid: 'Data inválida (use AAAA-MM-DD)',
    pageSizeInvalid: 'Tamanho de página inválido',
    thresholdInteger: 'Informe um número inteiro de dias',
    thresholdMin: 'O número de dias não pode ser negativo',
    thresholdMax: 'O número de dias não pode ultrapassar 3650 (10 anos)',
    blockLateEntriesBoolean: 'Valor inválido para o bloqueio de lançamentos',
    customFieldLabelRequired: 'Rótulo do campo é obrigatório',
    customFieldTypeInvalid: 'Tipo de campo inválido',
    customFieldOptionsRequired: 'Adicione ao menos uma opção',
    customFieldOptionsForbidden: 'Este tipo de campo não aceita opções',
    customFieldRequired: 'Campo obrigatório',
    customFieldNumber: 'Deve ser um número',
    customFieldDate: 'Data inválida (use AAAA-MM-DD)',
    customFieldOption: 'Opção inválida',
    customFieldServiceRequired: 'Selecione um serviço para o campo',
    customFieldEntityImmutable: 'O tipo de entidade do campo não pode ser alterado',
    customFieldDefaultInvalid: 'Valor padrão inválido para este tipo de campo',
    customFieldsPayloadEmpty: 'Nenhum campo foi enviado',
    customFieldsUnknownService: 'Serviço não encontrado neste projeto',
    customFieldDefaultNotOption: 'O valor padrão deve estar entre as opções',
    adminActivityNameRequired: 'Nome da atividade é obrigatório',
    adminActivityNameTaken: 'Já existe uma atividade administrativa com esse nome neste nível',
    adminActivityParentInvalid: 'Atividade superior inválida',
    adminActivityCycle: 'Uma atividade não pode ser movida para dentro dela mesma',
    adminActivityReorderConflict: 'A lista de atividades mudou. Recarregue e tente novamente.',
    adminActivityRequired: 'Selecione uma atividade administrativa',
    adminActivityUpdateEmpty: 'Informe ao menos um campo para atualizar',
    adminActivityArchived: 'Esta atividade foi arquivada. Restaure-a para editar este lançamento.',
    timeEntryShapeInvalid: 'Um lançamento deve ser de um projeto ou administrativo, não ambos',
    deleteInUse: 'Não é possível excluir: o registro está em uso',
    holidayNameRequired: 'Informe o nome do feriado.',
    holidayFeb29: '29 de fevereiro não pode ser um feriado anual. Cadastre como data pontual no ano desejado.',
    holidayEasterOffset: 'O deslocamento deve manter a data no mesmo ano da Páscoa.',
    holidayDateInvalid: 'Informe uma data válida.',
    shiftEndBeforeStart: 'A hora de saída deve ser posterior à hora de entrada.',
    shiftOverlap: 'Este intervalo se sobrepõe a um turno já registrado neste dia.',
    shiftOpenExists: 'Existe um turno em curso neste dia. Registre a saída antes de iniciar outro.',
    shiftDateFuture: 'Não é possível registrar horas em data futura.',
    shiftTimeInvalid: 'Informe um horário válido no formato HH:MM.',
    shiftWorkModelInvalid: 'Modelo de trabalho inválido ou arquivado.',
    shiftAbsenceNeedsZeroDuration: 'Um turno com modelo de ausência deve ter a mesma hora de entrada e saída.',
    shiftWorkedNeedsDuration: 'Um turno sem modelo de ausência precisa de uma hora de saída posterior à de entrada.',
    shiftOutOfWindow: 'Lançamento fora do período permitido.',
    shiftForbiddenOther: 'Você não tem permissão para registrar as horas de outra pessoa.',
    shiftForbiddenPayroll: 'Você não tem permissão para consultar a carga de outra pessoa.',
    shiftForbiddenExport: 'Você não tem permissão para exportar as horas de outra pessoa.',
    shiftUserInactive: 'Usuário indisponível para lançamento de horas.',
    shiftPeriodInvalid: 'Período inválido.',
    kmRateInvalid: 'A taxa por quilômetro deve ser maior que zero.',
    kmRateStartDateRequired: 'Informe uma data de início válida.',
    kmRateEndDateInvalid: 'Informe uma data de fim válida.',
    kmRateEndBeforeStart: 'A data de fim não pode ser anterior à data de início.',
    kmRateOverlap: 'Essa vigência se sobrepõe a uma vigência já cadastrada.',
    budgetNumberInvalid: 'Informe um número válido, maior ou igual a zero.',
    budgetFractionInvalid: 'Informe um percentual entre 0% e 100%.',
    budgetNameRequired: 'Informe um nome.',
    budgetSettingInvalid: 'Os dados informados são inválidos.',
    budgetClientRequired: 'Informe o cliente antes de salvar',
    budgetPhoneRequired: 'Informe o telefone com DDD',
    budgetOriginRequired: 'Selecione a origem do cliente',
    budgetEmailInvalid: 'Informe um e-mail válido.',
    budgetContactNotFound: 'O contato selecionado não existe mais.',
    budgetStatusInvalid: 'Situação do orçamento inválida.',
    contractFormInvalid: 'Respostas da ficha inválidas.',
    contractFormIncomplete: 'Falta preencher itens da ficha.',
    clientRegistrationInvalid: 'Dados do cadastro inválidos.',
    clientRegistrationIncomplete: 'Falta preencher ou corrigir itens do cadastro.',
    budgetRevisionConflict: 'Outra revisão deste orçamento foi criada ao mesmo tempo. Recarregue e tente novamente.',
    budgetKindInvalid: 'Tipo de proposta inválido.',
    budgetInputsInvalid: 'Os dados do orçamento são inválidos.',
    kmRateEmptyPatch: 'Informe ao menos um campo para atualizar.',
    vrMinimumHoursInvalid: 'O limite de horas para VR deve ser maior que zero.',
    vrMinimumHoursMax: 'O limite de horas para VR não pode ultrapassar 24.',
    reportLogoMissing: 'Selecione um arquivo de imagem.',
    reportLogoType: 'O logo precisa ser uma imagem PNG ou JPG.',
    reportLogoSize: 'O logo pode ter no máximo 1 MB.',
    reportLogoUnreadable: 'Não foi possível ler esta imagem. Tente salvá-la novamente como PNG ou JPG.',
    expenseTypeNameRequired: 'Informe o nome do tipo de despesa.',
    expenseTypeCalcKindRequired: 'Selecione o modo de cálculo do tipo de despesa.',
    workModelNameRequired: 'Informe o nome do modelo de trabalho.',
    workModelHoursKindRequired: 'Selecione a carga horária do modelo de trabalho.',
    reimbursementKmRateMissing: 'A taxa por quilômetro não está configurada. Peça a quem administra as configurações para defini-la.',
    reimbursementTypeArchived: 'O tipo de despesa selecionado não está mais disponível. Escolha outro.',
    reimbursementPurposeRequired: 'Informe a finalidade da despesa.',
    reimbursementRouteRequired: 'Informe o trecho percorrido.',
    reimbursementKmInvalid: 'Informe uma quilometragem maior que zero.',
    reimbursementValueInvalid: 'Informe um valor maior que zero.',
    reimbursementDateFuture: 'A data da despesa não pode ser futura.',
    reimbursementNotEditable: 'Lançamentos de meses anteriores só podem ser editados ou removidos no mês em que foram criados ou por um gestor.',
    reimbursementNotArchivable: 'Este lançamento já foi removido.',
    reimbursementForbiddenOthers: 'Você não tem permissão para lançar em nome de outra pessoa.',
    reimbursementOwnerInactive: 'Este colaborador está inativo e não pode receber novos lançamentos.',
    reimbursementSaveError: 'Não foi possível salvar. Tente novamente.',
    contractClientRequired: 'Informe o cliente.',
    contractServiceRequired: 'Informe o serviço.',
    contractDateInvalid: 'Informe uma data de fechamento válida.',
    contractValueInvalid: 'Informe um valor válido.',
    contractFieldInvalid: 'Valor inválido.',
    forecastFieldInvalid: 'Valor inválido.',
    forecastNameRequired: 'Informe o nome.',
    forecastAmountInvalid: 'Informe um valor válido.',
    forecastMonthInvalid: 'Use o mês no formato mm/aaaa.',
    forecastDateInvalid: 'Informe uma data válida (dd/mm/aaaa).',
    forecastHolderRequired: 'Escolha de qual sócia é a conta pessoal.',
    forecastContractTaken: 'Um dos contratos já está em outro plano de recebimento.',
    forecastContractUnknown: 'Contrato não encontrado.',
    contractBudgetLinked: 'Este lançamento vem de um orçamento fechado e não pode ser excluído.',
    contractProjectNotFound: 'O projeto escolhido não existe mais. Escolha outro.',
    contractBudgetNotClosed: 'Só orçamentos fechados têm dados de contrato.',
    closingRowRequired: 'Informe o lançamento.',
    closingCategoryInvalid: 'Escolha uma categoria válida: contrato, adicionais ou m² excedente.',
    technicalReserveClientRequired: 'Informe o cliente.',
    technicalReserveSupplierRequired: 'Informe o fornecedor.',
    technicalReserveMoneyInvalid: 'Informe um valor válido, maior ou igual a zero.',
    technicalReserveRateInvalid: 'Informe um percentual entre 0% e 100%.',
    technicalReserveDateInvalid: 'Informe uma data válida.',
    technicalReservePaymentMethodInvalid: 'Forma de recebimento inválida.',
    technicalReserveStatusInvalid: 'Situação da RT inválida.',
    technicalReserveEmptyPatch: 'Informe ao menos um campo para atualizar.',
    technicalReserveCodeConflict: 'Outra RT foi lançada ao mesmo tempo. Tente novamente.',
    technicalReserveCommissionReferenceRequired: 'Informe a referência do pagamento.',
    technicalReserveCommissionDateInvalid: 'Informe a data do pagamento.',
    technicalReserveCommissionBaseInvalid: 'Informe uma base maior que zero.',
    technicalReserveCommissionRateInvalid: 'Informe um percentual de comissão maior que 0% e até 100%.',
    technicalReserveCommissionRecipientsRequired: 'Informe quem recebeu.',
    technicalReserveCommissionPeriodInvalid: 'Semestre inválido.',
    technicalReserveCommissionPeriodRequired: 'Informe o semestre do pagamento.',
    technicalReserveCommissionPeriodTaken: 'Já existe um pagamento da comissão registrado para este semestre.',
    technicalReserveProjectTypeInvalid: 'Tipo de projeto inválido.',
    technicalReserveCategoryInvalid: 'Categoria inválida.',
    technicalReserveNotesInvalid: 'Observações inválidas.',
    technicalReserveBodyInvalid: 'Os dados enviados são inválidos.',
    supplierQuoteClientRequired: 'Informe o cliente.',
    supplierQuoteCategoryRequired: 'Informe a categoria.',
    supplierQuoteSupplierRequired: 'Informe o fornecedor.',
    supplierQuoteSuppliersRequired: 'Informe ao menos um fornecedor.',
    supplierQuoteSuppliersTooMany: 'Lance no máximo 30 fornecedores de uma vez.',
    supplierQuoteProjectInvalid: 'Obra inválida.',
    supplierQuoteNotesInvalid: 'Observação inválida.',
    supplierQuoteValueInvalid: 'Informe um valor válido, maior ou igual a zero.',
    supplierQuoteValueRequired: 'Informe o valor do orçamento recebido.',
    supplierQuoteDateInvalid: 'Informe uma data válida.',
    supplierQuoteStatusInvalid: 'Status do orçamento inválido.',
    supplierQuoteEmptyPatch: 'Informe ao menos um campo para atualizar.',
    supplierQuoteBodyInvalid: 'Os dados enviados são inválidos.',
    supplierQuoteRtReceived: 'A RT gerada por este orçamento já foi recebida. Para mudar o status, volte a RT para A receber na Visão geral.',
    supplierQuoteAlreadyClosed: 'Este orçamento já fechou.',
    supplierQuoteCloseNeedsValue: 'Informe o valor fechado.',
    financialEntryFieldInvalid: 'Valor inválido.',
    financialEntryTypeInvalid: 'Escolha entrada ou saída.',
    financialEntryDateInvalid: 'Informe a data (dd/mm/aaaa).',
    financialEntryAmountInvalid: 'Informe o valor.',
    financialEntryAccountInvalid: 'Escolha a conta PJ ou PF.',
    financialEntryCategoryInvalid: 'Escolha a categoria da lista do plano de contas.',
    financialEntryDescriptionRequired: 'Informe a descrição.',
    financialEntryOneLink: 'Escolha só uma parcela ou uma conta para dar baixa.',
    financialEntryLinkSide: 'Uma entrada dá baixa numa parcela da Previsão de entradas; uma saída, numa conta da Previsão de saídas.',
    financialEntryLinkNegative: 'Um estorno não dá baixa na Previsão: lance o valor positivo ou apague a parcela ou a conta escolhida.',
    financialEntryLinkUnknown: 'Parcela ou conta da Previsão não encontrada.',
    financialEntryLinkTaken: 'Esta parcela ou conta já está ligada a outro lançamento.',
    financialEntryLinkCancelled: 'Esta parcela ou conta está cancelada na Previsão.',
    financialEntryYearInvalid: 'Ano inválido.',
    cityHallBodyInvalid: 'Os dados enviados são inválidos.',
    cityHallEmptyPatch: 'Informe ao menos um campo para atualizar.',
    cityHallClientRequired: 'Informe o cliente.',
    cityHallTextInvalid: 'Texto inválido.',
    cityHallFlagInvalid: 'Informe sim ou não.',
    cityHallDateInvalid: 'Informe uma data válida.',
    cityHallProjectInvalid: 'Projeto não encontrado.',
    cityHallSignStatusInvalid: 'Situação da placa de obra inválida.',
    cityHallAfterPermitInvalid: 'Item do pós-alvará inválido.',
    cityHallSituationInvalid: 'Situação do processo inválida.',
    cityHallPermitNumberRequired: 'Informe o número do alvará.',
    cityHallPermitDateRequired: 'Informe a data do alvará.',
    cityHallPermitAreaInvalid: 'Informe a área do alvará em m², maior que zero.',
    cityHallPermitExists: 'Este processo já tem alvará. Para corrigir, edite os dados do alvará.',
    cityHallPermitNotIssued: 'Este processo ainda não tem alvará. Use Registrar alvará.',
    cityHallPermitBeforeEntry: 'A data do alvará não pode ser antes da entrada da última análise.',
    cityHallPermitBeforeReturn: 'A data do alvará não pode ser antes do retorno da última análise.',
    cityHallReviewsLockedByPermit: 'Com o alvará registrado, as análises não mudam. Para corrigir, ajuste o alvará antes.',
    cityHallArchived: 'Este processo está arquivado. Recupere-o para fazer alterações.',
    cityHallReviewOpen: 'A última análise ainda está na prefeitura. Registre o retorno antes de uma nova entrada.',
    cityHallReviewAfterPermit: 'O alvará já foi emitido: não há nova entrada a registrar.',
    cityHallReviewConflict: 'Outra entrada foi registrada ao mesmo tempo. Tente novamente.',
    cityHallEntryBeforeReturn: 'A entrada não pode ser antes do retorno da análise anterior.',
    cityHallReturnBeforeEntry: 'O retorno não pode ser antes da entrada da análise.',
    cityHallReturnAfterNextEntry: 'O retorno não pode ser depois da entrada da análise seguinte.',
    cityHallReturnRequired: 'Só a última análise pode ficar sem retorno.',
    cityHallReviewNotLast: 'Só a última análise pode ser excluída.',
    cityHallDeadlineDaysInvalid: 'Informe um prazo em dias, inteiro e maior que zero.',
    cityHallCountingInvalid: 'Escolha dias corridos ou dias úteis.',
    detailingFlowBodyInvalid: 'Os dados enviados são inválidos.',
    projectScheduleBodyInvalid: 'Os dados enviados são inválidos.',
    projectScheduleEmptyPatch: 'Informe ao menos um campo para atualizar.',
    projectScheduleDateInvalid: 'Informe uma data válida (dd/mm/aaaa).',
    projectScheduleFutureDate: 'A data não pode ser no futuro.',
    projectScheduleDaysInvalid: 'Informe o prazo em dias úteis, inteiro e maior que zero.',
    projectScheduleStartFromInvalid: 'Escolha a partir de quando o prazo conta: topográfico, briefing ou assinatura do contrato.',
    projectScheduleStageInvalid: 'Etapa desconhecida.',
    projectScheduleTextInvalid: 'Texto inválido.',
    projectScheduleFlagInvalid: 'Valor inválido.',
    projectScheduleDoneBeforePresented: 'A aprovação não pode ser antes da apresentação.',
    detailingFlowEmptyPatch: 'Informe ao menos um campo para atualizar.',
    detailingFlowTextInvalid: 'Texto inválido.',
    detailingFlowFlagInvalid: 'Informe sim ou não.',
    detailingFlowDateInvalid: 'Informe uma data válida.',
    detailingFlowFutureDate: 'A data não pode ser no futuro.',
    detailingFlowProjectRequired: 'Escolha o projeto.',
    detailingFlowProjectInvalid: 'Projeto não encontrado.',
    detailingFlowExists: 'Este projeto já está no detalhamento (confira também os arquivados).',
    detailingFlowDaysInvalid: 'Informe o prazo em dias úteis, inteiro e maior que zero.',
    detailingFlowStatusInvalid: 'Status inválido.',
    detailingFlowStageInvalid: 'Etapa do fluxo inválida.',
    detailingFlowDocumentInvalid: 'Documento não encontrado nos parâmetros.',
    detailingFlowDocumentStateInvalid: 'Situação do documento inválida.',
    detailingFlowArchived: 'Este fluxo está arquivado. Recupere-o para fazer alterações.',
    detailingFlowApprovalAfterDelivery: 'A aprovação do 3D não pode ser depois da entrega do detalhamento.',
    detailingFlowDeliveryBeforeApproval: 'A entrega não pode ser antes da aprovação do 3D.',
    detailingFlowDeliveryBeforeCorrection: 'A entrega da correção não pode ser antes da reunião que a pediu.',
    detailingFlowAlreadyDelivered: 'A entrega do detalhamento já foi registrada.',
    detailingFlowUndoDeliveryLocked: 'Só dá para desfazer a entrega enquanto ela aguarda a reunião de conferência.',
    detailingFlowNotDelivered: 'Registre a entrega do detalhamento antes da reunião de conferência.',
    detailingFlowCorrectionOpen: 'Há uma correção em aberto: registre a entrega dela ou dispense a correção antes.',
    detailingFlowMeetingDone: 'A reunião de conferência já foi registrada.',
    detailingFlowMeetingBeforeDelivery: 'A reunião não pode ser antes da entrega.',
    detailingFlowCorrectionNotesRequired: 'Descreva a correção pedida.',
    detailingFlowDueBeforeMeeting: 'O prazo da correção não pode ser antes da reunião.',
    detailingFlowCorrectionConflict: 'Outra correção foi registrada ao mesmo tempo. Tente novamente.',
    detailingFlowNotAwaitingMeeting: 'Só dá para seguir sem conferência enquanto o detalhamento aguarda a reunião.',
    detailingFlowNotSkipped: 'A reunião de conferência não foi dispensada.',
    detailingFlowNotInCorrection: 'Não há correção em aberto para dispensar.',
    detailingFlowAlreadyPaused: 'Este fluxo já está pausado.',
    detailingFlowPauseAfterConference: 'Depois da conferência o detalhamento não é mais pausado.',
    detailingFlowPauseBeforeApproval: 'A pausa não pode começar antes da aprovação do 3D.',
    detailingFlowPauseOverlap: 'A pausa não pode começar antes do fim da pausa anterior.',
    detailingFlowNotPaused: 'Este fluxo não está pausado.',
    detailingFlowResumeBeforePause: 'A retomada não pode ser antes do início da pausa.',
    detailingFlowProcessExists: 'Este projeto já tem um processo na prefeitura.',
    detailingFlowNotCondo: 'Marque o projeto como de condomínio antes de registrar um envio.',
    detailingFlowCondoOpen: 'O último envio ao condomínio ainda não voltou. Registre o retorno antes.',
    detailingFlowCondoApproved: 'O condomínio já aprovou o projeto.',
    detailingFlowCondoSendBeforeReturn: 'O envio não pode ser antes do retorno anterior do condomínio.',
    detailingFlowCondoReturnBeforeSend: 'O retorno não pode ser antes do envio ao condomínio.',
    detailingFlowCondoReturnAfterNextSend: 'O retorno não pode ser depois do envio seguinte ao condomínio.',
    detailingFlowCondoReturnRequired: 'Informe a data do retorno do condomínio.',
    detailingFlowCondoResultRequired: 'Escolha o resultado do retorno: aprovado ou com correções.',
    detailingFlowCondoResultInvalid: 'Resultado do condomínio inválido.',
    detailingFlowCondoConflict: 'Outro envio foi registrado ao mesmo tempo. Tente novamente.',
    detailingFlowDocumentsRequired: 'Mantenha ao menos um documento na lista.',
    detailingFlowDocumentNameRequired: 'Informe o nome do documento.',
    detailingFlowDocumentDuplicate: 'Há dois documentos com o mesmo identificador.',
    detailingFlowValidityInvalid: 'Informe a validade em dias, inteira e maior que zero, ou deixe em branco.',
    detailingFlowCondoDaysInvalid: 'Informe o prazo do condomínio em dias, inteiro e maior que zero.',
    detailingFlowCountingInvalid: 'Escolha dias corridos ou dias úteis.',
    detailingFlowCondoNameRequired: 'Informe o nome do condomínio.',
    detailingFlowCondoDuplicate: 'Há dois condomínios com o mesmo nome.',
  },
  cityHall: {
    /** Appended to the process notes when a return is registered with an observation. */
    returnNoteLine: '{date} – retorno da {number}ª análise: {text}',
    title: 'Processos na prefeitura',
    hint: 'Da 1ª entrada ao alvará: o que está com a prefeitura, o que está conosco e o que falta protocolar.',
    empty: 'Nenhum processo cadastrado.',
    tabs: {
      aria: 'Seções dos processos na prefeitura',
      detailing: 'Detalhamento',
      flow: 'Fluxo do projeto',
      inProgress: 'Em andamento',
      processes: 'Processos',
      afterPermit: 'Pós-alvará',
      indicators: 'Indicadores',
      settings: 'Parâmetros',
    },
    situation: {
      late: 'Atrasado na prefeitura',
      atCityHall: 'Com a prefeitura',
      atOffice: 'Correção no escritório',
      toFile: 'A protocolar',
      permitIssued: 'Alvará emitido',
      stalled: 'Sem movimento',
    },
    days_one: '{count} dia',
    days_other: '{count} dias',
    businessDays_one: '{count} dia útil',
    businessDays_other: '{count} dias úteis',
    process_one: '{count} processo',
    process_other: '{count} processos',
    /** The number of an analysis: "2ª". */
    reviewOrdinal: '{number}ª',
    reviewOf: '{number}ª análise',
    /** After the days at the city hall: "12 dias / 30". */
    ofDeadline: '/ {days}',
    cityHallError: 'erro da prefeitura',
    cityHallErrorHint: 'Uma análise foi perdida por erro da prefeitura',
    columns: {
      client: 'Cliente',
      city: 'Cidade',
      review: 'Análise',
      reviews: 'Análises',
      entry: 'Entrada',
      atCityHallFor: 'Com a prefeitura há',
      expectedBy: 'Retorno esperado até',
      returnOf: 'Retorno da',
      receivedOn: 'Recebido em',
      atOfficeFor: 'Parado conosco há',
      processNumber: 'Nº do processo',
      situation: 'Situação',
      since: 'Desde',
      days: 'Dias',
      responsible: 'Responsável',
      actions: 'Ações',
    },
    inProgress: {
      kpiLate: 'Atrasados na prefeitura',
      kpiLateNote: 'retorno além do prazo da cidade',
      kpiAtCityHall: 'Com a prefeitura no prazo',
      kpiDeadlineCalendar: 'prazo padrão de {days} dias corridos',
      kpiDeadlineBusiness: 'prazo padrão de {days} dias úteis',
      kpiAtOffice: 'Correção no escritório',
      kpiAtOfficeOldest: 'o mais antigo há {days}',
      kpiAtOfficeNone: 'nada parado conosco',
      kpiToFile: 'A protocolar',
      kpiToFileNote: 'sem 1ª entrada registrada',
      kpiPermits: 'Alvarás emitidos em {year}',
      kpiPermitsLink: 'ver o pós-alvará',
      lateTitle: 'Atrasados na prefeitura',
      lateHint: 'Cobrar retorno ou pedir prioridade',
      atOfficeTitle: 'Correção no escritório',
      atCityHallTitle: 'Com a prefeitura no prazo',
      toFileTitle: 'A protocolar',
      emptySection: 'Nenhum processo nesta situação.',
    },
    list: {
      title: 'Processos',
      search: 'Buscar',
      searchPlaceholder: 'Cliente, nº do processo, construtora ou alvará',
      city: 'Cidade',
      allCities: 'Todas',
      responsible: 'Responsável',
      allResponsibles: 'Todos',
      situationAria: 'Situação',
      filters: {
        active: 'Em andamento',
        late: 'Atrasados',
        atOffice: 'Correção no escritório',
        permitIssued: 'Alvará emitido',
        stalled: 'Sem movimento',
        archived: 'Arquivados',
        all: 'Todos',
      },
      empty: 'Nenhum processo com esses filtros.',
      newProcess: 'Novo processo',
      archive: 'Arquivar',
      archiveAria: 'Arquivar o processo de {client}',
      archiveTitle: 'Arquivar processo',
      archiveConfirm: 'Arquivar o processo de {client}? Ele sai das listas e dos indicadores; dá para recuperar em Arquivados.',
      cancel: 'Cancelar',
      archived: 'Processo de {client} arquivado.',
      archiveError: 'Não foi possível arquivar o processo.',
      restore: 'Recuperar',
      restoreAria: 'Recuperar o processo de {client}',
      restored: 'Processo de {client} recuperado.',
      restoreError: 'Não foi possível recuperar o processo.',
    },
    dialog: {
      eyebrow: 'Processos na prefeitura',
      title: 'Novo processo',
      close: 'Fechar',
      project: 'Projeto',
      noProject: 'Sem projeto',
      projectSearch: 'Buscar projeto',
      projectEmpty: 'Nenhum projeto encontrado.',
      projectHint: 'Opcional. Escolher o projeto preenche o cliente.',
      client: 'Cliente',
      clientPlaceholder: 'Ex.: Ana e Pedro',
      city: 'Cidade',
      region: 'Regional',
      regionPlaceholder: 'Só em Curitiba',
      responsible: 'Responsável',
      processNumber: 'Nº do processo',
      firstEntry: '1ª entrada',
      firstEntryHint: 'Com a data, a 1ª análise já fica registrada.',
      datePlaceholder: 'dd/mm/aaaa',
      builder: 'Construtora ou responsável técnico',
      cancel: 'Cancelar',
      submit: 'Criar processo',
      saving: 'Salvando…',
      saveError: 'Não foi possível criar o processo.',
      created: 'Processo de {client} criado.',
    },
    /** The shortcut on the project page to the project's process. */
    projectShortcut: 'Processo na prefeitura',
    /** The after-permit checklist (lib/cityHall/types AFTER_PERMIT_KEYS). */
    afterPermitItems: {
      signAndArea: 'Placa de obra + m² final',
      finishesMemorial: 'Memorial de acabamentos',
      exteriorLighting: 'Luminotécnico externo',
      frameDetails: 'Det. de esquadrias',
      constructionPermit: 'Alvará de construção',
      condoApproval: 'Aprovação do condomínio',
      cvco: 'CVCO',
      tiles: 'Azulejo',
      closing: 'Encerramento',
      hoursClosing: 'Fechamento de horas',
      rrtRelease: 'Baixa da RRT de execução',
    },
    afterPermitState: {
      pending: 'pendente',
      done: 'feito',
      na: 'não se aplica',
    },
    /** Placa de obra (lib/cityHall/types SIGN_STATUSES). */
    signStatus: {
      toDo: 'A fazer',
      awaitingPermit: 'Aguard. alvará',
      awaitingWorks: 'Aguard. início obra',
      inProduction: 'Em produção',
      atOffice: 'No escritório',
      delivered: 'Entregue/inst. obra',
      wontBeMade: 'Não será feita',
    },
    /** The conclusion meeting, 7 to 10 days after the permit (dates as dd/mm). */
    meeting: {
      upcoming: 'Agendar entre {from} e {to}',
      due: 'Agendar até {to}',
      overdue: 'Reunião pendente desde {to}',
      done: 'Encerramento feito',
      hint: 'Reunião de conclusão: de 7 a 10 dias depois do alvará',
    },
    /** Months in the indicators' chart; January also gets the year ("jan 26"). */
    monthsShort: {
      '1': 'jan', '2': 'fev', '3': 'mar', '4': 'abr', '5': 'mai', '6': 'jun',
      '7': 'jul', '8': 'ago', '9': 'set', '10': 'out', '11': 'nov', '12': 'dez',
    },
    monthWithYear: '{month} {year}',
    afterPermit: {
      title: 'Depois do alvará',
      showOld: 'Mostrar alvarás antigos',
      hintRecent: 'Alvarás emitidos nos últimos 12 meses.',
      hintAll: 'Todos os alvarás registrados.',
      hintOpen: 'Clique no cliente para marcar as entregas.',
      empty: 'Nenhum alvará no período.',
      noticeTitle: 'Reunião de conclusão:',
      /** One process in the notice: "Ana Souza (agendar até 05/11)". */
      noticeItem: '{client} ({meeting})',
      noticeEnd: 'O processo prevê a reunião entre 7 e 10 dias após a saída do alvará.',
      deliveries: '{done}/{total}',
      deliveriesHint: '{done} de {total} concluídas ou que não se aplicam',
      columns: {
        client: 'Cliente',
        permit: 'Alvará',
        meeting: 'Reunião de conclusão',
        deliveries: 'Entregas',
        sign: 'Placa de obra',
      },
    },
    indicators: {
      yearAria: 'Ano do alvará',
      allYears: 'Todos os alvarás',
      summary_one: '{count} processo com alvará · dias corridos',
      summary_other: '{count} processos com alvará · dias corridos',
      kpiReview: 'Análise da prefeitura',
      kpiReviewNote_one: 'média de {count} análise concluída',
      kpiReviewNote_other: 'média de {count} análises concluídas',
      kpiOffice: 'Correção no escritório',
      kpiOfficeNote: 'do retorno até a nova entrada',
      kpiReviews: 'Análises até o alvará',
      kpiReviewsRange: 'de {min} a {max} análises',
      kpiReviewsAlways_one: 'sempre {count} análise',
      kpiReviewsAlways_other: 'sempre {count} análises',
      kpiTotal: 'Da 1ª entrada ao alvará',
      kpiTotalNote: 'cerca de {months} meses',
      kpiErrors: 'Erro da prefeitura',
      kpiErrorsNote: 'processos com análise perdida por erro da prefeitura',
      byCityTitle: 'Tempo de análise por cidade',
      byCityHint: 'A marca na barra é o prazo de referência da cidade; barra em laranja indica média acima dele.',
      byRegionTitle: 'Curitiba por regional',
      byRegionHint: 'Regionais com pelo menos 2 análises concluídas.',
      noAnalyses: 'Sem análises concluídas no período.',
      deadlineMark: 'Prazo de referência: {days} dias',
      analyses_one: '{count} análise',
      analyses_other: '{count} análises',
      permitsTitle: 'Alvarás emitidos por mês',
      permitsAria: 'Alvarás emitidos nos últimos 12 meses',
      permitsHint: 'Últimos 12 meses, pela data de emissão do alvará.',
    },
    deadlines: {
      title: 'Prazo de retorno da prefeitura',
      hint: 'Passado esse prazo desde a entrada, o processo aparece como atrasado. Cidades sem prazo próprio usam o prazo padrão.',
      defaultDays: 'Prazo padrão (dias)',
      counting: 'Contagem',
      calendar: 'Dias corridos',
      business: 'Dias úteis',
      columns: {
        city: 'Cidade',
        days: 'Prazo (dias)',
        processes: 'Processos',
      },
      cityAria: 'Prazo de {city}',
      empty: 'Nenhuma cidade nos processos ainda.',
      save: 'Salvar prazos',
      saving: 'Salvando…',
      unsaved: 'Alterações não salvas',
      nothingChanged: 'Nenhuma alteração para salvar.',
      saved: 'Prazos salvos',
      error: 'Não foi possível salvar os prazos.',
      invalid: 'Use números inteiros de dias, a partir de 1.',
      locked: 'Só quem pode alterar os prazos edita esta tela.',
    },
    detail: {
      back: 'Processos',
      eyebrow: 'Processo na prefeitura',
      archivedNotice: 'Processo arquivado — recupere em Processos › Arquivados para editar.',
      noPermission: 'Sem permissão para editar',
      archivedLock: 'Processo arquivado',
      /** In the header, after the situation: "12 dias de 30". */
      ofDeadline: '{days} de {deadline}',
      cityHallErrorChip: 'erro da prefeitura registrado',
      saving: 'Gravando…',
      futureDate: 'A data não pode ser no futuro.',
      datePlaceholder: 'dd/mm/aaaa',
      reviews: {
        title: 'Análises',
        editDates: 'Editar datas',
        permitLock: 'Com o alvará registrado, as datas das análises não mudam.',
        cancel: 'Cancelar',
        save: 'Gravar datas',
        saveHint: 'Grava só as datas alteradas.',
        unchanged: 'Nenhuma data mudou.',
        saved_one: '{count} data gravada.',
        saved_other: '{count} datas gravadas.',
        error: 'Não foi possível gravar as datas.',
        entry: 'Entrada',
        return: 'Retorno',
        byPermit: '(alvará)',
        entryAria: 'Entrada da {number}ª análise',
        returnAria: 'Retorno da {number}ª análise',
        empty: 'Nenhuma entrada registrada.',
        atCityHallDays: '{days} na prefeitura',
        atCityHallFor: 'com a prefeitura há {days}',
        atOfficeDays: '{days} de correção no escritório',
        permit_one: 'Alvará {number} emitido em {date} após {count} análise.',
        permit_other: 'Alvará {number} emitido em {date} após {count} análises.',
        permitNoReviews: 'Alvará {number} emitido em {date}.',
        permitNoNumber: 'sem número',
        permitNoDate: 'data não informada',
        permitArea: 'Área emitida: {area} m².',
      },
      register: {
        title: 'Registrar',
        returnOf: 'Retorno da {number}ª análise',
        returnNotes: 'Observações do retorno (opcional)',
        returnNotesPlaceholder: 'Ex.: pediram ajuste na área permeável e nova matrícula',
        registerReturn: 'Registrar retorno',
        returnSaved: 'Retorno da {number}ª análise registrado.',
        returnSavedWithNote: 'Retorno da {number}ª análise registrado com observação.',
        returnError: 'Não foi possível registrar o retorno.',
        entryOf: '{number}ª entrada',
        registerEntry: 'Registrar entrada',
        entrySaved: '{number}ª entrada registrada.',
        entryError: 'Não foi possível registrar a entrada.',
        permitNumber: 'Nº do alvará',
        permitDate: 'Data de emissão',
        permitArea: 'm² emitido no alvará',
        permitAreaPlaceholder: 'Ex.: 286,45',
        permitHint: 'Registrar o alvará encerra o processo na prefeitura. O m² fica guardado para o aviso ao financeiro e administrativo.',
        registerPermit: 'Registrar alvará',
        permitSaved: 'Alvará registrado. A reunião de conclusão aparece no pós-alvará.',
        permitError: 'Não foi possível registrar o alvará.',
      },
      afterPermit: {
        title: 'Depois do alvará',
        toggleHint: 'Clique para alternar: pendente, feito, não se aplica.',
        itemSaved: '{item}: {state}.',
        itemError: 'Não foi possível gravar o item.',
        sign: 'Placa de obra',
        signOrderedOn: 'Pedido de produção',
        saveSign: 'Gravar placa de obra',
        signSaved: 'Placa de obra gravada.',
        signUnchanged: 'Nada mudou na placa de obra.',
        signError: 'Não foi possível gravar a placa de obra.',
      },
      data: {
        title: 'Dados do processo',
        processNumber: 'Nº do processo',
        city: 'Cidade',
        region: 'Regional',
        responsible: 'Responsável',
        builder: 'Construtora ou responsável técnico',
        conference: 'Reunião de conferência feita',
        cityHallError: 'Erro da prefeitura (análise perdida)',
        notes: 'Observações',
        save: 'Gravar dados',
        saved: 'Dados gravados.',
        unchanged: 'Nada mudou nos dados.',
        error: 'Não foi possível gravar os dados.',
      },
    },
  },
  detailingFlow: {
    /** The documents a new install starts with (Parâmetros edits them). */
    defaultDocuments: {
      artAuthorship: 'ART de autoria de projeto',
      artExecution: 'ART de execução de projeto',
      topography: 'Levantamento topográfico',
      yellowGuide: 'Guia amarela atualizada',
      registry: 'Matrícula atualizada',
    },
    defaultProviders: {
      office: 'Escritório solicita ao responsável técnico',
      client: 'Cliente',
    },
    /** Processos na prefeitura › Parâmetros: the flow's panels. */
    settings: {
      locked: 'Só quem pode alterar os parâmetros do fluxo edita estas listas.',
      unsaved: 'Alterações não salvas',
      nothingChanged: 'Nenhuma alteração para salvar.',
      saving: 'Salvando…',
      remove: 'Remover',
      statuses: {
        title: 'Status do detalhamento',
        hint: 'Você pode renomear os status. Cada um tem uma regra própria de entrada, por isso a lista é fixa.',
        columns: { name: 'Nome exibido', rule: 'Quando se aplica' },
        nameAria: 'Nome do status {status}',
        save: 'Salvar nomes',
        saved: 'Nomes dos status salvos',
        error: 'Não foi possível salvar os nomes dos status.',
        rules: {
          toDetail: '3D aprovado, detalhamento ainda não iniciado.',
          detailing: 'Equipe detalhando.',
          awaitingMeeting: 'Detalhamento ou correção entregue, aguardando a reunião com o cliente.',
          correction: 'Reunião feita com apontamentos do cliente; tem prazo próprio e pode continuar mesmo depois do protocolo.',
          paused: 'Parado por decisão do cliente ou do escritório; os dias úteis pausados estendem o prazo.',
          conferred: 'Reunião feita e correções entregues (ou dispensadas); fica na lista até a 1ª entrada.',
          skippedConference: 'Projeto segue para a prefeitura sem a reunião de conferência (para adiantar ou porque o cliente não pode); fica na lista até a 1ª entrada.',
        },
      },
      documents: {
        title: 'Documentos para a prefeitura',
        hint: 'Lista conferida na reunião de conferência do detalhamento. Validade em dias conta a partir da emissão (deixe em branco quando não vence).',
        columns: { name: 'Documento', provider: 'Quem providencia', validity: 'Validade (dias)' },
        nameAria: 'Documento',
        providerAria: 'Quem providencia',
        validityAria: 'Validade em dias',
        add: 'Incluir documento',
        save: 'Salvar documentos',
        saved: 'Lista de documentos salva',
        error: 'Não foi possível salvar a lista de documentos.',
        atLeastOne: 'Mantenha pelo menos um documento, com nome.',
        invalidValidity: 'A validade deve ser em dias inteiros, a partir de 1.',
        defaultProvider: 'Cliente',
      },
      condos: {
        title: 'Prazo de análise dos condomínios',
        hint: 'Passado o prazo desde o envio, o condomínio aparece como atrasado. Condomínios sem prazo próprio usam o padrão.',
        defaultDays: 'Prazo padrão (dias)',
        counting: 'Contagem',
        calendar: 'Dias corridos',
        business: 'Dias úteis',
        columns: { name: 'Condomínio', days: 'Prazo (dias)' },
        daysAria: 'Prazo de {name}',
        empty: 'Nenhum condomínio cadastrado.',
        newName: 'Nome do condomínio',
        add: 'Incluir condomínio',
        typeNameFirst: 'Digite o nome do condomínio.',
        save: 'Salvar condomínios',
        saved: 'Prazos dos condomínios salvos',
        error: 'Não foi possível salvar os condomínios.',
        invalid: 'Use números inteiros de dias, a partir de 1.',
      },
    },
    /** The detailing statuses' default names (Parâmetros renames them). */
    status: {
      toDetail: 'A detalhar',
      detailing: 'Em detalhamento',
      awaitingMeeting: 'Aguardando reunião de conferência',
      correction: 'Correção do detalhamento',
      paused: 'Pausado',
      conferred: 'Detalhamento conferido',
      skippedConference: 'Seguiu sem conferência',
    },
    /** The status filter's shorter label, while the status keeps its default name. */
    statusShort: {
      awaitingMeeting: 'Aguardando reunião',
    },
    list: {
      search: 'Buscar',
      searchPlaceholder: 'Cliente, projeto ou responsável',
      statusAria: 'Status',
      all: 'Todos',
      /** The status filter's last option: the archived flows only. */
      archived: 'Arquivados',
      newDetailing: 'Novo detalhamento',
      empty: 'Nenhum cliente com esses filtros.',
      client_one: '{count} cliente',
      client_other: '{count} clientes',
      footer: 'prazo em dias úteis contado da aprovação do 3D · conferidos e os que seguiram sem conferência ficam na lista até a 1ª entrada; reunião ou correção pendente continua aparecendo mesmo depois do protocolo',
      filed: 'protocolado',
      filedHint: 'O projeto já deu entrada na prefeitura',
      toBeDefined: 'a definir',
    },
    columns: {
      client: 'Cliente',
      approval3d: 'Aprovação do 3D',
      deadline: 'Prazo de entrega',
      status: 'Status',
      meeting: 'Reunião de conferência',
      documents: 'Documentos',
      facade: 'Fachada',
      detailedBy: 'Detalhado por',
    },
    deadline: {
      late: 'atrasado {days}',
      dueToday: 'vence hoje',
      left: 'faltam {days}',
      /** Before the days when the deadline is a correction's: "correção · faltam 3 dias úteis". */
      inCorrection: 'correção · {text}',
      none: 'sem prazo',
      /** No detailing deadline yet: it comes from the project's deadlines, or is typed in the ficha. */
      toBeSet: 'prazo a definir',
      pausedSince: 'pausado desde {date}',
      pausedSinceReason: 'pausado desde {date} · {reason}',
      deliveredOn: 'entregue em {date}',
      delivered: 'entregue',
    },
    meeting: {
      notHeld: 'Não realizada',
      skipped: 'seguiu sem conferência',
      skippedReason: 'seguiu sem conferência · {reason}',
      heldOn: 'Feita em {date}',
      held: 'Feita',
      withCorrections: 'com correções',
      withCorrectionsNth: 'com correções ({number}ª)',
      markedOnProcess: 'marcada na ficha do processo',
      waived: 'correção dispensada',
      correctionDelivered: 'correção entregue',
      approved: 'aprovado sem correções',
      toDo: 'A fazer',
      alreadyFiled: 'projeto já protocolado',
      delivered: 'detalhamento entregue',
    },
    documents: {
      allOk: 'Todos ok',
      count: '{ok} de {total}',
      ready: '{ok} de {total} prontos',
      expired_one: '{count} vencido',
      expired_other: '{count} vencidos',
    },
    dialog: {
      eyebrow: 'Detalhamento',
      title: 'Novo detalhamento',
      close: 'Fechar',
      intro: 'Registra a aprovação do 3D e o prazo do detalhamento. O projeto passa a aparecer no detalhamento e no fluxo do projeto.',
      project: 'Projeto',
      projectPlaceholder: 'Escolha o projeto',
      projectSearch: 'Buscar projeto ou cliente',
      projectEmpty: 'Nenhum projeto sem detalhamento.',
      approval3d: 'Aprovação do 3D',
      days: 'Prazo do detalhamento (dias úteis)',
      daysBlank: 'Em branco: prazo a definir.',
      initialStatus: 'Status inicial',
      facadeResponsible: 'Responsável pela fachada',
      datePlaceholder: 'dd/mm/aaaa',
      computed: 'Entrega do detalhamento até {date} ({days}).',
      submit: 'Incluir no detalhamento',
      saving: 'Salvando…',
      cancel: 'Cancelar',
      saveError: 'Não foi possível incluir o projeto no detalhamento.',
      created: '{client} incluído no detalhamento.',
    },
    /** "Aprovar 3D" in the project header: the project enters the detailing as A detalhar. */
    approve3d: {
      button: 'Aprovar 3D',
      title: 'Aprovar 3D',
      intro: 'Registre a data em que o cliente aprovou o 3D. O projeto entra no detalhamento como A detalhar, com prazo a definir.',
      date: 'Aprovação do cliente',
      submit: 'Aprovar 3D',
      saving: 'Salvando…',
      cancel: 'Cancelar',
      close: 'Fechar',
      approved: '3D aprovado. {client} entrou no detalhamento como A detalhar.',
      error: 'Não foi possível aprovar o 3D.',
      open: 'No detalhamento',
    },
    /** The Fluxo do projeto tab: KPIs and one column per stage. */
    board: {
      columns: {
        detailing: 'Em detalhamento',
        meeting: 'Reunião de conferência',
        documents: 'Documentos',
        toFile: 'Pronto para protocolar',
        cityHall: 'Prefeitura e condomínio',
        done: 'Concluído',
      },
      doneHint: 'Alvarás dos últimos {days} dias',
      empty: 'Nenhum projeto',
      kpiLate: 'Detalhamento atrasado',
      kpiLateNote: 'de {count} em detalhamento, em dias úteis',
      kpiMeetings: 'Reuniões de conferência',
      kpiMeetingsNote: 'detalhamento entregue, reunião a fazer',
      kpiDocuments: 'Documentos pendentes',
      kpiDocumentsNote: 'conferência feita, faltam documentos',
      kpiToFile: 'Prontos para protocolar',
      kpiToFileNote: 'tudo em mãos para a 1ª entrada',
      kpiCondo: 'Análise do condomínio',
      kpiCondoLate: '{count} além do prazo do condomínio',
      kpiCondoNone: 'nenhum além do prazo',
      footer: 'Entram aqui os projetos do detalhamento e, sem detalhamento cadastrado, os processos em andamento e os alvarás recentes. Os registros de conferência, documentos e condomínio ficam na ficha do fluxo.',
    },
    /** A card of the Fluxo do projeto. */
    card: {
      pausedSince: 'desde {date}',
      deadlineOn: 'prazo {date}',
      noDeadline: 'sem prazo de entrega',
      detailedBy: 'Detalhado por {name}',
      deliveredAgo: 'entregue em {date} · há {days}',
      delivered: 'detalhamento entregue',
      documentsComplete: 'documentos completos',
      permitOn: 'alvará em {date}',
      paused: 'pausado',
      processOnly: 'sem detalhamento',
      processOnlyHint: 'Processo sem detalhamento cadastrado',
    },
    /** Where the condomínio's analysis stands. */
    condo: {
      undefined: 'Condomínio a definir',
      notCondo: 'Não é condomínio',
      approved: 'Condomínio aprovado',
      toSend: 'Enviar ao condomínio',
      atCondo: 'Com o condomínio há {days}',
      late: 'Condomínio atrasado ({days})',
      changes: 'Correções do condomínio',
    },
    /** The ficha of a flow (/prefeitura/fluxo/[id]). */
    ficha: {
      back: 'Fluxo do projeto',
      eyebrow: 'Fluxo do projeto',
      project: 'Projeto {name}',
      openProcess: 'Processo na prefeitura',
      archivedNotice: 'Fluxo arquivado.',
      archivedLock: 'Fluxo arquivado',
      archive: 'Arquivar',
      archiveTitle: 'Arquivar fluxo',
      archiveConfirm: 'Arquivar o fluxo de {client}? Ele sai do detalhamento e do quadro; dá para recuperar em Detalhamento › Arquivados.',
      archived: 'Fluxo de {client} arquivado.',
      archiveError: 'Não foi possível arquivar o fluxo.',
      restore: 'Recuperar',
      restored: 'Fluxo de {client} recuperado.',
      restoreError: 'Não foi possível recuperar o fluxo.',
      cancel: 'Cancelar',
      noPermission: 'Sem permissão para editar',
      save: 'Gravar',
      saveError: 'Não foi possível registrar agora. Tente de novo.',
      datePlaceholder: 'dd/mm/aaaa',
      futureDate: 'A data não pode ser no futuro.',
      reasonOptional: 'Motivo (opcional)',
      steps: {
        title: 'Etapas',
        approval3d: '3D aprovado',
        facadeResponsible: 'Responsável pela fachada',
        facadePlaceholder: 'Quem criou a fachada',
        facadeSaved: 'Responsável pela fachada gravado.',
        facadeRemoved: 'Responsável pela fachada removido.',
        detailedBy: 'Detalhado por',
        detailedByPlaceholder: 'Quem detalhou o projeto',
        detailedBySaved: 'Detalhado por gravado.',
        detailedByRemoved: 'Detalhado por removido.',
        daysLabel: 'Prazo do detalhamento (dias úteis)',
        daysPlaceholder: 'Em branco: prazo a definir',
        daysSaved: 'Prazo do detalhamento gravado.',
        daysCleared: 'Prazo do detalhamento removido: prazo a definir.',
        daysToBeSet: 'Prazo a definir',
        correctedBy: 'Correção feita por',
        correctedByPlaceholder: 'Quem fez a correção',
        detailing: 'Detalhamento',
        statusAria: 'Status do detalhamento',
        deliveredOn: 'Entregue em {date}',
        done: 'Concluído',
        undoDelivery: 'desfazer a entrega',
        deliveryUndone: 'Entrega do detalhamento desfeita.',
        daysOf: 'Prazo de {days}',
        correctionDeadline: 'Correção',
        noCorrectionDeadline: 'Correção sem prazo',
        until: 'até {date} · {text}',
        pausedDeadline: 'até {date}, mais os dias da pausa',
        startedSaved: 'Detalhamento iniciado.',
        toDetailSaved: 'Voltou para a detalhar.',
        deliveryDate: 'Entregue em',
        correctionDeliveryDate: 'Correção entregue em',
        newMeeting: 'Fazer nova reunião de conferência',
        registerDelivery: 'Registrar entrega',
        registerCorrectionDelivery: 'Registrar correção entregue',
        deliverySaved: 'Entrega do detalhamento registrada. Agende a reunião de conferência.',
        correctionDeliveredNewMeeting: 'Correção entregue. Agende a nova reunião de conferência.',
        correctionDelivered: 'Correção entregue. Detalhamento conferido.',
        waive: 'Seguir sem a correção',
        waiveReasonPlaceholder: 'Ex.: ajustes ficam para a próxima análise',
        waiveSubmit: 'Dispensar a correção',
        waived: 'Correção dispensada.',
        correction: '{number}ª correção pedida na reunião de {date}',
        correctionDue: 'prazo {date}',
        correctionDeliveredOn: 'entregue {date}',
        correctionWaivedOn: 'dispensada {date}',
        correctionBy: 'feita por {name}',
        pause: 'Pausar o detalhamento',
        pausedOn: 'Pausado em',
        pauseReasonPlaceholder: 'Ex.: cliente revendo o programa',
        pauseSubmit: 'Pausar',
        paused: 'Detalhamento pausado.',
        pausedSince: 'desde {date}',
        pausedSinceReason: 'desde {date} · {reason}',
        resumedOn: 'Retomado em',
        resume: 'Retomar',
        resumed: 'Detalhamento retomado; o prazo foi estendido pelos dias pausados.',
        pauseHint: 'Os dias úteis pausados são somados ao prazo de entrega.',
        pauseHistory: 'pausado de {from} a {to}',
        pauseHistoryReason: 'pausado de {from} a {to} ({reason})',
        meeting: 'Reunião de conferência com o cliente',
        skippedOn: 'Não realizada: seguiu sem conferência em {date}',
        skippedOnReason: 'Não realizada: seguiu sem conferência em {date} · {reason}',
        undoSkip: 'desfazer (a reunião ainda vai acontecer)',
        skipUndone: 'Reunião de conferência volta a ficar pendente.',
        heldApproved: 'Feita em {date}, detalhamento aprovado',
        heldCorrectionDelivered: 'Feita em {date}, correção entregue',
        heldWaived: 'Feita em {date}, com correções dispensadas',
        heldWaivedReason: 'Feita em {date}, com correções dispensadas ({reason})',
        markedOnProcess: 'Marcada como feita na ficha do processo',
        inCorrection: 'Feita em {date}, com apontamentos do cliente. A correção pode seguir mesmo depois do protocolo.',
        meetingDate: 'Feita em',
        correctionDueField: 'Prazo da correção (se houver)',
        correctionNotes: 'O que corrigir (se houver)',
        approve: 'Aprovado, sem correções',
        askCorrection: 'Pedir correção',
        meetingSaved: 'Reunião de conferência registrada.',
        correctionSaved: 'Reunião feita com correções registrada.',
        dueBeforeToday: 'O prazo da correção não pode ser antes de hoje.',
        meetingHint: 'Na reunião, confira com o cliente os documentos ao lado.',
        skip: 'Seguir sem a reunião de conferência',
        skipReasonPlaceholder: 'Ex.: adiantar o processo; cliente sem agenda',
        skipSubmit: 'Seguir sem conferência',
        skipped: 'Segue sem a reunião de conferência.',
        afterDelivery: 'Depois da entrega do detalhamento',
        documents: 'Documentos para a prefeitura',
        firstEntry: '1ª entrada na prefeitura',
        filed: 'Processo na prefeitura',
        filedNumber: 'Processo {number}',
        noEntry: 'Processo criado, sem entrada registrada. Registre pela ficha do processo.',
        readyToFile: 'Tudo pronto para protocolar.',
        documentsPending: 'Ainda há documentos pendentes.',
        fileBefore: 'Dá para protocolar antes; a reunião ou a correção continua pendente aqui.',
        file: 'Protocolar na prefeitura',
        fileSubmit: 'Protocolar',
        filedSaved: 'Processo criado na prefeitura.',
        permit: 'Alvará',
        permitOn: 'Emitido em {date}',
        reviewOf: '{number}ª análise',
      },
      documents: {
        title: 'Documentos para a prefeitura',
        stateAria: 'Situação de {name}',
        requestedOn: 'solicitado em {date}',
        receivedOn: 'recebido em {date}',
        issuedOn: 'Emitida em',
        validUntil: 'Vale até {date}',
        expiredOn: 'Venceu em {date}',
        validity: 'Vale {days} dias após a emissão',
        saved: '{name}: {state}.',
        issuedSaved: 'Data de emissão gravada.',
        footer: 'Os itens da lista são definidos em Parâmetros.',
      },
      /** The document states, as the segmented control names them. */
      docState: {
        pending: 'Pendente',
        requested: 'Solicitado',
        received: 'Recebido',
        na: 'Não se aplica',
      },
      condo: {
        title: 'Condomínio',
        aria: 'É condomínio?',
        yes: 'É condomínio',
        no: 'Não é condomínio',
        yesSaved: 'Marcado como projeto de condomínio.',
        noSaved: 'Marcado como projeto sem condomínio.',
        name: 'Condomínio',
        namePlaceholder: 'Nome do condomínio',
        nameSaved: 'Condomínio gravado.',
        deadlineCalendar_one: 'Prazo de análise: {count} dia corrido',
        deadlineCalendar_other: 'Prazo de análise: {count} dias corridos',
        deadlineBusiness_one: 'Prazo de análise: {count} dia útil',
        deadlineBusiness_other: 'Prazo de análise: {count} dias úteis',
        deadlineDefault: '(padrão; defina o prazo deste condomínio em Parâmetros)',
        reviewsAria: 'Envios ao condomínio',
        send: 'Envio',
        return: 'Retorno',
        ordinal: '{number}º',
        approved: 'Aprovado',
        changes: 'Pediu correções',
        resultNotes: '{result}: {notes}',
        sendOf: '{number}º envio ao condomínio',
        registerSend: 'Registrar envio',
        sendSaved: '{number}º envio ao condomínio registrado.',
        returnDate: 'Retorno do condomínio',
        resultAria: 'Resultado do retorno',
        resultApproved: 'Aprovado',
        resultChanges: 'Com correções',
        notes: 'Observações (opcional)',
        registerReturn: 'Registrar retorno',
        approvedSaved: 'Aprovação do condomínio registrada.',
        changesSaved: 'Correções do condomínio registradas.',
        approvedOnProcess: 'Aprovação marcada na ficha do processo.',
        notCondoHint: 'Sem análise de condomínio.',
        undefinedHint: 'Indique se o projeto passa pela aprovação do condomínio. Se passar, o envio acompanha a 1ª entrada na prefeitura.',
      },
      link: {
        title: 'Processo na prefeitura',
        process: 'Processo {number}',
        noNumber: 'Processo sem número',
        none: 'Ainda sem processo na prefeitura. Ele é criado ao protocolar.',
      },
      notes: {
        title: 'Observações do fluxo',
        placeholder: 'Anotações da conferência, contatos com responsáveis, pendências',
        save: 'Gravar observação',
        saved: 'Observação gravada.',
      },
    },
  },
  technicalReserves: {
    title: 'RT – reservas técnicas',
    hint: 'RTs lançadas aqui, com o que já entrou, o que está a receber e a comissão da equipe.',
    year: 'Ano',
    loading: 'Carregando as RTs…',
    loadError: 'Não foi possível carregar as RTs.',
    rt_one: '{count} RT',
    rt_other: '{count} RTs',
    notInformed: 'Não informado',
    nothingReceived: 'Nada recebido no período.',
    tabs: { aria: 'Seções da RT', overview: 'Visão geral', quotes: 'Controle de orçamentos', commission: 'Comissão da equipe' },
    monthsShort: {
      '1': 'Jan', '2': 'Fev', '3': 'Mar', '4': 'Abr', '5': 'Mai', '6': 'Jun',
      '7': 'Jul', '8': 'Ago', '9': 'Set', '10': 'Out', '11': 'Nov', '12': 'Dez',
    },
    monthsLong: {
      '1': 'janeiro', '2': 'fevereiro', '3': 'março', '4': 'abril', '5': 'maio', '6': 'junho',
      '7': 'julho', '8': 'agosto', '9': 'setembro', '10': 'outubro', '11': 'novembro', '12': 'dezembro',
    },
    status: { pending: 'A receber', received: 'Recebida', overdue: 'Atrasada', lost: 'Perdida' },
    paymentMethods: {
      office: 'Conta do escritório',
      credit: 'Crédito em compra para o escritório',
      proLabore: 'Pró-labore',
      partnerAccount: 'Conta pessoal de sócia',
      other: 'Outros',
    },
    kpis: {
      received: 'Recebido em {year}',
      januaryTo: 'janeiro a {month}',
      wholeYear: 'ano inteiro',
      variation: '{variation} sobre o mesmo período de {year} ({value})',
      monthlyAverage: 'Média mensal',
      months_one: '{count} mês ({period})',
      months_other: '{count} meses ({period})',
      pending: 'A receber',
      pendingNote: '{count} · {withDate} com data prevista, {withoutDate} sem data',
      overdue: 'Atrasadas',
      overdueNote_one: '{count} RT passou da data prevista',
      overdueNote_other: '{count} RTs passaram da data prevista',
      overdueNone: 'nenhuma passou da data prevista',
    },
    byMonth: {
      title: 'Recebido por mês',
      subtitle: 'pela data do pagamento em {year}',
      received: 'Recebido',
      count: 'RTs recebidas',
      total: 'Total',
    },
    list: {
      title: 'RTs',
      editHint: 'clique nas datas e nos valores para editar',
      newReserve: 'Lançar RT a receber',
      searchPlaceholder: 'Buscar por cliente, fornecedor ou ID',
      searchAria: 'Buscar RT por cliente, fornecedor, ID, categoria ou observações',
      statusAria: 'Filtrar pela situação',
      statusPending: 'A receber {count}',
      statusReceived: 'Recebidas {count}',
      statusLost: 'Perdidas {count}',
      statusAll: 'Todas {count}',
      periodAria: 'Período',
      periodYear: 'Ano escolhido',
      periodAll: 'Todos os anos',
      outsideOffice: 'Só fora da conta do escritório',
      infoPending: '{count} a receber · {value}',
      info: '{count} · {value}',
      infoAllYears: 'em todos os anos',
      infoTruncated: 'mostrando as {limit} mais recentes',
      infoNoMatch: 'nenhuma RT com essa busca',
      receivableTitle: 'A receber por mês, pela data prevista',
      receivableOverdue: 'Atrasadas',
      receivableNone: 'Sem data',
      receivableValue: 'Valor',
      receivableCount: 'RTs',
      receivableTotal: 'Total',
      sectionOverdue: 'Atrasadas · {count}',
      sectionWithDate: 'Com data prevista · {count}',
      sectionWithoutDate: 'Sem data prevista · {count}',
      colCode: 'ID',
      colClient: 'Cliente',
      colSupplier: 'Fornecedor',
      colOrderedOn: 'Pedido em',
      colExpected: 'Previsto',
      colPaid: 'Pago em',
      colPaidOrExpected: 'Pago / previsto',
      colOrderValue: 'Valor do pedido',
      colRate: 'RT',
      colAmount: 'Valor RT',
      colStatus: 'Situação',
      expectedNote: 'previsto',
      toDefine: 'a definir',
      emptyPending: 'Nenhuma RT a receber.',
      emptyPendingSearch: 'Nenhuma RT a receber com essa busca.',
      empty: 'Nenhuma RT com esses filtros.',
      editAria: 'Editar {field} de {code}',
      statusMenuAria: 'Situação de {code}: {status}. Mudar situação',
      delete: 'Excluir {code}',
      deleteConfirm: 'Excluir?',
      deleteConfirmAria: 'Confirmar a exclusão de {code}',
      updated: '{code} atualizada',
      updatedRecalc: '{code} atualizada (valor da RT recalculado: {value})',
      updateError: 'Não foi possível salvar a alteração.',
      invalidDate: 'Data inválida. Use dd/mm/aaaa.',
      invalidRate: 'Percentual inválido. Use um número entre 0 e 100.',
      receivedOn: '{code} recebida em {date} (clique na data para mudar)',
      statusChanged: '{code}: {status}',
      statusError: 'Não foi possível mudar a situação.',
      deleted: '{code} excluída',
      deleteError: 'Não foi possível excluir a RT.',
      editValueAria: 'Editar {field} de {code}: {value}',
      emptyValue: 'não informado',
      fields: {
        orderedOn: 'data do pedido',
        expectedOn: 'data prevista',
        paidOn: 'data do pagamento',
        orderValueCents: 'valor do pedido',
        rate: 'percentual da RT',
        amountCents: 'valor da RT',
      },
    },
    dialog: {
      eyebrow: 'RT a receber',
      title: 'Lançar RT',
      close: 'Fechar',
      client: 'Cliente',
      clientPlaceholder: 'Nome do cliente',
      projectType: 'Tipo de projeto',
      projectTypePlaceholder: 'Selecione',
      supplier: 'Fornecedor',
      category: 'Categoria',
      pickPlaceholder: 'Digite ou escolha',
      paymentMethod: 'Forma de recebimento',
      orderValue: 'Valor do pedido',
      rate: 'RT (%)',
      ratePlaceholder: 'Ex.: 5',
      amount: 'Valor da RT',
      amountHint: 'calculado pelo pedido e %',
      orderedOn: 'Data do pedido',
      expectedOn: 'Data prevista para receber',
      expectedSuggested: 'sugestão: 30 dias após o pedido',
      expectedTyped: 'data informada',
      expectedNone: 'sem data prevista',
      datePlaceholder: 'dd/mm/aaaa',
      notes: 'Observações',
      info: 'Fica registrada como A receber, com o ID {code}.',
      cancel: 'Cancelar',
      submit: 'Lançar RT',
      saving: 'Salvando…',
      created: '{code} lançada',
      saveError: 'Não foi possível lançar a RT.',
    },
    byClient: {
      title: 'Por cliente',
      searchPlaceholder: 'Buscar cliente',
      statusAria: 'Situação',
      periodAria: 'Período',
      order: 'Ordem',
      orderValue: 'Maior valor',
      orderAlpha: 'Alfabética',
      orderCount: 'Mais RTs',
      orderRecent: 'Mais recente',
      statusReceived: 'Recebidas',
      statusPending: 'A receber',
      statusLost: 'Perdidas',
      statusAll: 'Todas',
      colClient: 'Cliente',
      colCount: 'RTs',
      colReceived: 'Recebido',
      colPending: 'A receber',
      colLost: 'Perdido',
      colLast: 'Última RT',
      total: { received: 'Recebido', pending: 'A receber', lost: 'Perdido', all: 'Total' },
      totalLower: { received: 'recebido', pending: 'a receber', lost: 'perdido', all: 'total' },
      clients_one: '{count} cliente',
      clients_other: '{count} clientes',
      info: '{clients} · {value} {status} · {period}',
      allYears: 'todos os anos',
      showInList: 'Ver as RTs de {client} na lista',
      emptySearch: 'Nenhum cliente com essa busca.',
      empty: 'Nenhuma RT nessa situação.',
    },
    ranking: {
      supplier: 'Por fornecedor',
      category: 'Por categoria',
      subtitle: 'recebido em {year}',
    },
    byYear: {
      title: 'Recebido por ano',
      subtitle: 'pela data do pagamento',
      chartAria: 'Recebido por ano, em barras',
      colYear: 'Ano',
      colReceived: 'Recebido',
      colCount: 'RTs',
      colVariation: 'Variação',
      untilToday: 'até hoje',
      samePeriod: 'mesmo período',
      samePeriodTitle: 'Comparado com o mesmo período de {year}',
      total: 'Total',
      barTitle: '{year}: {value} · {count}',
    },
    byProjectType: {
      title: 'Por tipo de projeto',
      allYears: 'Todos os anos',
      subtitleYear: '% do recebido em {year}',
      subtitleCurrent: '% do recebido em {year} (até hoje)',
      subtitleAll: '% do recebido em todos os anos',
      barAria: 'Distribuição por tipo de projeto',
      segmentTitle: '{name}: {percent} ({value})',
    },
    commission: {
      loading: 'Carregando a comissão…',
      loadError: 'Não foi possível carregar a comissão da equipe.',
      semester: '{half}º semestre {year}',
      people_one: '{count} pessoa',
      people_other: '{count} pessoas',
      kpis: {
        received: 'RT recebida no {semester}',
        receivedNote: '{count} até hoje',
        commission: 'Comissão até agora ({percent})',
        commissionNote: '{value} para cada uma das {people}',
        projection: 'Projeção do semestre',
        projectionNote_one: 'somando {count} RT prevista até {date} ({value}) · {each} cada',
        projectionNote_other: 'somando {count} RTs previstas até {date} ({value}) · {each} cada',
        projectionNone: 'nenhuma RT a receber com data prevista no semestre',
        lastPayment: 'Último pagamento',
        lastPaymentNote: '{reference} · pago em {date} · {each} cada',
        lastPaymentNone: 'nenhum registrado',
      },
      semesters: {
        title: 'Comissão da equipe por semestre',
        rule: '{percent} sobre todas as RTs recebidas no semestre (pela data do pagamento), dividido igualmente entre {people}.',
        expandHint: 'clique no semestre para ver as RTs',
        toggle: 'Ver as RTs do {semester}',
        colSemester: 'Semestre',
        colCount: 'RTs',
        colReceived: 'RT recebida',
        colCommission: 'Comissão',
        colPerPerson: 'Individual',
        colStatus: 'Situação',
        colPaid: 'Pago',
        paidOn: 'Pago em {date}',
        current: 'Em andamento',
        due: 'A pagar',
        basePaid: 'base paga {value} ({difference})',
        basePaidTitle: 'A base registrada no pagamento ({value}) é diferente da soma atual das RTs recebidas no semestre',
        register: 'Registrar pagamento',
        noReserves: 'Nenhuma RT recebida neste semestre.',
      },
      payments: {
        title: 'Pagamentos registrados',
        hint: 'pagamentos da comissão registrados aqui',
        colDate: 'Data',
        colReference: 'Referência',
        colBase: 'Base',
        colCommission: 'Comissão',
        colPerPerson: 'Individual',
        colRecipients: 'Quem recebeu',
        empty: 'Nenhum pagamento registrado.',
        deleteTarget: 'pagamento do {reference}',
        deleted: 'Pagamento do {reference} excluído',
        deleteError: 'Não foi possível excluir o pagamento.',
      },
      dialog: {
        eyebrow: 'Comissão da equipe',
        title: 'Registrar pagamento',
        close: 'Fechar',
        reference: 'Referência',
        paidOn: 'Data do pagamento',
        datePlaceholder: 'dd/mm/aaaa',
        base: 'Base – RT recebida',
        rate: 'Comissão (%)',
        recipients: 'Quem recebeu',
        recipientsPlaceholder: 'Nomes separados por vírgula',
        calc: 'Comissão: {commission} · {people}: {each} cada · média mensal da base: {monthly}',
        cancel: 'Cancelar',
        submit: 'Registrar pagamento',
        saving: 'Salvando…',
        saved: 'Pagamento do {reference} registrado',
        saveError: 'Não foi possível registrar o pagamento.',
      },
    },
  },
  supplierQuotes: {
    hint: 'Orçamentos pedidos a fornecedores para cada cliente: o que foi orçado, o que ainda pode fechar e o que virou RT.',
    loading: 'Carregando os orçamentos…',
    loadError: 'Não foi possível carregar os orçamentos.',
    new: 'Novo orçamento',
    status: { toSend: 'A enviar', requested: 'Aguardando', received: 'Recebido', negotiating: 'Em negociação', won: 'Fechado', lost: 'Perdido' },
    kpis: {
      total: 'Oportunidade total', totalNote: 'O menor orçamento de cada categoria',
      open: 'Perspectiva a fechar', openNote: '{share} da oportunidade, ainda em aberto',
      openRt: 'RT prevista a fechar', openRtNote: '{share} da perspectiva · 5% quando a % de RT não foi informada',
      won: 'Fechado', wonNote: 'Virou RT · {share}',
      lost: 'Perdido', lostNote: '{share} da oportunidade',
      requested: 'Aguardando resposta', requestedNote: 'Pedidos sem valor ainda · {toSend} a enviar',
    },
    filters: {
      aria: 'Filtrar clientes', all: 'Todos', open: 'Com perspectiva', toSend: 'A enviar', requested: 'Aguardando',
      search: 'Buscar cliente, obra, fornecedor ou categoria',
      viewAria: 'Ver por', byClient: 'Por cliente', bySupplier: 'Por fornecedor',
    },
    byClient: {
      title: 'Por cliente', subtitle: 'Ordenado pela maior perspectiva a fechar',
      colClient: 'Cliente', colCount: 'Orçamentos', colTotal: 'Oportunidade', colWon: 'Fechado (RT)', colLost: 'Perdido',
      colOpen: 'Perspectiva a fechar', colProgress: 'Andamento',
      waiting: '{count} aguardando', toSend: '{count} a enviar',
      expand: 'Mostrar os orçamentos de {client}', collapse: 'Esconder os orçamentos de {client}',
      noProject: 'Sem obra', projectOpen: 'Perspectiva desta obra:', addInProject: '+ orçamento nesta obra', addSupplier: '+ fornecedor',
      categoryCount_one: '{count} orçamento', categoryCount_other: '{count} orçamentos',
      categoryOpen: 'Conta na perspectiva:', categoryRt: 'RT prevista:', openRt: 'RT prevista {value}', categoryWon: 'Fechado · {value}', awaitingValues: 'Aguardando valores', notSent: 'Ainda não enviado',
      legendWon: 'Fechado', legendOpen: 'Perspectiva', legendLost: 'Perdido',
      legendRule: 'Em cada categoria conta só o menor orçamento recebido. Se a categoria fechou, conta o valor fechado.',
      progressAria: 'Fechado {won}, perspectiva {open}, perdido {lost}',
      empty: 'Nenhum orçamento lançado ainda. Use "Novo orçamento" para anotar o primeiro.',
      emptyFilter: 'Nenhum cliente com esse filtro ou busca.',
    },
    row: {
      colSupplier: 'Fornecedor', colRequestedOn: 'Pedido em', colStatus: 'Status', colValue: 'Valor', colRate: '% RT', colActions: 'Ações',
      cheapest: 'menor', cheapestHint: 'O menor orçamento recebido nesta categoria: é ele que conta na perspectiva.',
      markSent: 'Marcar como enviado', arrived: 'Chegou · informar valor', negotiate: 'Negociando', close: 'Fechou · gerar RT',
      lost: 'Perdido', reopen: 'Reabrir', generatedRt: 'Gerou a', rtGone: 'A RT gerada foi excluída',
      closeNeedsRt: 'Gerar a RT precisa da permissão de lançar RTs.',
      reopenNeedsRt: 'Mudar o status de um orçamento fechado tira a RT da lista e precisa da permissão de excluir RTs.',
      confirmRemovesRt: 'Confirmar: tira a {code} das RTs',
      rtRemoved: '{supplier}: {status}. A {code} saiu da lista de RTs.',
      deleteName: 'o orçamento de {supplier}',
      editValue: 'Valor do orçamento de {supplier}', editValueTrigger: 'Alterar o valor do orçamento de {supplier}: {value}',
      editRate: '% de RT prevista com {supplier}', editRateTrigger: 'Alterar a % de RT prevista com {supplier}: {rate}',
      editDate: 'Data do pedido a {supplier}', editDateTrigger: 'Alterar a data do pedido a {supplier}: {date}',
      addNote: '+ observação', noteAria: 'Observação do orçamento de {supplier}',
      updated: 'Orçamento de {supplier} atualizado.', statusChanged: '{supplier}: {status}.', deleted: 'Orçamento de {supplier} excluído.',
      updateError: 'Não foi possível atualizar o orçamento.', deleteError: 'Não foi possível excluir o orçamento.',
      invalidDate: 'Data inválida: use dd/mm/aaaa.',
      invalidRate: 'Percentual inválido: use um número entre 0 e 100.',
    },
    bySupplier: {
      title: 'Por fornecedor', subtitle: 'Só para consulta: quais clientes estão sendo orçados com cada um',
      colSupplier: 'Fornecedor', colClients: 'Clientes', colCount: 'Orçamentos', colToSend: 'A enviar', colRequested: 'Aguardando',
      colNegotiating: 'Em negociação', colWon: 'Fechados',
      empty: 'Nenhum fornecedor com esse filtro ou busca.',
    },
    dialog: {
      eyebrow: 'Controle de orçamentos', title: 'Novo orçamento', close: 'Fechar',
      client: 'Cliente', clientPlaceholder: 'Digite para buscar no cadastro',
      project: 'Obra', projectPlaceholder: 'Ex.: Casa Alphaville',
      category: 'Categoria', pickPlaceholder: 'Escolha ou digite',
      colSupplier: 'Fornecedor', colStatus: 'Status', colValue: 'Valor', colRate: '% RT', ratePlaceholder: 'Ex.: 10',
      rateAria: '% de RT prevista da linha {n}',
      supplierAria: 'Fornecedor da linha {n}', statusAria: 'Status da linha {n}', valueAria: 'Valor da linha {n}', noteAria: 'Observação da linha {n}',
      addSupplier: '+ outro fornecedor', removeSupplier: 'Remover a linha {n}', addNote: '+ observação', notePlaceholder: 'Ex.: falou que não vale a pena pelo espaço',
      valueHint: 'O valor abre quando o status é Recebido ou Em negociação. A % de RT prevista é opcional: sem ela, o card RT prevista a fechar conta 5%. Para um fornecedor só, basta deixar uma linha.',
      cancel: 'Cancelar', submit_one: 'Salvar orçamento', submit_other: 'Salvar {count} orçamentos', saving: 'Salvando…',
      saveError: 'Não foi possível salvar os orçamentos.',
      created_one: 'Orçamento lançado.', created_other: '{count} orçamentos lançados.',
    },
    value: {
      title: 'Orçamento recebido', subtitle: '{supplier} · {category} · {client}', label: 'Valor do orçamento',
      submit: 'Salvar', cancel: 'Cancelar',
    },
    close: {
      eyebrow: 'Fechou', title: 'Gerar RT',
      subtitle: '{client} fechou {category} com {supplier}. A RT entra como A receber na Visão geral.',
      value: 'Valor fechado', rate: 'RT (%)', ratePlaceholder: 'Ex.: 10', amount: 'Valor da RT', amountHint: 'Valor fechado × RT (%)',
      expectedOn: 'Previsão de recebimento', datePlaceholder: 'dd/mm/aaaa',
      submit: 'Gerar RT', cancel: 'Cancelar', saving: 'Gerando…', error: 'Não foi possível gerar a RT.',
      done: '{code} gerada a partir do orçamento de {supplier}.',
      rtNotes: 'Gerada do controle de orçamentos.', rtNotesProject: 'Gerada do controle de orçamentos · obra {project}.',
    },
  },
  forecast: {
    title: 'Previsão',
    tabs: { aria: 'Tipo de previsão', receivables: 'Previsão de entradas', payables: 'Previsão de saídas', cashFlow: 'Previsão do fluxo de caixa' },
    year: 'Ano',
    currentMonth: 'Mês atual',
    previousMonth: 'Mês anterior',
    nextMonth: 'Próximo mês',
    monthOfYear: '{month} de {year}',
    monthsShort: {
      '1': 'Jan', '2': 'Fev', '3': 'Mar', '4': 'Abr', '5': 'Mai', '6': 'Jun',
      '7': 'Jul', '8': 'Ago', '9': 'Set', '10': 'Out', '11': 'Nov', '12': 'Dez',
    },
    monthsLong: {
      '1': 'janeiro', '2': 'fevereiro', '3': 'março', '4': 'abril', '5': 'maio', '6': 'junho',
      '7': 'julho', '8': 'agosto', '9': 'setembro', '10': 'outubro', '11': 'novembro', '12': 'dezembro',
    },
    total: 'Total',
    accounts: { PF: 'PF – pessoa física', PJ: 'PJ – pessoa jurídica', Terrara: 'Terrara', none: 'Não informado' },
    dialog: {
      close: 'Fechar',
      cancel: 'Cancelar',
      save: 'Salvar',
      saving: 'Salvando…',
      unsaved: 'Há alterações não salvas. Feche de novo para descartar.',
      confirmDelete: 'Excluir mesmo? Clique de novo',
    },
    move: {
      submit: 'Mover',
      newMonth: 'Novo mês',
      invalid: 'Use o formato mm/aaaa',
      description: '{what}. Hoje prevista para {month}.',
    },
    loadError: 'Não foi possível carregar a previsão.',
    saveError: 'Não foi possível salvar. Tente novamente.',
    receivables: {
      // filled by the Previsão de entradas screen
      title: 'Previsão de entradas',
      hint: 'O que o escritório tem a receber mês a mês, a partir do plano de recebimento de cada contrato. Parcelas a confirmar (minuta não assinada ou m² enviado sem o ok do cliente) aparecem separadas. A RT fica à parte e não entra no total.',
      newEntry: 'Nova entrada avulsa',
      newEntryTitle: 'Reembolsos e outras entradas que não vêm de um contrato',
      loading: 'Carregando a previsão…',
      noPlans: 'Nenhum plano de recebimento ainda. Crie o primeiro pelo botão Criar plano de um contrato ou em Nova entrada avulsa.',
      categories: {
        contract: 'Contratos', additions: 'Adicionais', excessArea: 'M² excedente', management: 'Gerenciamento',
        processes: 'Processos', reimbursement: 'Reembolsos', other: 'Outras entradas', rt: 'RT',
      },
      situations: {
        expected: 'A receber', toConfirm: 'A confirmar', received: 'Recebida', cancelled: 'Cancelada', overdue: 'Atrasada', paused: 'Pausada',
      },
      situationAria: 'Mudar a situação: {situation}',
      installment_one: '{count} parcela',
      installment_other: '{count} parcelas',
      kpis: {
        planned: 'Previsto em {month}',
        plannedOtherYear: 'Previsto em {month} de {year}',
        plannedToConfirm: '{count} · {value} a confirmar',
        received: 'Recebido',
        receivedShare: '{share} do previsto no mês',
        nothingPlanned: 'nada previsto no mês',
        toReceive: 'A receber',
        firm_one: '{count} parcela firme',
        firm_other: '{count} parcelas firmes',
        firmExcept: '{firm}, fora {count} a confirmar',
        overdue: 'Atrasadas',
        overdueNote_one: '{count} parcela de meses anteriores',
        overdueNote_other: '{count} parcelas de meses anteriores',
        noOverdue: 'nenhuma parcela em atraso',
        rt: 'RT prevista no mês',
        rtNote: 'à parte, fora do total',
      },
      rows: { total: 'Total de entradas', received: 'Recebido', toReceive: 'A receber', toConfirm: 'A confirmar', rt: 'RT (à parte)' },
      matrix: {
        title: 'Quadro mensal',
        subtitle: '{year} · clique no mês para ver as parcelas',
        monthButton: 'Ver as parcelas de {month}',
        expand: 'Mostrar os planos de {category}',
        collapse: 'Esconder os planos de {category}',
      },
      grid: {
        title: 'Quadro por cliente',
        subtitle: 'uma linha por contrato, os meses lado a lado; clique no valor para mudar a situação',
        windowAria: 'Meses do quadro',
        window: 'Mês atual e próximos 12',
        year: 'Ano inteiro',
        showEmpty: 'Mostrar quem não tem parcela no período',
        searchPlaceholder: 'Buscar pelo cliente',
        searchAria: 'Buscar no quadro por cliente',
        range: '{from} a {to}',
        colClient: 'Cliente',
        colContract: 'Contrato',
        colInstallments: 'Parcelas',
        colToReceive: 'A receber',
        sections: { entries: 'Contratos e entradas', rt: 'RT · à parte, fora do total', paused: 'Pausados · fora da previsão' },
        expandSection: 'Mostrar {section}',
        collapseSection: 'Esconder {section}',
        client_one: '{count} cliente',
        client_other: '{count} clientes',
        empty: 'Nenhum contrato com parcela entre {from} e {to}.',
        several: '{count} parcelas neste mês: abrir o plano',
        cancelled: 'cancelada',
        due: 'venc. {day}',
        receivedCount: '{received} de {total} parcelas recebidas',
      },
      month: {
        info: '{received} recebidos de {total}',
        colDue: 'Venc.',
        colName: 'Contrato ou entrada',
        colCategory: 'Categoria',
        colValue: 'Valor',
        colSituation: 'Situação',
        colActions: 'Ações',
        noDay: 'sem dia',
        receivedOn: 'recebida em {date}',
        account: 'conta {account}',
        entries: 'Entradas · {count}',
        rt: 'RT · à parte, fora do total',
        empty: 'Nenhuma parcela prevista em {month}.',
        markReceived: 'Recebida',
        markReceivedTitle: 'Marcar como recebida hoje',
        move: 'Mover',
        moveTitle: 'Mudar o mês desta parcela',
        openPlan: 'Ver o plano de recebimento',
        pausedTitle: 'O contrato está pausado',
      },
      overdue: {
        title: 'Atrasadas',
        subtitle: '{count} · {value} · continuam no mês previsto até você marcar como recebida ou mover',
        colMonth: 'Mês previsto',
      },
      chart: { title: 'Previsto por mês', subtitle: 'recebido, a receber e a confirmar, sem a RT', aria: 'Entradas previstas por mês em {year}' },
      withoutPlan: {
        title: 'Contratos sem plano de recebimento',
        subtitle: 'fechados nos últimos 12 meses · {count}',
        contract_one: '{count} contrato',
        contract_other: '{count} contratos',
        colClosed: 'Fechamento',
        colClient: 'Cliente',
        colService: 'Serviço',
        colValue: 'Valor',
        upfront: 'à vista',
        create: 'Criar plano',
        createAria: 'Criar plano de recebimento para {client}',
        presetBoth: 'Arq + Int',
      },
      plans: {
        title: 'Planos de recebimento',
        subtitle: 'um plano por contrato ou entrada; clique no nome para ver e editar as parcelas',
        filterAria: 'Filtrar planos',
        filters: { active: 'Em andamento {count}', toConfirm: 'A confirmar {count}', paused: 'Pausados {count}', done: 'Concluídos {count}', all: 'Todos {count}' },
        searchPlaceholder: 'Buscar pelo cliente',
        searchAria: 'Buscar plano de recebimento pelo cliente',
        colName: 'Contrato ou entrada',
        colCategory: 'Categoria',
        colValue: 'Valor',
        colReceived: 'Recebido',
        colToReceive: 'A receber',
        colNext: 'Próxima parcela',
        noContract: 'sem contrato vinculado',
        linkedContract: 'contrato vinculado',
        pausedSince: 'pausado desde {date}',
        pausedNoDate: 'pausado',
        progress: '{share} recebido',
        nextValue: '{month} · {value}',
        toConfirm: 'a confirmar',
        overdue: 'atrasada',
        pausedPill: 'Pausado',
        allReceived: 'tudo recebido',
        emptyFilter: 'Nenhum plano nesta situação.',
        emptySearch: 'Nenhum plano encontrado com essa busca.',
      },
      moveTitle: 'Mover parcela',
      toasts: {
        status: 'Parcela: {situation}',
        received: 'Parcela marcada como recebida',
        moved: 'Parcela movida para {month}',
        created: 'Plano de recebimento criado',
        saved: 'Plano salvo',
        deleted: 'Plano excluído',
        deleteError: 'Não foi possível excluir',
        generated_one: '{count} parcela gerada. Confira e salve.',
        generated_other: '{count} parcelas geradas. Confira e salve.',
        paused: 'Contrato pausado. Salve para confirmar.',
        resumed: 'Plano retomado. Salve para confirmar.',
      },
      dialog: {
        eyebrow: 'Plano de recebimento',
        newTitle: 'Nova entrada',
        name: 'Nome',
        namePlaceholder: 'Ex.: Ikigai – Kelly e Gilberto',
        category: 'Categoria',
        dueDay: 'Dia do vencimento',
        account: 'Conta',
        value: 'Valor do contrato',
        notes: 'Observação',
        contracts: 'Contratos vinculados',
        noContracts: 'Nenhum contrato vinculado: entrada avulsa.',
        pause: 'Pausar contrato',
        pauseTitle: 'Tira as parcelas em aberto da previsão, sem apagá-las',
        pauseReason: 'Motivo da pausa (opcional)',
        confirmPause: 'Confirmar pausa',
        pausedSince: 'Contrato pausado desde {date}.',
        pausedNoDate: 'Contrato pausado.',
        pausedOpen: 'As {count} em aberto ({value}) ficam fora da previsão até a retomada.',
        resumeFrom: 'Retomar a partir de',
        resume: 'Retomar',
        resumeHint: 'Ao retomar, as parcelas em aberto passam para meses seguidos a partir do mês escolhido.',
        resumeInvalid: 'Informe o mês da retomada (mm/aaaa)',
        generate: 'Gerar parcelas',
        model: 'Modelo',
        models: { equal: 'Parcelas iguais', downPayment: 'Entrada + parcelas', stages: 'Por etapa do projeto' },
        distribute: 'Valor a distribuir',
        count: 'Nº de parcelas',
        countAfter: 'Parcelas após a entrada',
        downPayment: 'Entrada',
        firstMonth: 'Mês da 1ª parcela',
        downPaymentMonth: 'Mês da entrada',
        initialStatus: 'Situação inicial',
        initialExpected: 'A receber (contrato assinado)',
        initialToConfirm: 'A confirmar (minuta não assinada)',
        stageName: 'Etapa',
        stagePct: '%',
        stageMonth: 'Mês previsto',
        stageNameAria: 'Etapa {n}',
        stagePctAria: 'Percentual da etapa {n}',
        stageMonthAria: 'Mês previsto da etapa {n}',
        addStage: '+ Etapa',
        stagesSum: 'Soma das etapas: {pct}%',
        generateHint: 'As parcelas já recebidas são mantidas; as demais são substituídas.',
        installmentLabel: 'Parcela {i} de {n}',
        singleInstallment: 'Parcela única',
        downPaymentLabel: 'Entrada',
        stages: {
          signature: 'Assinatura do contrato',
          layout: 'Aprovação do layout',
          facade: 'Aprovação da fachada/3D',
          executive: 'Aprovação do projeto executivo',
          condominium: 'Protocolo no condomínio',
          cityHall: 'Entrada na prefeitura',
          permit: 'Emissão do alvará',
        },
        installments: 'Parcelas',
        addInstallment: 'Adicionar parcela',
        colMonth: 'Mês',
        colMilestone: 'Etapa ou observação',
        colValue: 'Valor',
        colSituation: 'Situação',
        colReceivedOn: 'Recebida em',
        monthAria: 'Mês da parcela {n}',
        milestoneAria: 'Etapa ou observação da parcela {n}',
        valueAria: 'Valor da parcela {n}',
        situationAria: 'Situação da parcela {n}',
        receivedOnAria: 'Data em que a parcela {n} foi recebida',
        removeAria: 'Remover parcela {n}',
        noInstallments: 'Nenhuma parcela ainda. Use Gerar parcelas ou Adicionar parcela.',
        sum: 'Soma das parcelas: {value}',
        received: 'Recebido: {value}',
        toReceive: 'A receber: {value}',
        missing: 'Faltam {value} para o valor do contrato',
        exceeds: 'Passa {value} do valor do contrato',
        delete: 'Excluir plano',
        save: 'Salvar plano',
        errors: {
          name: 'Informe o nome',
          month: 'Confira o mês das parcelas (mm/aaaa)',
          amount: 'Há parcela sem valor',
          distribute: 'Informe o valor a distribuir',
          stagesPct: 'Informe o percentual das etapas',
          stagesMonth: 'Informe o mês de cada etapa',
          firstMonth: 'Informe o mês no formato mm/aaaa',
          downPayment: 'Informe uma entrada menor que o valor a distribuir',
        },
      },
    },
    payables: {
      title: 'Previsão de saídas',
      eyebrow: 'Previsão de saídas',
      hint: 'O que o escritório tem a pagar mês a mês: salários, pró-labore, provisionamento, aplicação e as contas do escritório. As contas pessoais das sócias entram no total e aparecem como valor a descontar do pró-labore. A Terrara fica como lembrete, fora do total.',
      loading: 'Carregando as saídas…',
      empty: 'Nenhuma despesa cadastrada. Use Nova despesa para lançar a primeira.',
      emptyReadOnly: 'Nenhuma despesa cadastrada.',
      oneOffAction: 'Lançar pagamento',
      oneOffActionTitle: 'Algo pago que não estava previsto',
      newBill: 'Nova despesa',
      groups: {
        team: 'Salários e equipe', proLabore: 'Pró-labore', provisioning: 'Provisionamento', investment: 'Aplicação',
        office: 'Despesas do escritório', project: 'Custos de projeto', personal: 'Contas pessoais (a descontar do pró-labore)',
        reminder: 'Terrara (lembrete, fora do total)',
      },
      groupsShort: {
        team: 'Equipe', proLabore: 'Pró-labore', provisioning: 'Provisionamento', investment: 'Aplicação',
        office: 'Escritório', project: 'Custos de projeto', personal: 'Conta pessoal', reminder: 'Terrara',
      },
      personalPartners: 'Conta pessoal (sócias)',
      situation: { open: 'A pagar', paid: 'Paga', cancelled: 'Cancelada', overdue: 'Atrasada' },
      situationAria: 'Mudar a situação de {name} em {month}',
      bills_one: '{count} conta',
      bills_other: '{count} contas',
      totalOut: 'Total de saídas',
      paid: 'Pago',
      toPay: 'A pagar',
      account: 'conta {account}',
      method: 'Forma de pagamento',
      notes: 'Observação',
      noValue: 'sem valor',
      openBill: 'Ver e editar a conta',
      expand: 'Expandir {name}',
      collapse: 'Recolher {name}',
      kpis: {
        forecast: 'Saídas previstas em {month}',
        forecastOtherYear: 'Saídas previstas em {month} de {year}',
        paid: 'Pago',
        paidNote: '{share} do previsto no mês',
        nothingForecast: 'nada previsto no mês',
        toPay: 'A pagar',
        overdue: 'Atrasadas',
        overdueNote_one: '{count} conta de meses anteriores',
        overdueNote_other: '{count} contas de meses anteriores',
        overdueNone: 'nenhuma conta em atraso',
        personal: 'A descontar do pró-labore',
        personalHolder: '{holder} {value}',
        personalNone: 'nenhuma conta pessoal no mês',
      },
      matrix: {
        title: 'Quadro mensal',
        sub: '{years} · clique no mês para ver as contas',
        yearsTwo: '{year} e {next}',
        periodAria: 'Período do quadro mensal',
        onlyYear: 'Só o ano escolhido',
        twoYears: 'Ano escolhido e o seguinte',
        group: 'Grupo',
        total: 'Total',
        totalYear: 'Total {year}',
        discount: 'A descontar – {holder}',
        pickMonth: 'Ver as contas de {month}',
      },
      grid: {
        title: 'Quadro por conta',
        sub: 'uma linha por conta, os meses lado a lado; clique no valor para mudar a situação',
        subReadOnly: 'uma linha por conta, os meses lado a lado',
        windowAria: 'Meses do quadro',
        window: 'Mês atual e próximos 12',
        wholeYear: 'Ano inteiro',
        showEmpty: 'Mostrar contas sem valor no período',
        search: 'Buscar pela conta',
        searchAria: 'Buscar no quadro pela conta',
        range: '{from} a {to}',
        bill: 'Conta',
        due: 'Venc.',
        bankAccount: 'Conta bancária',
        toPayTitle: 'Soma do que está a pagar em todos os meses',
        dueDay: 'venc. {day}',
        reminderPaid: 'pago',
        reminderToPay: 'pagar',
        entries: '{count} lançamentos',
        empty: 'Nenhuma conta entre {from} e {to}.',
        emptySearch: 'Nenhuma conta encontrada para “{query}”.',
      },
      month: {
        info: '{paid} pagos de {total}',
        due: 'Venc.',
        bill: 'Conta',
        group: 'Grupo',
        value: 'Valor',
        situation: 'Situação',
        actions: 'Ações',
        noDay: 'sem dia',
        oneOff: 'pagamento avulso',
        project: 'projeto {client}',
        paidOn: 'paga em {date}',
        expected: 'previsto {value}',
        discount: 'descontar do pró-labore da {holder}',
        bills: 'Contas · {count}',
        reminders: 'Terrara · lembrete, fora do total',
        empty: 'Nenhuma conta prevista em {month}.',
        pay: 'Paga',
        payTitle: 'Registrar o pagamento',
        move: 'Mover',
        moveTitle: 'Mudar o mês desta conta',
      },
      overdue: {
        title: 'Atrasadas',
        sub_one: '{count} conta · {value} · continua no mês previsto até você marcar como paga ou mover',
        sub_other: '{count} contas · {value} · continuam no mês previsto até você marcar como paga ou mover',
        month: 'Mês previsto',
      },
      chart: { title: 'Saídas por mês', sub: 'pago e a pagar, sem os lembretes', aria: 'Saídas por mês: pago e a pagar' },
      move: { title: 'Mover conta' },
      toast: {
        status: 'Conta: {status}',
        moved: 'Conta movida para {month}',
        paid: 'Pagamento registrado',
        paidDiff: 'Pagamento registrado: {value} (previsto {expected})',
        saved: 'Conta salva',
        created: 'Despesa incluída',
        deleted: 'Conta excluída',
        deleteError: 'Não foi possível excluir',
        oneOff: 'Pagamento lançado em {month}',
        generated_one: '{count} mês lançado. Confira e salve.',
        generated_other: '{count} meses lançados. Confira e salve.',
      },
      bill: {
        name: 'Conta ou fornecedor',
        namePlaceholder: 'Ex.: Aluguel, Copel, DAS',
        group: 'Grupo',
        holder: 'Sócia',
        dueDay: 'Dia do vencimento',
        account: 'Conta bancária',
        reminder: 'Só lembrete: sem valor e fora do total',
        generate: 'Lançar meses',
        months: 'Meses',
        addMonth: 'Adicionar mês',
        month: 'Mês',
        value: 'Valor',
        paidOn: 'Paga em',
        monthAria: 'Mês {n}',
        noteAria: 'Observação do mês {n}',
        notePlaceholder: 'Observação do mês',
        valueAria: 'Valor do mês {n}',
        paidOnAria: 'Data do pagamento do mês {n}',
        situationAria: 'Situação do mês {n}',
        remove: 'Remover mês {n}',
        noMonths: 'Nenhum mês ainda. Use Lançar meses ou Adicionar mês.',
        sumTotal: 'Total:',
        reminderNote: 'Lembrete: os valores não entram no total de saídas.',
        delete: 'Excluir conta',
        errors: {
          name: 'Informe a conta ou o fornecedor',
          month: 'Confira o mês (mm/aaaa)',
          amount: 'Há mês sem valor',
          holder: 'Escolha de qual sócia é a conta pessoal',
        },
      },
      generate: {
        model: 'Modelo',
        monthly: 'Todo mês',
        installments: 'Parcelado',
        oneOff: 'Uma vez',
        from: 'De',
        to: 'Até',
        first: 'Mês da 1ª parcela',
        month: 'Mês',
        count: 'Nº de parcelas',
        amount: 'Valor',
        amountEach: 'Valor de cada parcela',
        hint: 'Os meses já pagos são mantidos; os demais a partir do mês inicial são substituídos.',
        submit: 'Lançar',
        installmentLabel: 'Parcela {i} de {n}',
        errors: {
          amount: 'Informe o valor',
          from: 'Informe o mês no formato mm/aaaa',
          to: 'O mês final precisa ser igual ou depois do inicial',
        },
      },
      payment: {
        title: 'Registrar pagamento',
        expected: 'previsto {value}',
        date: 'Data do pagamento',
        amount: 'Valor pago',
        account: 'Conta usada',
        notesPlaceholder: 'Ex.: pago com juros, desconto, nº do comprovante',
        more: 'Pago a mais que o previsto: {value}. O valor pago passa a valer nos totais; o previsto fica guardado.',
        less: 'Pago a menos que o previsto: {value}. O valor pago passa a valer nos totais; o previsto fica guardado.',
        submit: 'Registrar pagamento',
        errors: {
          date: 'Informe a data do pagamento (dd/mm/aaaa).',
          amount: 'Informe o valor pago.',
        },
      },
      oneOff: {
        title: 'Lançar pagamento avulso',
        hint: 'Para o que foi pago e não estava previsto: uma compra, um serviço pontual, um reembolso. Entra como conta paga no mês do pagamento.',
        name: 'Descrição',
        namePlaceholder: 'Fornecedor ou serviço',
        client: 'Cliente / projeto',
        clientPlaceholder: 'Cliente de um contrato ou orçamento fechado',
        saveAndNew: 'Salvar e lançar outro',
        errors: {
          name: 'Informe a descrição.',
          client: 'Escolha o cliente da lista.',
        },
      },
    },
    cashFlow: {
      title: 'Previsão do fluxo de caixa',
      hint: 'Junta o total a receber (Previsão de entradas), os saldos das contas, a caixinha e o total a pagar (Previsão de saídas) para mostrar o saldo de cada mês. Nos meses sem saldo informado, o saldo do mês anterior passa para o seguinte, como na planilha.',
      inform: 'Informar saldos',
      loading: 'Carregando o fluxo de caixa…',
      empty: 'Ainda não há meses para mostrar no fluxo de caixa.',
      saved: 'Saldos salvos',
      deleted: 'Saldos apagados',
      deleteError: 'Não foi possível apagar os saldos.',
      kpis: {
        balance: 'Saldo previsto em {month}',
        balanceMissing: 'informe os saldos do mês para calcular',
        balanceProjected: 'a partir do saldo projetado do mês anterior',
        balanceInformed: 'com os saldos informados',
        receivable: 'A receber no mês',
        receivableToConfirm: 'dos quais {value} a confirmar',
        receivableNote: 'Previsão de entradas, sem a RT',
        payable: 'A pagar no mês',
        payableNote: 'Previsão de saídas, sem a Terrara',
        firstNegative: 'Primeiro mês negativo',
        firstNegativeNote: 'saldo previsto de {value}',
        firstNegativeNone: 'nenhum',
        firstNegativeNoneNote: 'o saldo fica positivo no período',
        reserve: 'Fundo de reserva disponível',
        reserveNote: 'PJ diversos + sobra PF · {month}',
        reserveMissing: 'informe os fundos de reserva',
      },
      matrix: {
        title: 'Previsão do fluxo de caixa',
        hint: 'clique no mês para informar os saldos',
        missing: 'faltam os saldos de {month}: use Informar saldos',
        receivable: 'Total a receber',
        toConfirm: 'dos quais a confirmar',
        pf: 'Saldo no banco pessoa física',
        projected: 'projetado',
        pj: 'Saldo no banco pessoa jurídica',
        cash: 'Caixinha (dinheiro)',
        payable: 'Total a pagar',
        balance: 'Saldo do mês',
        openMonth: 'Informar os saldos de {month}',
      },
      reserves: {
        title: 'Fundos de reserva',
        hint: 'poupança PJ e aplicação PF, como no rodapé da planilha',
        pjProvision: 'Poupança – fundo de reserva PJ (provisionamento)',
        pjOther: 'Poupança – fundo de reserva PJ (diversos)',
        pjTotal: 'Total poupança pessoa jurídica',
        pfTarget: 'Fundo de reserva PF (provisionamento – deveria ter)',
        pfSurplus: 'Fundo de reserva PF (sobra)',
        pfTotal: 'Total fundo de reserva pessoa física',
        available: 'Total fundo de reserva disponível (PJ + PF)',
      },
      dialog: {
        eyebrow: 'Previsão do fluxo de caixa',
        title: 'Saldos de {month}',
        month: 'Mês',
        accounts: 'Contas e caixinha',
        reserves: 'Fundos de reserva',
        notInformed: 'não informado',
        hint: 'Deixe em branco o que não quiser informar. Sem o saldo da pessoa física, o mês usa o saldo projetado do mês anterior.',
        delete: 'Apagar os saldos deste mês',
        invalid: 'Valor inválido em {field}. Use, por exemplo, -1.234,56.',
        fields: {
          pfBalanceCents: 'Saldo no banco pessoa física',
          pjBalanceCents: 'Saldo no banco pessoa jurídica',
          cashCents: 'Caixinha (dinheiro)',
          pjReserveProvisionCents: 'Poupança – fundo de reserva PJ (provisionamento)',
          pjReserveOtherCents: 'Poupança – fundo de reserva PJ (diversos)',
          pfReserveTargetCents: 'Fundo de reserva PF (provisionamento – deveria ter)',
          pfReserveTotalCents: 'Total aplicado no fundo de reserva PF (saldo do CDB)',
        },
      },
    },
  },
  financialEntries: {
    title: 'Movimentação financeira',
    hint: 'Entradas e saídas de dinheiro nas contas PJ e PF, pelo plano de contas 2026. Ao lançar, escolha a parcela da Previsão de entradas ou a conta da Previsão de saídas para dar baixa nela.',
    newIncome: 'Lançar entrada',
    newExpense: 'Lançar saída',
    loading: 'Carregando a movimentação…',
    loadError: 'Não foi possível carregar a movimentação.',
    saveError: 'Não foi possível salvar. Tente novamente.',
    accountFilter: { aria: 'Conta', all: 'PJ e PF', PJ: 'Só PJ', PF: 'Só PF' },
    entries_one: '{count} lançamento',
    entries_other: '{count} lançamentos',
    kpis: {
      income: 'Entradas',
      expense: 'Saídas',
      result: 'Resultado do mês',
      resultNote: 'entradas menos saídas, pelas categorias; sem transferências entre contas',
      movement: 'Movimento nas contas',
      movementNote: 'entrou {income} · saiu {expense} · com transferências',
      toCheck: 'Para conferir',
      toCheckNote_one: '{count} baixa na previsão sem lançamento',
      toCheckNote_other: '{count} baixas na previsão sem lançamento',
      allChecked: 'tudo conferido',
    },
    pending: {
      title: 'Baixas na Previsão sem lançamento',
      hint: 'parcelas marcadas como recebidas ou contas pagas direto na Previsão neste mês; lance cada uma para a movimentação ficar completa',
      date: 'Data',
      item: 'Parcela ou conta',
      account: 'Conta',
      value: 'Valor',
      actions: 'Ações',
      receivable: 'Previsão de entradas · recebida',
      payable: 'Previsão de saídas · paga',
      launch: 'Lançar',
      launchTitle: 'Lançar {name} na movimentação',
    },
    table: {
      title: 'Lançamentos do mês',
      filterAria: 'Filtrar lançamentos',
      all: 'Todos {count}',
      income: 'Entradas {count}',
      expense: 'Saídas {count}',
      search: 'Buscar por descrição, categoria ou cliente',
      searchAria: 'Buscar lançamento',
      info: '{entries} · entradas {income} · saídas {expense}',
      date: 'Data',
      description: 'Descrição',
      category: 'Categoria',
      account: 'Conta',
      value: 'Valor',
      forecast: 'Previsão',
      actions: 'Ações',
      outOfResult: 'fora do resultado',
      refund: 'estorno',
      received: 'recebida',
      paid: 'paga',
      edit: 'Editar',
      editTitle: 'Editar este lançamento',
      delete: 'Excluir este lançamento',
      confirmDelete: 'Excluir?',
      confirmDeleteReopen: 'Excluir e reabrir na previsão?',
      empty: 'Nenhum lançamento em {month}. Use Lançar entrada ou Lançar saída.',
      emptyReadOnly: 'Nenhum lançamento em {month}.',
      emptySearch: 'Nenhum lançamento com essa busca.',
    },
    matrix: {
      title: 'Resultado por categoria',
      hint: 'entradas e saídas do ano pelo plano de contas, sem as transferências entre contas; clique no mês para ver os lançamentos',
      year: 'Ano',
      income: 'Entradas',
      expense: 'Saídas',
      totalIncome: 'Total de entradas',
      totalExpense: 'Total de saídas',
      result: 'Resultado',
      total: 'Total',
      noIncome: 'Nenhuma entrada no ano.',
      noExpense: 'Nenhuma saída no ano.',
      monthButton: 'Ver os lançamentos de {month}',
    },
    dialog: {
      eyebrow: 'Movimentação financeira',
      newIncome: 'Lançar entrada',
      newExpense: 'Lançar saída',
      editIncome: 'Editar entrada',
      editExpense: 'Editar saída',
      linkIncome: 'Dar baixa na Previsão de entradas',
      linkExpense: 'Dar baixa na Previsão de saídas',
      linkNone: 'Não dar baixa',
      linkPlaceholderIncome: 'Opcional: busque a parcela a receber',
      linkPlaceholderExpense: 'Opcional: busque a conta a pagar',
      linkEmptyIncome: 'Nenhuma parcela a receber em aberto',
      linkEmptyExpense: 'Nenhuma conta a pagar em aberto',
      linkSearch: 'Buscar',
      linkNoMatch: 'Nada encontrado',
      linkHintIncome: 'a parcela fica marcada como recebida na data do lançamento',
      linkHintExpense: 'a conta fica marcada como paga na data do lançamento',
      linkChosenIncome: 'Previsto {value} em {month}. A parcela fica marcada como recebida na data do lançamento.',
      linkChosenExpense: 'Previsto {value} em {month}. A conta fica marcada como paga na data do lançamento.',
      overdue: 'atrasada',
      alreadyIncome: '{name} já está recebida na Previsão; o lançamento fica ligado a ela.',
      alreadyExpense: '{name} já está paga na Previsão; o lançamento fica ligado a ela.',
      linkedIncome: 'Parcela recebida: {name} · {month}.',
      linkedExpense: 'Conta paga: {name} · {month}.',
      linkedChanges: 'Data e valor alterados aqui também mudam na Previsão.',
      date: 'Data',
      amount: 'Valor (R$)',
      amountPlaceholder: 'Ex.: 1.250,00',
      category: 'Categoria do plano de contas',
      categoryPlaceholder: 'Digite ou escolha',
      categoryHint: '{group} · DRE: {dre}',
      categoryHintOut: '{group} · DRE: {dre} · fora do resultado',
      categoryUnknown: 'Escolha uma categoria da lista do plano de contas',
      description: 'Descrição',
      descriptionIncome: 'De quem veio',
      descriptionExpense: 'Fornecedor ou serviço',
      account: 'Conta',
      method: 'Forma',
      client: 'Cliente / projeto',
      clientPlaceholder: 'Cliente da aba Contratos',
      note: 'Observação',
      saveAndNew: 'Salvar e lançar outro',
      errors: {
        date: 'Informe a data (dd/mm/aaaa).',
        amount: 'Informe o valor.',
        category: 'Escolha a categoria da lista do plano de contas.',
        description: 'Informe a descrição.',
      },
    },
    toast: {
      createdIncome: 'Entrada lançada',
      createdExpense: 'Saída lançada',
      createdIncomeSettled: 'Entrada lançada e parcela recebida na Previsão',
      createdExpenseSettled: 'Saída lançada e conta paga na Previsão',
      saved: 'Lançamento salvo',
      deleted: 'Lançamento excluído',
      deletedReopenedIncome: 'Lançamento excluído · a parcela voltou para a receber',
      deletedReopenedExpense: 'Lançamento excluído · a conta voltou para a pagar',
      deleteError: 'Não foi possível excluir o lançamento.',
    },
  },
} as const
